import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import { MdHeight, MdVideoLibrary } from 'react-icons/md';

const resources = {
  en: { //English
    translation: {
      welcome: "Hello {{name}}!",
      today: "Today is {{date}}.",
      trackingCompleted: "Well done! You have completed this week's tracking plan.",
      trackingNotCompleted: "You have not completed this week's tracking plan.",
      faqs: "Frequently Asked Questions",
      home: "Home",
      trackProgress: "Track Progress",
      progressTrack: "Progress Tracking",
      completeTracking: "Weekly Tracking Plan Completed?",
      giveFeedback: "Give Feedback?",
      weekFeedback: "Weekly Exercise Plan Feedback",
      qOne: "1. On a scale from 0 to 5, how much have you improved compared to last week?",
      qTwo: "2. On a scale from 0 to 5, how effective were the videos that were given?",
      qThree: "3. Any specific feedback?",
      cancel: "Cancel",
      submit: "Submit",
      consultations: "Consultations",
      speciality: "Speciality: ",
      location: "Location: ",
      consultationTag: "Schedule your in-person physiotherapy consultation.",
      selectDateTime: "Select Date and Time: ",
      schedule: "Schedule",
      scheduleWith: "Schedule Consultation with ",
      videoLibrary: "Video Library",
      selectCategory: "Select a category to view videos:",
      resistance: "Resistance Exercises",
      stretching: "Stretching Exercises",
      strengthening: "Strengthening Exercises",
      functional: "Functional Exercises",
      balanceNeuromuscular: "Balance & Neuromuscular Exercises",
      backCategories: "Back to Categories",
      watchVideo: "Watch Video",
      watched: "Watched",
      gFeedback: "Give Feedback",
      rate: "Rate: ",
      selectRating: "Select Rating: ",
      submitRating: "Submit Rating",
      noVideos: "No videos available for this category.",
      userProfile: "User Profile",
      editProfile: "Edit Profile",
      profilePicture: "Profile Picture: ",
      noFileChosen: "No file chosen",
      chooseFile: "Choose file",
      firstName: "First Name: ",
      lastName: "Last Name: ",
      email: "Email Address: ",
      sex: "Sex: ",
      phoneNumber: "Phone Number: ",
      enterPhone: "Enter Phone Number..",
      formattedPhone: "Formatted Phone",
      selectSex: "- Select Sex -",
      male: "Male",
      female: "Female",
      dob: "Date of Birth: ",
      height: "Height (cm): ",
      weight: "Weight (kg): ",
      country: "Country: ",
      selectCountry: "Select Country",
      selectCountryFirst: "Please select your country of residence first",
      address: "Address: ",
      searchAddress: "Search Address",
      selectedAddress: "Selected Address",
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      emailRequired: "Email is required",
      phoneNumberRequired: "Phone number is required",
      addressRequired: "Address is required",
      sexRequired: "Sex is required",
      countryRequired: "Country is required",
      dobRequired: "Date of birth is required",
      dobCorrect: "Please enter a correct date of birth",
      heightRequired: "Height is required",
      heightCorrect: "Please enter a correct height",
      weightRequired: "Weight is required",
      weightCorrect: "Please enter a correct weight",
      saveProfile: "Save Profile",
      profileSaved: "Profile saved!",
      noImage: "No Image",
      settings: "Settings",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      darkLight: "Dark Mode/Light Mode",
      language: "Language",
      notificationPreference: "Notification Preference",
      emaiL: "Email",
      phone: "Phone Number",
      both: "Both",
      login: "Login",
      register: "Register",
      firstname: "First Name",
      lastname: "Last Name",
      password: "Password: ",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      incorrectOldPassword: "Current password is incorrect.",
      passwordsDoNotMatch: "New passwords do not match.",
      invalidCredentials: "Invalid email or password",
      fillAllFields: "Please fill all fields",
      dontHaveAccount: "Don't have an account? ",
      alreadyHaveAccount: "Already have an account? ",
      registerHere: "Register here",
      loginHere: "Login here",
      messages: "Chat",
      directMessages: "Direct Messaging",
      typeYourMessage: "Type your Message..",
      you: "You",
      send: "Send",
      patient: "Patient",
      physio: "Physiotherapist",
      selectRole: "Select Role",
      reportFeedback: "Report",
      name: "Name: ",
      reportType: "Select Report Type: ",
      errorBug: "Bug/Error",
      misbehaviourAbuse: "Misbehaviour/Abuse",
      issueDescription: "Description of Issue: ",
      trackPatients: "Track Patients",
      physioProfile: "Physio Profile",
      allocation: "You are allocated to ",
      patients: " patients.",
      youHave: "You have ",
      consultationsMonth: " consultations this month.",
      slotsAvailable: " slots still available.",
      patientsTrack: "Patient Reports",
      change: "Change",
      remove: "Remove",
      addSlots: "Add Slots",
      removeSlots: "Remove Slots",
      welcomeDr: "Hello Dr. {{name}}!",
      enterSpeciality: "- Enter Speciality -",
      yearsOfExperience: "Years of Experience: ",
      yearsSinceLicensed: "Year when Licensed: ",
      enterYearOfLicense: "Enter Year Licensed Since..",
      enterYearsOfExperience: "Enter Years of Experience..",
      companyName: "Company Name: ",
      enterCompanyName: "Enter Company or Employer Name..",
      neurologicalDisorder: "Neurological Disorder",
      geriatrics: "Geriatrics",
      cardiovascularPulmonaryPhysiotherapy: "Cardiovascular and Pulmonary Physiotherapy",
      pediatricPhysiotherapy: "Pediatric Physiotherapy",
      musculoskeletalPhysiotherapy: "Musculoskeletal Physiotherapy",
      sportsPhysiotherapy: "Sports Physiotherapy",
      cardiovascularDisease: "Cardiovascular Disease",
      orthopedics: "Orthopedics",
      vestibularRehabilitation: "Vestibular Rehabilitation",
      homecarePhysiotherapy: "Homecare Physiotherapy",
      pediatrics: "Pediatrics",
      pelvicFloor: "Pelvic Floor",
      womensHealthPhysiotherapy: "Women's Health Physiotherapy",
      acupuncture: "Acupunture",
      magneticTherapy: "Magnetic Therapy",
      manualTherapy: "Manual Therapy",
      oncology: "Oncology",
      postOperativePhysiotherapist: "Post Operative Physiotherapy",
      rehabilitation: "Rehabiliation",
      chestPhysiotherapy: "Chest Physiotherapy",
      womensHealth: "Women's Health",
      pleaseAnswerAllQuestions: "Please Answer All Questions",
      physioTrackProgress: "Patient Reports",
      noReportsFound: "No Reports Found",
      question1: "Week Improvement",
      question2: "Video Satisfaction",
      specificFeedback: "Open Feedback",
      submittedAt: "Submitted at",
      logout: "Log Out",
      search: "Search",
      pSelectSpeciality: "Please select a speciality.",
      searchingWith: "Searching with:",
      consultationScheduledWith: "Consultation scheduled for: ",
      detectMyLocation: "Detect Your Location",
      pProvideLocation: "Please provide your location.",
      geolocation: "Geolocation is not supported by your browser.",
      errorLocation: "Error detecting location.",
      locationDetected: "Location detected:",
      contact: "Contact: ",
      physioFAQs: "Physio FAQ",
      patientFAQs: "Patient FAQ",
      PaQ1: "How do I register on PhysioEase?",
      PaA1: "Click the Register button on the login page, fill in your details, and you'll be able to log in with your email and password.",
      PaQ2: "How do I book an appointment?",
      PaA2: "Once logged in, go to the Consultations page, select a physiotherapist, and use the booking form to schedule an appointment.",
      PaQ3: "How do I update my profile?",
      PaA3: "Navigate to your User Profile page, make the changes, and click Save to update your information.",
      PaQ4: "Who do I contact if I have issues with the website?",
      PaA4: "Contact our support team via contact.physioease@gmail.com.",
      PhQ1: "How do I register as a physiotherapist?",
      PhA1: "Select the physiotherapist role on the registration page and complete your details. Once registered, you'll have access to the physio dashboard.",
      PhQ2: "How can I manage my appointments?",
      PhA2: "Log in and navigate to the Consultations page to view and manage your patient appointments.",
      PhQ3: "How do I communicate with patients?",
      PhA3: "Use the Direct Messages page to send and receive messages with your patients.",
      PhQ4: "Who do I contact for technical support?",
      PhA4: "For website-related issues or support, please contact our support team via contact.physioease@gmail.com.",
      footer1: "Follow PhysioEase on all Social Media Channels:",
      legalTerms: "Legal Terms",
      privacyPolicy: "Privacy Policy",
      cookies: "Cookies",
      contactUs: "Contact Us",
      scrollDown: "Scroll to Bottom",
      backToTop: "Scroll to Top",
      cookiesPolicy: "Cookies Policy",
      cookiesIntro: "As of now, this website does not use cookies to store or track your data. At PhysioEase, we respect your privacy and are committed to maintaining transparency regarding how we handle your data. Currently, PhysioEase does not use cookies to track, store, or analyse your personal information or usage behaviour. This Cookies Policy explains what cookies are, how they may be used in the future, and how you can control them.",
      futureUse: "Future Use of Cookies",
      cookiesFuture: "While we do not use cookies at this time, we may implement cookies in the future to improve functionality: Improve your user experience by remembering language or theme preferences, Maintain login sessions more efficiently, Analyse general usage patterns to improve platform performance. If cookies are introduced, we will update this policy and notify users clearly before any such use begins. You will have the opportunity to review and manage your preferences.",
      whatAreCookies: "What Are Cookies?",
      cookiesExplanation: "Cookies are small text files stored on your browser or device by websites you visit. They often contain information such as: Session identifiers, Preferences (e.g., language or layout), Analytics data (non-personally identifiable). Cookies cannot access your device or personal files, and they cannot run programs or deliver viruses.",
      yourControl: "Your Control Over Cookies",
      cookiesControl: "Should PhysioEase implement cookies in the future, you will have full control to: Accept or reject cookies through a settings interface, Adjust cookie permissions through your browser preferences, Delete cookies manually at any time. Most browsers allow you to block cookies entirely or alert you when cookies are being used. Keep in mind, disabling cookies may limit functionality on some websites.",
      contactUsMore: "If you have any questions, feel free to ",
      legalTermsTitle: "Legal Terms & Conditions",
      effectiveDate: "Effective Date: April 10, 2025",
      credits: "Credits",
      madeWith: "This webapp was created through Visual Studio Code (React JavaScript for frontend) and IntelliJ IDEA (Java for backend), with a PostgreSQL database in PgAdmin 4 and deployed through Netlify.",
      createdBy: "Created and ideated by Brunel University Year 2 CompSci - Group A13 students: Abdullah Al Jawad, Adam El Edrissi Calvo Flores, Jamil Ahmed, Md Nafiul Islam Khan, Muhammad Rohail Saleem Saleem, Mustak Kabir, Samad Adekunle Olaibi and Sharun Jeyaraman.",
      legalIntro: "Welcome to PhysioEase. By accessing or using this web application, you agree to be bound by these Terms and Conditions. Please read them carefully. If you do not agree with any part of these terms, please refrain from using the platform.",
      useOfService: "1. Use of Service",
      useDescription: "This webapp is intended to support patient and physiotherapist engagement through exercise tracking, educational content, and progress monitoring tools. The service is provided ''as is'' and intended for informational and general health guidance purposes, and for booking professional help.",
      userResponsibilities: "2. User Responsibilities",
      userTerms: "By using PhysioEase, you agree to: Provide accurate, complete, and current information when registering or updating your profile. Maintain the confidentiality of your account credentials and accept responsibility for all activity under your account. Use the platform only for lawful purposes and refrain from engaging in any activity that may compromise the integrity or security of the system or other users. Not upload, post, or share any content that is harmful, misleading, defamatory, or violates any applicable laws or third-party rights.",
      intellectualProperty: "3. Intellectual Property",
      ipNotice: "All content available on PhysioEase, including logos, brand elements, videos, text, graphics, and user interface design, is the property of PhysioEase or its licensors and is protected by applicable intellectual property laws. You may not copy, reproduce, distribute, modify, or create derivative works from any part of the platform without prior written consent. Unauthorised use of any materials on the site may violate copyright, trademark, and other laws.",
      changesToTerms: "4. Changes to Terms",
      termsChange: "PhysioEase reserves the right to update or revise these Terms and Conditions at any time. Changes will become effective immediately upon being posted on the site. Continued use of the platform after changes are made constitutes acceptance of the new terms. We recommend reviewing this page regularly to stay informed about any modifications.",
      contactClause: "5. Contact Us",
      questionsClause: "If you have any questions about these terms, please ",
      privacyPolicyTitle: "Privacy Policy",
      privacyIntro: "At PhysioEase, we value your privacy. This Privacy Policy explains how PhysioEase collects, uses, stores, and protects your personal information when you use our platform.",
      whatWeCollect: "1. What We Collect",
      basicData: "We only collect basic information you provide. When you use PhysioEase, we may collect the following types of information: Personal Information: such as your name, email, password, role (patient or physiotherapist), profile picture, phone number, sex, date of birth, height, weight, and address. Health Feedback: such as answers to weekly progress questions, tracking data, and notes submitted by users.",
      howWeUseData: "2. How We Use Your Data",
      usagePurpose: "We use your information to: Provide personalised experiences and track rehabilitation progress, Maintain secure authentication and user accounts, Improve platform functionality and usability, Communicate with you (e.g., reminders, updates, support), Comply with applicable laws and regulations.",
      dataSecurity: "3. Data Security",
      securityMeasures: "We take your data security seriously. Personal information is stored securely and only accessible to authorised personnel. Measures include: Secure HTTPS connections, Access control restrictions. Despite our efforts, no method of online transmission or storage is 100% secure. We encourage you to use strong, unique passwords and log out of your account after use.",
      yourRights: "4. Your Rights",
      rightsText: "You can access, update, or delete your data by contacting us. ",
      forRequests: "for any requests.",
      policyUpdates: "5. Updates to This Policy",
      updateNotice: "This policy may change as the platform evolves. Changes will be posted on this page and are effective upon update. We encourage you to review the policy periodically.",
      fillForm: "If you have questions, suggestions, or feedback, feel free to reach out using the form below.",
      thankYou: "Thank you for your message. We'll get back to you soon!",
      yourName: "Your Name",
      yourEmail: "Your Email",
      message: "Message",
      sendMessage: "Send Message",
      nf404: "404 — Page Not Found",
      nf404p: "The page you’re looking for doesn’t exist or has been moved.",
      nf404h: "Back to Home",
    }
  },
  af: { //Afrikaans
    translation: {
      welcome: "Hallo {{name}}!",
      today: "Vandag is {{date}}.",
      trackingCompleted: "Baie goed! Jy het hierdie week se volgplan voltooi.",
      trackingNotCompleted: "Jy het hierdie week se volgplan nie voltooi nie.",
      faqs: "Gereelde Vrae",
      home: "Tuisblad",
      trackProgress: "Volg Voortgang",
      progressTrack: "Voortgangsopsporing",
      completeTracking: "Weeklikse volgplan voltooi?",
      giveFeedback: "Gee terugvoer?",
      weekFeedback: "Weeklikse oefenplan terugvoer",
      qOne: "1. Op 'n skaal van 0 tot 5, hoe baie het jy verbeter vergeleke met verlede week?",
      qTwo: "2. Op 'n skaal van 0 tot 5, hoe doeltreffend was die video wat gegee is?",
      qThree: "3. Enige spesifieke terugvoer?",
      cancel: "Kanselleer",
      submit: "Dien in",
      consultations: "Konsultasies",
      speciality: "Spesialiteit: ",
      location: "Ligging: ",
      consultationTag: "Skeduleer jou persoonlike fisioterapie konsultasie.",
      selectDateTime: "Kies Datum en Tyd: ",
      schedule: "Skeduleer",
      scheduleWith: "Skeduleer Konsultasie met ",
      videoLibrary: "Video Biblioteek",
      selectCategory: "Kies 'n kategorie om video's te besigtig:",
      resistance: "Weerstandsoefeninge",
      stretching: "Strek oefeninge",
      strengthening: "Versterkingsoefeninge",
      functional: "Funktionele oefeninge",
      balanceNeuromuscular: "Balans en neuromuskulêre oefeninge",
      backCategories: "Terug na kategorieë",
      watchVideo: "Kyk Video",
      watched: "Bekyk",
      gFeedback: "Gee terugvoer",
      rate: "Beoordeel: ",
      selectRating: "Kies Beoordeling: ",
      submitRating: "Stuur Beoordeling",
      noVideos: "Geen video's beskikbaar vir hierdie kategorie nie.",
      userProfile: "Gebruikersprofiel",
      editProfile: "Wysig profiel",
      profilePicture: "Profielfoto: ",
      noFileChosen: "Geen lêer gekies",
      chooseFile: "Kies lêer",
      firstName: "Eerste Naam: ",
      lastName: "Van: ",
      email: "E-pos: ",
      sex: "Geslag: ",
      selectSex: "Kies Geslag",
      male: "Manlik",
      female: "Vroulik",
      dob: "Geboortedatum: ",
      height: "Hoogte (cm): ",
      weight: "Gewig (kg): ",
      firstNameRequired: "Eerste naam word vereis",
      lastNameRequired: "Van word vereis",
      emailRequired: "E-pos word vereis",
      sexRequired: "Geslag word vereis",
      dobRequired: "Geboortedatum word vereis",
      dobCorrect: "Voer asseblief 'n korrekte geboortedatum in",
      heightRequired: "Hoogte word vereis",
      heightCorrect: "Voer asseblief 'n korrekte hoogte in",
      weightRequired: "Gewig word vereis",
      weightCorrect: "Voer asseblief 'n korrekte gewig in",
      saveProfile: "Stoor Profiel",
      profileSaved: "Profiel gestoor!",
      noImage: "Geen beeld",
      settings: "Instellings",
      darkMode: "Donker modus",
      language: "Taal",
      notificationPreference: "Kennisgewing Voorkeur",
      lightMode: "Lig Modus",
      emaiL: "E-pos",
      phone: "Telefoonnommer",
      both: "Albei",
      login: "Teken in",
      register: "Registreer",
      firstname: "Voornaam",
      lastname: "Van",
      password: "Wagwoord: ",
      invalidCredentials: "Ongeldige e-pos of wagwoord",
      fillAllFields: "Vul asseblief alle velde in",
      dontHaveAccount: "Het jy nie 'n rekening nie? ",
      alreadyHaveAccount: "Het jy reeds 'n rekening? ",
      registerHere: "Registreer hier",
      loginHere: "Teken hier in",
      messages: "Klets",
      directMessages: "Direkte boodskappe",
      typeYourMessage: "Tik jou boodskap...",
      you: "Jy",
      send: "Stuur",
      patient: "Pasiënt",
      physio: "Fisioterapeut",
      selectRole: "Kies rol",
      reportFeedback: "Rapporteer",
      name: "Naam: ",
      reportType: "Kies Rapport Tipe: ",
      errorBug: "Fout/Bug",
      misbehaviourAbuse: "Ongeskikte gedrag/ Misbruik",
      issueDescription: "Beskrywing van probleem: ",
      trackPatients: "Volg pasiënts",
      physioProfile: "Fisioterapeutprofiel",
      allocation: "Jy is toegewys aan ",
      patients: " pasiënts.",
      youHave: "Jy het ",
      consultationsMonth: "konsultasies hierdie maand.",
      slotsAvailable: " plekke beskikbaar.",
      patientsTrack: "Pasiëntverslae",
      change: "Verander",
      remove: "Verwyder",
      addSlots: "Voeg plekke by",
      removeSlots: "Verwyder plekke",
      welcomeDr: "Hallo Dr. {{name}}!",
      enterSpeciality: "Voer spesialiteit in",
      yearsOfExperience: "Jare ondervinding: ",
      enterYearsOfExperience: "Voer jare ondervinding in...",
      neurologicalDisorder: "Neurologiese afwyking",
      geriatrics: "Geriatrie",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskulêre en pulmonêre fisioterapie",
      pediatricPhysiotherapy: "Pediatriese fisioterapie",
      musculoskeletalPhysiotherapy: "Muskel- en skeletfysioterapie",
      sportsPhysiotherapy: "Sportfysioterapie",
      cardiovascularDisease: "Kardiovaskulêre siekte",
      orthopedics: "Ortogedrewe",
      vestibularRehabilitation: "Vestibulêre rehabilitasie",
      homecarePhysiotherapy: "Tuisorg fisioterapie",
      pediatrics: "Pediatrie",
      pelvicFloor: "Bekkenvloer",
      womensHealthPhysiotherapy: "Vroue se gesondheidsfysioterapie",
      acupuncture: "Akupunktuur",
      magneticTherapy: "Magnetiese terapie",
      manualTherapy: "Manuele terapie",
      oncology: "Onkologie",
      postOperativePhysiotherapist: "Postoperatiewe fisioterapie",
      rehabilitation: "Rehabilitasie",
      chestPhysiotherapy: "Borsfysioterapie",
      womensHealth: "Vroue se gesondheid",
      pleaseAnswerAllQuestions: "Beantwoord asseblief alle vrae",
      physioTrackProgress: "Pasiëntverslae",
      noReportsFound: "Geen verslae gevind nie",
      question1: "Week verbetering",
      question2: "Video tevredenheid",
      specificFeedback: "Oop terugvoer",
      submittedAt: "Voorlegging by",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
      detectMyLocation: "Detect Your Location",
    }
  },
  am: { //Amharic
    translation: {
      welcome: "ሰላም {{name}}!",
      today: "ዛሬ {{date}} ነው።",
      trackingCompleted: "ጥሩ ስራ! የዚህ ሳምንት መከታተያ እቅድ ተጠናቀቀ።",
      trackingNotCompleted: "የዚህ ሳምንት መከታተያ እቅድ አልተጠናቀቀም።",
      faqs: "ተደጋጋሚ የሚጠይቁ ጥያቄዎች",
      home: "ዋና ገፅ",
      trackProgress: "እርምጃ ተከታትል",
      progressTrack: "እርምጃ ተከታትል",
      completeTracking: "የሳምንቱ እቅድ ተጠናቀቀ?",
      giveFeedback: "አስተያየት ስጥ?",
      weekFeedback: "የሳምንቱ እርምጃ እቅድ አስተያየት",
      qOne: "1. ከ0 እስከ 5 መለኪያ፣ ከባለፈው ሳምንት ጋር በተነጣጠረ መልኩ ስንት ተሻሽለህ?",
      qTwo: "2. ከ0 እስከ 5 መለኪያ፣ የተሰጡት ቪዲዮዎች ስንት ተግባራዊ ነበሩ?",
      qThree: "3. ምንም ተወላጅ አስተያየት አለ?",
      cancel: "ሰርዝ",
      submit: "አስገባ",
      consultations: "ኮንሰልቴሽኖች",
      speciality: "ስፔሻሊቲ: ",
      location: "ቦታ: ",
      consultationTag: "የፊዚዮቴራፒ ኮንሰልቴሽንዎን ይሰጡ።",
      selectDateTime: "ቀንና ሰዓት ይምረጡ: ",
      schedule: "አዘጋጅ",
      scheduleWith: "ከዚህ ጋር ኮንሰልቴሽን አዘጋጅ: ",
      videoLibrary: "ቪዲዮ ቤተ መጻሕፍት",
      selectCategory: "ለቪዲዮ ማሳያ አንድ ምድብ ይምረጡ:",
      resistance: "የተጋጠሙ እርምጃዎች",
      stretching: "የሚያስፋፋ እርምጃዎች",
      strengthening: "የሚጠናቀቁ እርምጃዎች",
      functional: "ተግባራዊ እርምጃዎች",
      balanceNeuromuscular: "የሚያስገናኝ እና የኒውሮ ስክላ እርምጃዎች",
      backCategories: "ወደ ምድቦች ተመለስ",
      watchVideo: "ቪዲዮ ተመልከት",
      watched: "ተመልከተ",
      gFeedback: "አስተያየት ስጥ",
      rate: "ውሎ: ",
      selectRating: "ውሎ ይምረጡ: ",
      submitRating: "ውሎ አስገባ",
      noVideos: "ለዚህ ምድብ ምንም ቪዲዮ የለም።",
      userProfile: "የተጠቃሚ ፕሮፋይል",
      editProfile: "ፕሮፋይል አስተካክል",
      profilePicture: "የፕሮፋይል ፎቶ: ",
      noFileChosen: "ምንም ፋይል አልተመረጠም",
      chooseFile: "ፋይል ይምረጡ",
      firstName: "የመጀመሪያ ስም: ",
      lastName: "የአያት ስም: ",
      email: "ኢሜል: ",
      sex: "ጾታ: ",
      selectSex: "ጾታ ይምረጡ",
      male: "ወንድ",
      female: "ሴት",
      dob: "የትውልድ ቀን: ",
      height: "ቁመት (cm): ",
      weight: "ክብደት (kg): ",
      firstNameRequired: "የመጀመሪያ ስም ያስፈልጋል",
      lastNameRequired: "የአያት ስም ያስፈልጋል",
      emailRequired: "ኢሜል ያስፈልጋል",
      sexRequired: "ጾታ ያስፈልጋል",
      dobRequired: "የትውልድ ቀን ያስፈልጋል",
      dobCorrect: "እባክዎ ትክክለኛ የትውልድ ቀን ያስገቡ",
      heightRequired: "ቁመት ያስፈልጋል",
      heightCorrect: "እባክዎ ትክክለኛ ቁመት ያስገቡ",
      weightRequired: "ክብደት ያስፈልጋል",
      weightCorrect: "እባክዎ ትክክለኛ ክብደት ያስገቡ",
      saveProfile: "ፕሮፋይል ያስቀምጡ",
      profileSaved: "ፕሮፋይል ተያይዞ ነው!",
      noImage: "ምንም ምስል የለም",
      settings: "ቅንብሮች",
      darkMode: "ጨለማ ሁኔታ",
      language: "ቋንቋ",
      notificationPreference: "ማሳወቂያ ፍላጎት",
      lightMode: "ብርሀን ሞድ",
      emaiL: "ኢሜይል",
      phone: "ስልክ ቁጥር",
      both: "ሁለቱም",
      login: "መግባት",
      register: "ምዝገባ",
      firstname: "የመጀመሪያ ስም",
      lastname: "የመጨረሻ ስም",
      password: "ፓስወርድ: ",
      invalidCredentials: "የተሳሳተ ኢሜይል ወይም ፓስወርድ",
      fillAllFields: "እባክዎ ሁሉንም ቦታ ይሙሉ",
      dontHaveAccount: "አካውንት የለዎትም? ",
      alreadyHaveAccount: "አካውንት አለዎት? ",
      registerHere: "እዚህ ይመዝገቡ",
      loginHere: "እዚህ ይግቡ",
      messages: "መልእክቶች",
      directMessages: "ቀጥታ መልእክት",
      typeYourMessage: "መልእክትዎን ያስተካክሉ...",
      you: "እርስዎ",
      send: "ላክ",
      patient: "ታካሚ",
      physio: "ፊዚዮተራፒስት",
      selectRole: "የሚና ይምረጡ",
      reportFeedback: "ሪፖርት",
      name: "ስም: ",
      reportType: "የሪፖርት አይነት ይምረጡ: ",
      errorBug: "ስህተት/ባግ",
      misbehaviourAbuse: "የተሳሳተ ባህሪ/ጥቃት",
      issueDescription: "የችግኝ መግለጫ: ",
      trackPatients: "ታካሚዎችን ተከታትሉ",
      physioProfile: "ፊዚዮ ፕሮፋይል",
      allocation: "ተመድቦ ለ: ",
      patients: " ታካሚዎች።",
      youHave: "አለዎት: ",
      consultationsMonth: " ምክር ቦታዎች በዚህ ወር",
      slotsAvailable: " ቦታዎች አሉ",
      patientsTrack: "የታካሚ ሪፖርቶች",
      change: "ቀይር",
      remove: "አስወግድ",
      addSlots: "ቦታዎች ያክሉ",
      removeSlots: "ቦታዎች አስወግድ",
      welcomeDr: "ሰላም ዶ/ር {{name}}!",
      enterSpeciality: "ስፔሻሊቲ ያስገቡ",
      yearsOfExperience: "የተሞክሮ ዓመታት: ",
      enterYearsOfExperience: "የተሞክሮ ዓመታት ያስገቡ...",
      neurologicalDisorder: "ኒሩሎጂካል ችግኝ",
      geriatrics: "ጄሪያትሪክስ",
      cardiovascularPulmonaryPhysiotherapy: "ካርዲዮቫስኩላር እና ፑልሞናሪ ፊዚዮተራፒ",
      pediatricPhysiotherapy: "ፒዲያትሪክ ፊዚዮተራፒ",
      musculoskeletalPhysiotherapy: "ሙስኩላርእና ስኬላር ፊዚዮተራፒ",
      sportsPhysiotherapy: "ስፖርትስ ፊዚዮተራፒ",
      cardiovascularDisease: "ካርዲዮቫስኩላር በሽታ",
      orthopedics: "ኦርቶፒዲክስ",
      vestibularRehabilitation: "ቬስቲብላር ሪሀቢሊቲንግ",
      homecarePhysiotherapy: "ሆምኬር ፊዚዮተራፒ",
      pediatrics: "ፒዲያትሪክስ",
      pelvicFloor: "ፔልቪክ ፍሎር",
      womensHealthPhysiotherapy: "የሴቶች ጤና ፊዚዮተራፒ",
      acupuncture: "አኩፕንክቸር",
      magneticTherapy: "ማግኔቲክ ሰነድ",
      manualTherapy: "ማኑዋል ፊዚዮተራፒ",
      oncology: "ኦንኮሎጂ",
      postOperativePhysiotherapist: "የኦፕሬሽን በኋላ ፊዚዮተራፒ",
      rehabilitation: "ሪሀቢሊቲንግ",
      chestPhysiotherapy: "የደረቅ ፊዚዮተራፒ",
      womensHealth: "የሴቶች ጤና",
      pleaseAnswerAllQuestions: "እባክዎ ሁሉንም ጥያቄዎች ይመልሱ",
      physioTrackProgress: "የታካሚ ሪፖርቶች",
      noReportsFound: "ሪፖርት አልተገኘም",
      question1: "የሳምንቱ ልምድ ማሻሻያ",
      question2: "የቪዲዮ እርግጠኝነት",
      specificFeedback: "ክፍተት አስተያየት",
      submittedAt: "በተላከበት ጊዜ",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ar: { //Modern Standard Arabic
    translation: {
      welcome: "مرحباً {{name}}",
      today: ".اليوم هو {{date}}",
      trackingCompleted: "أحسنت! لقد أنجزت خطة المتابعة لهذا الأسبوع",
      trackingNotCompleted: "لم تُكمل خطة المتابعة لهذا الأسبوع",
      faqs: "الأسئلة المتكررة",
      home: "الرئيسية",
      trackProgress: "تتبع التقدم",
      progressTrack: "متابعة التقدم",
      completeTracking: "هل أكملت خطة المتابعة الأسبوعية؟",
      giveFeedback: "هل ترغب في تقديم ملاحظات؟",
      weekFeedback: "ملاحظات خطة التمرين الأسبوعية",
      qOne: "على مقياس من 0 إلى 5، إلى أي مدى تحسنت مقارنة بالأسبوع الماضي؟",
      qTwo: "على مقياس من 0 إلى 5، ما مدى فعالية الفيديوهات المقدمة؟",
      qThree: "هل لديك أي ملاحظات محددة؟",
      cancel: "إلغاء",
      submit: "إرسال",
      consultations: "الاستشارات",
      speciality: "التخصص",
      location: "الموقع: ",
      consultationTag: "حدد موعد استشارتك الشخصية للعلاج الطبيعي",
      selectDateTime: "اختر التاريخ والوقت",
      schedule: "جدولة",
      scheduleWith: "حدد موعد الاستشارة مع",
      videoLibrary: "مكتبة الفيديو",
      selectCategory: "اختر فئة لعرض الفيديوهات",
      resistance: "تمارين المقاومة",
      stretching: "تمارين الإطالة",
      strengthening: "تمارين التقوية",
      functional: "تمارين وظيفية",
      balanceNeuromuscular: "تمارين التوازن والعصبية العضلية",
      backCategories: "العودة إلى الفئات",
      watchVideo: "شاهد الفيديو",
      watched: "تمت المشاهدة",
      gFeedback: "أعطِ ملاحظات",
      rate: "التقييم",
      selectRating: "اختر التقييم",
      submitRating: "إرسال التقييم",
      noVideos: "لا توجد فيديوهات متاحة لهذه الفئة",
      userProfile: "الملف الشخصي",
      editProfile: "تعديل الملف الشخصي",
      profilePicture: "صورة الملف الشخصي",
      noFileChosen: "لم يتم اختيار أي ملف",
      chooseFile: "اختر ملف",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "البريد الإلكتروني",
      sex: "الجنس",
      selectSex: "اختر الجنس",
      male: "ذكر",
      female: "أنثى",
      dob: "تاريخ الميلاد: ",
      height: "الطول (سم)",
      weight: "الوزن (كجم)",
      firstNameRequired: "الاسم الأول مطلوب",
      lastNameRequired: "اسم العائلة مطلوب",
      emailRequired: "البريد الإلكتروني مطلوب",
      sexRequired: "الجنس مطلوب",
      dobRequired: "تاريخ الميلاد مطلوب",
      dobCorrect: "يرجى إدخال تاريخ ميلاد صحيح",
      heightRequired: "الطول مطلوب",
      heightCorrect: "يرجى إدخال طول صحيح",
      weightRequired: "الوزن مطلوب",
      weightCorrect: "يرجى إدخال وزن صحيح",
      saveProfile: "حفظ الملف الشخصي",
      profileSaved: "تم حفظ الملف الشخصي!",
      noImage: "لا صورة",
      settings: "الإعدادات",
      darkMode: "الوضع الداكن",
      language: "اللغة",
      notificationPreference: "تفضيل الإشعارات",
      lightMode: "الوضع الفاتح",
      emaiL: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      both: "كلاهما",
      login: "تسجيل الدخول",
      register: "التسجيل",
      firstname: "الاسم الأول",
      lastname: "اسم العائلة",
      password: "كلمة المرور: ",
      invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      fillAllFields: "يرجى ملء جميع الحقول",
      dontHaveAccount: "ليس لديك حساب؟ ",
      alreadyHaveAccount: "هل لديك حساب بالفعل؟ ",
      registerHere: "سجل هنا",
      loginHere: "سجل الدخول هنا",
      messages: "الدردشة",
      directMessages: "المراسلة المباشرة",
      typeYourMessage: "اكتب رسالتك...",
      you: "أنت",
      send: "أرسل",
      patient: "مريض",
      physio: "أخصائي علاج طبيعي",
      selectRole: "اختر الدور",
      reportFeedback: "الإبلاغ",
      name: "الاسم: ",
      reportType: "اختر نوع التقرير: ",
      errorBug: "خطأ/خلل",
      misbehaviourAbuse: "سوء السلوك/الإساءة",
      issueDescription: "وصف المشكلة: ",
      trackPatients: "تتبع المرضى",
      physioProfile: "ملف الأخصائي",
      allocation: "تم تخصيصك لـ",
      patients: " مرضى.",
      youHave: "لديك",
      consultationsMonth: " استشارات هذا الشهر.",
      slotsAvailable: " أماكن متاحة",
      patientsTrack: "تقارير المرضى",
      change: "تغيير",
      remove: "إزالة",
      addSlots: "إضافة أماكن",
      removeSlots: "إزالة الأماكن",
      welcomeDr: "مرحباً د. {{name}}!",
      enterSpeciality: "أدخل التخصص",
      yearsOfExperience: "سنوات الخبرة: ",
      enterYearsOfExperience: "أدخل سنوات الخبرة...",
      neurologicalDisorder: "اضطراب عصبي",
      geriatrics: "طب الشيخوخة",
      cardiovascularPulmonaryPhysiotherapy: "العلاج الطبيعي القلبي الرئوي",
      pediatricPhysiotherapy: "العلاج الطبيعي للأطفال",
      musculoskeletalPhysiotherapy: "العلاج الطبيعي العضلي الهيكلي",
      sportsPhysiotherapy: "العلاج الطبيعي الرياضي",
      cardiovascularDisease: "مرض قلبي وعائي",
      orthopedics: "جراحة العظام",
      vestibularRehabilitation: "إعادة تأهيل الدهليزي",
      homecarePhysiotherapy: "العلاج الطبيعي المنزلي",
      pediatrics: "طب الأطفال",
      pelvicFloor: "أرضية الحوض",
      womensHealthPhysiotherapy: "العلاج الطبيعي لصحة المرأة",
      acupuncture: "الوخز بالإبر",
      magneticTherapy: "العلاج المغناطيسي",
      manualTherapy: "العلاج اليدوي",
      oncology: "علم الأورام",
      postOperativePhysiotherapist: "أخصائي العلاج الطبيعي بعد العملية",
      rehabilitation: "إعادة التأهيل",
      chestPhysiotherapy: "العلاج الطبيعي الصدري",
      womensHealth: "صحة المرأة",
      pleaseAnswerAllQuestions: "يرجى الإجابة على جميع الأسئلة",
      physioTrackProgress: "تقارير المرضى",
      noReportsFound: "لم يتم العثور على تقارير",
      question1: "تحسن الأسبوع",
      question2: "رضا الفيديو",
      specificFeedback: "تعليقات مفتوحة",
      submittedAt: "تم الإرسال في",
      logout: "Log Out",
      phoneNumber: "Phone Number ",
    }
  },
  bg: { //Bulgarian
    translation: {
      welcome: "Здравей, {{name}}!",
      today: "Днес е {{date}}",
      trackingCompleted: "Браво! Завършихте плана за проследяване за тази седмица.",
      trackingNotCompleted: "Не сте завършили плана за проследяване за тази седмица.",
      faqs: "Често задавани въпроси",
      home: "Начало",
      trackProgress: "Проследи напредъка",
      progressTrack: "Проследяване на напредъка",
      completeTracking: "Завършен ли е седмичният план за проследяване?",
      giveFeedback: "Дайте обратна връзка?",
      weekFeedback: "Обратна връзка за седмичния тренировъчен план",
      qOne: "1. По скала от 0 до 5, до каква степен сте се подобрили в сравнение с миналата седмица?",
      qTwo: "2. По скала от 0 до 5, колко ефективни бяха предоставените видеа?",
      qThree: "3. Някакви конкретни коментари?",
      cancel: "Отказ",
      submit: "Изпрати",
      consultations: "Консултации",
      speciality: "Специалност: ",
      location: "Местоположение: ",
      consultationTag: "Насрочете вашата лична физиотерапевтична консултация.",
      selectDateTime: "Изберете дата и час: ",
      schedule: "Насрочи",
      scheduleWith: "Насрочи консултация с ",
      videoLibrary: "Видео библиотека",
      selectCategory: "Изберете категория за преглед на видеа:",
      resistance: "Упражнения с тежести",
      stretching: "Разтягания",
      strengthening: "Упражнения за заздравяване",
      functional: "Функционални упражнения",
      balanceNeuromuscular: "Упражнения за баланс и невромускулна координация",
      backCategories: "Обратно към категориите",
      watchVideo: "Гледай видео",
      watched: "Гледано",
      gFeedback: "Дайте обратна връзка",
      rate: "Оцени: ",
      selectRating: "Избери оценка: ",
      submitRating: "Изпрати оценка",
      noVideos: "Няма налични видеа за тази категория.",
      userProfile: "Профил на потребителя",
      editProfile: "Редактирай профила",
      profilePicture: "Снимка на профила: ",
      noFileChosen: "Няма избран файл",
      chooseFile: "Избери файл",
      firstName: "Име: ",
      lastName: "Фамилия: ",
      email: "Имейл: ",
      sex: "Пол: ",
      selectSex: "Избери пол",
      male: "Мъжки",
      female: "Женски",
      dob: "Дата на раждане: ",
      height: "Височина (cm): ",
      weight: "Тегло (kg): ",
      firstNameRequired: "Името е задължително",
      lastNameRequired: "Фамилията е задължителна",
      emailRequired: "Имейлът е задължителен",
      sexRequired: "Полът е задължителен",
      dobRequired: "Датата на раждане е задължителна",
      dobCorrect: "Моля, въведете правилна дата на раждане",
      heightRequired: "Височината е задължителна",
      heightCorrect: "Моля, въведете правилна височина",
      weightRequired: "Теглото е задължително",
      weightCorrect: "Моля, въведете правилно тегло",
      saveProfile: "Запази профила",
      profileSaved: "Профилът е запазен!",
      noImage: "Няма изображение",
      settings: "Настройки",
      darkMode: "Тъмен режим",
      language: "Език",
      notificationPreference: "Предпочитания за известия",
      lightMode: "Светъл режим",
      emaiL: "Имейл",
      phone: "Телефонен номер",
      both: "И двете",
      login: "Вход",
      register: "Регистрация",
      firstname: "Име",
      lastname: "Фамилия",
      password: "Парола: ",
      invalidCredentials: "Невалиден имейл или парола",
      fillAllFields: "Моля, попълнете всички полета",
      dontHaveAccount: "Нямате акаунт? ",
      alreadyHaveAccount: "Вече имате акаунт? ",
      registerHere: "Регистрирайте се тук",
      loginHere: "Влезте тук",
      messages: "Чат",
      directMessages: "Директни съобщения",
      typeYourMessage: "Напишете вашето съобщение...",
      you: "Вие",
      send: "Изпрати",
      patient: "Пациент",
      physio: "Физиотерапевт",
      selectRole: "Изберете роля",
      reportFeedback: "Доклад",
      name: "Име: ",
      reportType: "Изберете тип доклад: ",
      errorBug: "Грешка/Бъг",
      misbehaviourAbuse: "Неподходящо поведение/Злоупотреба",
      issueDescription: "Описание на проблема: ",
      trackPatients: "Проследяване на пациенти",
      physioProfile: "Профил на физиотерапевт",
      allocation: "Вие сте определени към ",
      patients: " пациенти.",
      youHave: "Имате ",
      consultationsMonth: " консултации този месец.",
      slotsAvailable: " свободни места",
      patientsTrack: "Доклади на пациенти",
      change: "Промени",
      remove: "Премахни",
      addSlots: "Добави места",
      removeSlots: "Премахни места",
      welcomeDr: "Здравейте д-р {{name}}!",
      enterSpeciality: "Въведете специалност",
      yearsOfExperience: "Години опит: ",
      enterYearsOfExperience: "Въведете години опит...",
      neurologicalDisorder: "Неврологично разстройство",
      geriatrics: "Гериатрия",
      cardiovascularPulmonaryPhysiotherapy: "Кардиоваскуларна и пулмонална физиотерапия",
      pediatricPhysiotherapy: "Педиатрична физиотерапия",
      musculoskeletalPhysiotherapy: "Мускулно-скелетна физиотерапия",
      sportsPhysiotherapy: "Спортна физиотерапия",
      cardiovascularDisease: "Кардиоваскуларно заболяване",
      orthopedics: "Ортопедия",
      vestibularRehabilitation: "Вестибуларна рехабилитация",
      homecarePhysiotherapy: "Домашна физиотерапия",
      pediatrics: "Педиатрия",
      pelvicFloor: "Тазово дъно",
      womensHealthPhysiotherapy: "Физиотерапия за здравето на жените",
      acupuncture: "Акупунктура",
      magneticTherapy: "Магнитна терапия",
      manualTherapy: "Ръчна терапия",
      oncology: "Онкология",
      postOperativePhysiotherapist: "Физиотерапевт след операция",
      rehabilitation: "Рехабилитация",
      chestPhysiotherapy: "Гръдна физиотерапия",
      womensHealth: "Здравето на жените",
      pleaseAnswerAllQuestions: "Моля, отговорете на всички въпроси",
      physioTrackProgress: "Доклади на пациенти",
      noReportsFound: "Няма намерени доклади",
      question1: "Седмично подобрение",
      question2: "Удовлетвореност от видеото",
      specificFeedback: "Отворена обратна връзка",
      submittedAt: "Изпратено на",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  bn: { //Bengali/Bangla
    translation: {
      welcome: "হ্যালো {{name}}!",
      today: "আজ {{date}}.",
      trackingCompleted: "ভাল কাজ! আপনি এই সপ্তাহের ট্র্যাকিং পরিকল্পনা সম্পন্ন করেছেন।",
      trackingNotCompleted: "আপনি এই সপ্তাহের ট্র্যাকিং পরিকল্পনা সম্পন্ন করেননি।",
      faqs: "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী",
      home: "হোম",
      trackProgress: "প্রগতি ট্র্যাক করুন",
      progressTrack: "প্রগতি ট্র্যাকিং",
      completeTracking: "সাপ্তাহিক ট্র্যাকিং পরিকল্পনা সম্পন্ন করেছেন?",
      giveFeedback: "মতামত দিন?",
      weekFeedback: "সাপ্তাহিক ব্যায়াম পরিকল্পনার মতামত",
      qOne: "১. 0 থেকে 5-এর মধ্যে, গত সপ্তাহের তুলনায় আপনার কতটা উন্নতি হয়েছে?",
      qTwo: "২. 0 থেকে 5-এর মধ্যে, প্রদত্ত ভিডিওগুলির কার্যকারিতা কেমন ছিল?",
      qThree: "৩. কোনো নির্দিষ্ট মতামত আছে?",
      cancel: "বাতিল করুন",
      submit: "জমা দিন",
      consultations: "পরামর্শ",
      speciality: "বিশেষত্ব: ",
      location: "অবস্থান: ",
      consultationTag: "আপনার ব্যক্তিগত ফিজিওথেরাপি পরামর্শ নির্ধারণ করুন।",
      selectDateTime: "তারিখ এবং সময় নির্বাচন করুন: ",
      schedule: "তৈরি করুন",
      scheduleWith: "এর সাথে পরামর্শ নির্ধারণ করুন: ",
      videoLibrary: "ভিডিও লাইব্রেরি",
      selectCategory: "ভিডিও দেখার জন্য একটি বিভাগ নির্বাচন করুন:",
      resistance: "প্রতিরোধ ব্যায়াম",
      stretching: "স্ট্রেচিং ব্যায়াম",
      strengthening: "শক্তি বৃদ্ধির ব্যায়াম",
      functional: "কার্যকরী ব্যায়াম",
      balanceNeuromuscular: "সামঞ্জস্য এবং নিউরোমাসকুলার ব্যায়াম",
      backCategories: "বিভাগে ফিরে যান",
      watchVideo: "ভিডিও দেখুন",
      watched: "দেখা হয়েছে",
      gFeedback: "মতামত দিন",
      rate: "রেট: ",
      selectRating: "রেটিং নির্বাচন করুন: ",
      submitRating: "রেটিং জমা দিন",
      noVideos: "এই বিভাগের জন্য কোনো ভিডিও পাওয়া যায়নি।",
      userProfile: "ব্যবহারকারীর প্রোফাইল",
      editProfile: "প্রোফাইল সম্পাদনা করুন",
      profilePicture: "প্রোফাইল ছবি: ",
      noFileChosen: "কোনো ফাইল নির্বাচিত হয়নি",
      chooseFile: "ফাইলটি নির্বাচন করুন",
      firstName: "নামের প্রথম অংশ: ",
      lastName: "শেষের নাম: ",
      email: "ইমেইল: ",
      sex: "লিঙ্গ: ",
      selectSex: "লিঙ্গ নির্বাচন করুন",
      male: "পুরুষ",
      female: "নারী",
      dob: "জন্ম তারিখ: ",
      height: "উচ্চতা (সেমি): ",
      weight: "ওজন (কেজি): ",
      firstNameRequired: "নামের প্রথম অংশ প্রয়োজন",
      lastNameRequired: "শেষের নাম প্রয়োজন",
      emailRequired: "ইমেইল প্রয়োজন",
      sexRequired: "লিঙ্গ প্রয়োজন",
      dobRequired: "জন্ম তারিখ প্রয়োজন",
      dobCorrect: "সঠিক জন্ম তারিখ প্রবেশ করুন",
      heightRequired: "উচ্চতা প্রয়োজন",
      heightCorrect: "সঠিক উচ্চতা প্রবেশ করুন",
      weightRequired: "ওজন প্রয়োজন",
      weightCorrect: "সঠিক ওজন প্রবেশ করুন",
      saveProfile: "প্রোফাইল সংরক্ষণ করুন",
      profileSaved: "প্রোফাইল সংরক্ষিত হয়েছে!",
      noImage: "কোনো ছবি নেই",
      settings: "সেটিংস",
      darkMode: "ডার্ক মোড",
      language: "ভাষা",
      notificationPreference: "নোটিফিকেশন পছন্দ",
      lightMode: "হালকা মোড",
      emaiL: "ইমেইল",
      phone: "ফোন নম্বর",
      both: "উভয়",
      login: "লগ ইন",
      register: "নিবন্ধন করুন",
      firstname: "প্রথম নাম",
      lastname: "শেষ নাম",
      password: "পাসওয়ার্ড: ",
      invalidCredentials: "অবৈধ ইমেইল বা পাসওয়ার্ড",
      fillAllFields: "অনুগ্রহ করে সব ফিল্ড পূরণ করুন",
      dontHaveAccount: "একাউন্ট নেই? ",
      alreadyHaveAccount: "আগেই একাউন্ট আছে? ",
      registerHere: "এখানে নিবন্ধন করুন",
      loginHere: "এখানে লগ ইন করুন",
      messages: "চ্যাট",
      directMessages: "ডাইরেক্ট ম্যাসেজিং",
      typeYourMessage: "আপনার বার্তা টাইপ করুন...",
      you: "আপনি",
      send: "পাঠান",
      patient: "রোগী",
      physio: "ফিজিওথেরাপিস্ট",
      selectRole: "ভূমিকা নির্বাচন করুন",
      reportFeedback: "রিপোর্ট করুন",
      name: "নাম: ",
      reportType: "রিপোর্টের ধরন নির্বাচন করুন: ",
      errorBug: "বাগ/ত্রুটি",
      misbehaviourAbuse: "অশালীন আচরণ/নির্যাতন",
      issueDescription: "সমস্যার বর্ণনা: ",
      trackPatients: "রোগীদের ট্র্যাক করুন",
      physioProfile: "ফিজিও প্রোফাইল",
      allocation: "আপনাকে বরাদ্দ করা হয়েছে ",
      patients: " রোগী।",
      youHave: "আপনার আছে ",
      consultationsMonth: " এই মাসে পরামর্শ",
      slotsAvailable: " স্লট উপলব্ধ",
      patientsTrack: "রোগী রিপোর্ট",
      change: "পরিবর্তন করুন",
      remove: "মুছে ফেলুন",
      addSlots: "স্লট যোগ করুন",
      removeSlots: "স্লট মুছে ফেলুন",
      welcomeDr: "হ্যালো ডঃ {{name}}!",
      enterSpeciality: "বিশেষত্ব প্রবেশ করুন",
      yearsOfExperience: "অভিজ্ঞতার বছর: ",
      enterYearsOfExperience: "অভিজ্ঞতার বছর প্রবেশ করুন...",
      neurologicalDisorder: "স্নায়ুবিষয়ক ব্যাধি",
      geriatrics: "বয়স্ক রোগ",
      cardiovascularPulmonaryPhysiotherapy: "হৃদরোগ ও ফুসফুসের ফিজিওথেরাপি",
      pediatricPhysiotherapy: "শিশু ফিজিওথেরাপি",
      musculoskeletalPhysiotherapy: "মাস্কুলোস্কেলেটাল ফিজিওথেরাপি",
      sportsPhysiotherapy: "ক্রীড়া ফিজিওথেরাপি",
      cardiovascularDisease: "হৃদরোগ",
      orthopedics: "অর্থোপেডিক্স",
      vestibularRehabilitation: "ভেস্টিবুলার পুনর্বাসন",
      homecarePhysiotherapy: "হোম কেয়ার ফিজিওথেরাপি",
      pediatrics: "শিশু চিকিৎসা",
      pelvicFloor: "পেলভিক ফ্লোর",
      womensHealthPhysiotherapy: "মহিলাদের স্বাস্থ্য ফিজিওথেরাপি",
      acupuncture: "একুপাংচার",
      magneticTherapy: "চুম্বক থেরাপি",
      manualTherapy: "ম্যানুয়াল থেরাপি",
      oncology: "অঙ্কোলজি",
      postOperativePhysiotherapist: "অপারেশনের পর ফিজিওথেরাপিস্ট",
      rehabilitation: "পুনর্বাসন",
      chestPhysiotherapy: "বুকের ফিজিওথেরাপি",
      womensHealth: "মহিলাদের স্বাস্থ্য",
      pleaseAnswerAllQuestions: "অনুগ্রহ করে সব প্রশ্নের উত্তর দিন",
      physioTrackProgress: "রোগী রিপোর্ট",
      noReportsFound: "কোন রিপোর্ট পাওয়া যায়নি",
      question1: "সপ্তাহের উন্নতি",
      question2: "ভিডিও সন্তুষ্টি",
      specificFeedback: "খোলামেলা প্রতিক্রিয়া",
      submittedAt: "জমা দেওয়ার সময়",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ca: { //Catalan
    translation: {
      welcome: "Hola {{name}}!",
      today: "Avui és {{date}}.",
      trackingCompleted: "¡Molt bé! Has completat el pla de seguimient d'aquesta setmana.",
      trackingNotCompleted: "Encara no has completat el pla de seguimient d'aquesta setmana.",
      faqs: "Preguntes Freqüents",
      home: "Inici",
      trackProgress: "Seguir Progrés",
      progressTrack: "Siguiment de Progrés",
      completeTracking: "Pla de seguiment setmanal completat?",
      giveFeedback: "Aportar comentaris?",
      weekFeedback: "Formulari del Pla de Seguimient de la Setmana",
      qOne: "1. Del 0 al 5, quant has millorat des de la setmana pasada?",
      qTwo: "2. Del 0 al 5, com d'efectiu van ser els vídeos que se'ls van donar?",
      qThree: "3. Algun comentari específic?",
      cancel: "Cancel·lar",
      submit: "Enviar",
      consultations: "Consultes",
      speciality: "Especialitat: ",
      location: "Ubicació: ",
      consultationTag: "Programa la teva consulta fisioterapèutica presencial.",
      selectDateTime: "Selecciona Data i Hora: ",
      scheduleWith: "Programa la teva Consulta amb ",
      schedule: "Programar",
      videoLibrary: "Biblioteca de Vídeos",
      selectCategory: "Selecciona una categoria per veure vídeos:",
      resistance: "Exercicis de Resistència",
      stretching: "Exercicis d'Estirament",
      strengthening: "Exercicis de Enfortiment",
      functional: "Exercicis Funcionals",
      balanceNeuromuscular: "Exercicis de Equilibri y Neuromusculars",
      backCategories: "Tornar a Categorías",
      watchVideo: "Veure Vídeo",
      watched: "Vist",
      gFeedback: "Donar Qualificació",
      rate: "Qualificar: ",
      selectRating: "Seleccionar Nota: ",
      submitRating: "Enviar Qualificació",
      noVideos: "No hi ha vídeos disponibles per a aquesta categoria.",
      userProfile: "Perfil d'Usuari",
      editProfile: "Editar Perfil",
      profilePicture: "Foto de Perfil: ",
      chooseFile: "Triar un fitxer",
      noFileChosen: "Ningú fitxer seleccionat",
      firstName: "Nom: ",
      lastName: "Cognom(s): ",
      email: "Email: ",
      sex: "Sexe: ",
      selectSex: "Triar Sexe",
      male: "Masculí",
      female: "Femení",
      dob: "Data de Naixement: ",
      height: "Altura (cm): ",
      weight: "Pes (kg): ",
      firstNameRequired: "Nom és requerit",
      lastNameRequired: "Cognom és requerit",
      emailRequired: "Email és requerit",
      sexRequired: "Sexe és requerit",
      dobRequired: "Data de naixement es requerit",
      dobCorrect: "Si us plau entre una data de naixement correcta",
      heightRequired: "Altura és requerit",
      heightCorrect: "Si us plau entre una altura correcta",    
      weightRequired: "Pes és requerit",
      weightCorrect: "Si us plau entre un peso correcto",
      saveProfile: "Guardar Perfil",
      profileSaved: "Perfil Guardat!",
      noImage: "Sense Imatge",
      settings: "Configuració",
      darkMode: "Mode Fosc",
      language: "Llengua",
      notificationPreference: "Preferència de notificacions",
      lightMode: "Mode clar",
      emaiL: "Correu electrònic",
      phone: "Número de telèfon",
      both: "Tots dos",
      login: "Inicia sessió",
      register: "Registra't",
      firstname: "Nom",
      lastname: "Cognom",
      password: "Contrasenya: ",
      invalidCredentials: "Correu electrònic o contrasenya invàlids",
      fillAllFields: "Si us plau, omple tots els camps",
      dontHaveAccount: "No tens compte? ",
      alreadyHaveAccount: "Ja tens compte? ",
      registerHere: "Registra't aquí",
      loginHere: "Inicia sessió aquí",
      messages: "Xat",
      directMessages: "Missatgeria directa",
      typeYourMessage: "Escriu el teu missatge...",
      you: "Tu",
      send: "Envia",
      patient: "Pacient",
      physio: "Fisioterapeuta",
      selectRole: "Selecciona rol",
      reportFeedback: "Informa",
      name: "Nom: ",
      reportType: "Selecciona el tipus d'informe: ",
      errorBug: "Error/Bug",
      misbehaviourAbuse: "Mals comportaments/Abús",
      issueDescription: "Descripció del problema: ",
      trackPatients: "Segueix els pacients",
      physioProfile: "Perfil del fisioterapeuta",
      allocation: "Estàs assignat a ",
      patients: " pacients.",
      youHave: "Tens ",
      consultationsMonth: " consultes aquest mes.",
      slotsAvailable: " places encara disponibles.",
      patientsTrack: "Informes dels pacients",
      change: "Canvia",
      remove: "Elimina",
      addSlots: "Afegeix places",
      removeSlots: "Elimina places",
      welcomeDr: "Hola Dr. {{name}}!",
      enterSpeciality: "Introdueix la especialitat",
      yearsOfExperience: "Anys d'experiència: ",
      enterYearsOfExperience: "Introdueix els anys d'experiència...",
      neurologicalDisorder: "Trastorn neurològic",
      geriatrics: "Geriatria",
      cardiovascularPulmonaryPhysiotherapy: "Fisioteràpia cardiovascular i pulmonar",
      pediatricPhysiotherapy: "Fisioteràpia pediàtrica",
      musculoskeletalPhysiotherapy: "Fisioteràpia múscul-esquelètica",
      sportsPhysiotherapy: "Fisioteràpia esportiva",
      cardiovascularDisease: "Malaltia cardiovascular",
      orthopedics: "Ortopèdia",
      vestibularRehabilitation: "Rehabilitació vestibular",
      homecarePhysiotherapy: "Fisioteràpia a domicili",
      pediatrics: "Pediatria",
      pelvicFloor: "Sòl pèlvic",
      womensHealthPhysiotherapy: "Fisioteràpia per a la salut de les dones",
      acupuncture: "Acupuntura",
      magneticTherapy: "Teràpia magnètica",
      manualTherapy: "Teràpia manual",
      oncology: "Oncologia",
      postOperativePhysiotherapist: "Fisioterapeuta postoperatori",
      rehabilitation: "Rehabilitació",
      chestPhysiotherapy: "Fisioteràpia toràcica",
      womensHealth: "Salut de les dones",
      pleaseAnswerAllQuestions: "Si us plau, responeu a totes les preguntes",
      physioTrackProgress: "Informes dels pacients",
      noReportsFound: "No s'han trobat informes",
      question1: "Millora setmanal",
      question2: "Satisfacció amb el vídeo",
      specificFeedback: "Feedback obert",
      submittedAt: "Enviat a",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  cs: { //Czech
    translation: {
      welcome: "Ahoj {{name}}!",
      today: "Dnes je {{date}}.",
      trackingCompleted: "Výborně! Dokončili jste tento týdenní plán sledování.",
      trackingNotCompleted: "Tento týdenní plán sledování jste nedokončili.",
      faqs: "Často kladené otázky",
      home: "Domů",
      trackProgress: "Sleduj pokrok",
      progressTrack: "Sledování pokroku",
      completeTracking: "Byl dokončen týdenní plán sledování?",
      giveFeedback: "Dejte zpětnou vazbu?",
      weekFeedback: "Zpětná vazba k týdennímu tréninkovému plánu",
      qOne: "1. Na stupnici od 0 do 5, o kolik jste se zlepšili ve srovnání s minulým týdnem?",
      qTwo: "2. Na stupnici od 0 do 5, jak efektivní byly poskytnuté videa?",
      qThree: "3. Máte nějakou konkrétní zpětnou vazbu?",
      cancel: "Zrušit",
      submit: "Odeslat",
      consultations: "Konzultace",
      speciality: "Specializace: ",
      location: "Lokalita: ",
      consultationTag: "Naplánujte si osobní konzultaci s fyzioterapeutem.",
      selectDateTime: "Vyberte datum a čas: ",
      schedule: "Naplánovat",
      scheduleWith: "Naplánovat konzultaci s ",
      videoLibrary: "Video knihovna",
      selectCategory: "Vyberte kategorii pro zobrazení videí:",
      resistance: "Cvičení s odporem",
      stretching: "Protahovací cvičení",
      strengthening: "Posilovací cvičení",
      functional: "Funkční cvičení",
      balanceNeuromuscular: "Cvičení na rovnováhu a neuromuskulární koordinaci",
      backCategories: "Zpět ke kategoriím",
      watchVideo: "Sleduj video",
      watched: "Sledováno",
      gFeedback: "Dejte zpětnou vazbu",
      rate: "Hodnoť: ",
      selectRating: "Vyberte hodnocení: ",
      submitRating: "Odeslat hodnocení",
      noVideos: "Pro tuto kategorii nejsou k dispozici žádná videa.",
      userProfile: "Uživatelský profil",
      editProfile: "Upravit profil",
      profilePicture: "Profilová fotka: ",
      noFileChosen: "Není vybrán žádný soubor",
      chooseFile: "Vybrat soubor",
      firstName: "Křestní jméno: ",
      lastName: "Příjmení: ",
      email: "Email: ",
      sex: "Pohlaví: ",
      selectSex: "Vyberte pohlaví",
      male: "Muž",
      female: "Žena",
      dob: "Datum narození: ",
      height: "Výška (cm): ",
      weight: "Hmotnost (kg): ",
      firstNameRequired: "Křestní jméno je povinné",
      lastNameRequired: "Příjmení je povinné",
      emailRequired: "Email je povinný",
      sexRequired: "Pohlaví je povinné",
      dobRequired: "Datum narození je povinné",
      dobCorrect: "Zadejte prosím správné datum narození",
      heightRequired: "Výška je povinná",
      heightCorrect: "Zadejte prosím správnou výšku",
      weightRequired: "Hmotnost je povinná",
      weightCorrect: "Zadejte prosím správnou hmotnost",
      saveProfile: "Uložit profil",
      profileSaved: "Profil uložen!",
      noImage: "Žádný obrázek",
      settings: "Nastavení",
      darkMode: "Tmavý režim",
      language: "Jazyk",
      notificationPreference: "Předvolby oznámení",
      lightMode: "Světlý režim",
      emaiL: "Email",
      phone: "Telefonní číslo",
      both: "Obojí",
      login: "Přihlásit se",
      register: "Registrovat se",
      firstname: "Křestní jméno",
      lastname: "Příjmení",
      password: "Heslo: ",
      invalidCredentials: "Neplatný email nebo heslo",
      fillAllFields: "Prosím, vyplňte všechna pole",
      dontHaveAccount: "Nemáte účet? ",
      alreadyHaveAccount: "Už máte účet? ",
      registerHere: "Zaregistrujte se zde",
      loginHere: "Přihlaste se zde",
      messages: "Chat",
      directMessages: "Přímá zpráva",
      typeYourMessage: "Napište svou zprávu...",
      you: "Vy",
      send: "Odeslat",
      patient: "Pacient",
      physio: "Fyzioterapeut",
      selectRole: "Vyberte roli",
      reportFeedback: "Nahlásit",
      name: "Jméno: ",
      reportType: "Vyberte typ hlášení: ",
      errorBug: "Chyba/Bug",
      misbehaviourAbuse: "Špatné chování/Missbruk",
      issueDescription: "Popis problému: ",
      trackPatients: "Sledovat pacienty",
      physioProfile: "Profil fyzioterapeuta",
      allocation: "Jste přiděleni k ",
      patients: " pacientům.",
      youHave: "Máte ",
      consultationsMonth: " konzultací tento měsíc.",
      slotsAvailable: " volných míst",
      patientsTrack: "Hlášení pacientů",
      change: "Změnit",
      remove: "Odstranit",
      addSlots: "Přidat místa",
      removeSlots: "Odstranit místa",
      welcomeDr: "Dobrý den, Dr. {{name}}!",
      enterSpeciality: "Zadejte specializaci",
      yearsOfExperience: "Roky praxe: ",
      enterYearsOfExperience: "Zadejte roky praxe...",
      neurologicalDisorder: "Neurologická porucha",
      geriatrics: "Geriatrie",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskulární a plicní fyzioterapie",
      pediatricPhysiotherapy: "Dětská fyzioterapie",
      musculoskeletalPhysiotherapy: "Muskuloskeletální fyzioterapie",
      sportsPhysiotherapy: "Sportovní fyzioterapie",
      cardiovascularDisease: "Kardiovaskulární nemoc",
      orthopedics: "Ortopedie",
      vestibularRehabilitation: "Vestibulární rehabilitace",
      homecarePhysiotherapy: "Fyzioterapie doma",
      pediatrics: "Pediatrie",
      pelvicFloor: "Pánevní dno",
      womensHealthPhysiotherapy: "Fyzioterapie pro zdraví žen",
      acupuncture: "Akupunktura",
      magneticTherapy: "Magnetoterapie",
      manualTherapy: "Manuální terapie",
      oncology: "Onkologie",
      postOperativePhysiotherapist: "Fyzioterapeut po operaci",
      rehabilitation: "Rehabilitace",
      chestPhysiotherapy: "Prsní fyzioterapie",
      womensHealth: "Zdraví žen",
      pleaseAnswerAllQuestions: "Prosím, odpovězte na všechny otázky",
      physioTrackProgress: "Hlášení pacientů",
      noReportsFound: "Nebyla nalezena žádná hlášení",
      question1: "Týdenní zlepšení",
      question2: "Spokojenost s videem",
      specificFeedback: "Otevřená zpětná vazba",
      submittedAt: "Odesláno v",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  cy: { //Welsh
    translation: {
      welcome: "Helo {{name}}!",
      today: "Heddiw yw {{date}}.",
      trackingCompleted: "Da iawn! Rydych wedi cwblhau cynllun dilyn yr wythnos hon.",
      trackingNotCompleted: "Nid ydych wedi cwblhau cynllun dilyn yr wythnos hon.",
      faqs: "Cwestiynau a Aderyn Eu Cyffredin",
      home: "Hafan",
      trackProgress: "Dilyn Cynnydd",
      progressTrack: "Cynnyddoldeb",
      completeTracking: "A yw cynllun dilyn yr wythnos wedi'i gwblhau?",
      giveFeedback: "Rhoi adborth?",
      weekFeedback: "Adborth ar Gynllun Ymarfer yr Wythnos",
      qOne: "1. Ar graddfa o 0 i 5, pa mor gwell ydych wedi gwella o gymharu â'r wythnos diwethaf?",
      qTwo: "2. Ar graddfa o 0 i 5, pa mor effeithiol oedd y fideos a roddwyd?",
      qThree: "3. A oes gennych unrhyw adborth penodol?",
      cancel: "Canslo",
      submit: "Cyflwyno",
      consultations: "Ymgynghoriadau",
      speciality: "Arbenigedd: ",
      location: "Lleoliad: ",
      consultationTag: "Trefnwch eich ymgynghoriad physiotherapy personol.",
      selectDateTime: "Dewiswch Dyddiad a Amser: ",
      schedule: "Trefnu",
      scheduleWith: "Trefnu Ymgynghoriad gyda ",
      videoLibrary: "Llyfrfarchnad Fideo",
      selectCategory: "Dewiswch gategori i weld fideos:",
      resistance: "Ymarferion Atal",
      stretching: "Ymarferion Estyn",
      strengthening: "Ymarferion Cryfhau",
      functional: "Ymarferion Swyddogaethol",
      balanceNeuromuscular: "Ymarferion Cydbwyso a Neuromusclegol",
      backCategories: "Yn ôl i Gategori",
      watchVideo: "Gweld Fideo",
      watched: "Wedi ei wylio",
      gFeedback: "Rhoi Adborth",
      rate: "Gwerthuso: ",
      selectRating: "Dewiswch Raddfa: ",
      submitRating: "Cyflwyno Raddfa",
      noVideos: "Dim fideos ar gael ar gyfer y categori hon.",
      userProfile: "Proffil Defnyddiwr",
      editProfile: "Golygu Proffil",
      profilePicture: "Llun Proffil: ",
      noFileChosen: "Dim ffeil wedi'i ddewis",
      chooseFile: "Dewiswch ffeil",
      firstName: "Enw Cyntaf: ",
      lastName: "Cyfenw: ",
      email: "E-bost: ",
      sex: "Rhyw: ",
      selectSex: "Dewiswch Rhyw",
      male: "Gwrywaidd",
      female: "Benywaidd",
      dob: "Dyddiad Geni: ",
      height: "Uchder (cm): ",
      weight: "Pwysau (kg): ",
      firstNameRequired: "Mae angen enw cyntaf",
      lastNameRequired: "Mae angen cyfenw",
      emailRequired: "Mae angen e-bost",
      sexRequired: "Mae angen dewis rhyw",
      dobRequired: "Mae angen dyddiad geni",
      dobCorrect: "Nodwch ddyddiad geni cywir os gwelwch yn dda",
      heightRequired: "Mae angen uchder",
      heightCorrect: "Nodwch uchder cywir os gwelwch yn dda",
      weightRequired: "Mae angen pwysau",
      weightCorrect: "Nodwch bwysau cywir os gwelwch yn dda",
      saveProfile: "Cadw Proffil",
      profileSaved: "Wedi cadw proffil!",
      noImage: "Dim Llun",
      settings: "Gosodiadau",
      darkMode: "Modd Tywyll",
      language: "Iaith",
      notificationPreference: "Dewis Rhybuddion",
      lightMode: "Modd Golau",
      emaiL: "E-bost",
      phone: "Rhif Ffôn",
      both: "Dau o'r ddau",
      login: "Mewngofnodi",
      register: "Cofrestru",
      firstname: "Enw Cynnar",
      lastname: "Cyfenw",
      password: "Cyfrinair: ",
      invalidCredentials: "E-bost neu gyfrinair annilys",
      fillAllFields: "Llenwch bob maes os gwelwch yn dda",
      dontHaveAccount: "Does dim cyfrif gennych? ",
      alreadyHaveAccount: "Mae gennych gyfrif yn barod? ",
      registerHere: "Cofrestrwch yma",
      loginHere: "Mewngofnodwch yma",
      messages: "Sgwrs",
      directMessages: "Negeseuon Uniongyrchol",
      typeYourMessage: "Rhowch eich neges...",
      you: "Chi",
      send: "Anfon",
      patient: "Clinigol",
      physio: "Ffisiotherapeutaidd",
      selectRole: "Dewiswch Rôl",
      reportFeedback: "Adrodd",
      name: "Enw: ",
      reportType: "Dewiswch Dyrfa Adrodd: ",
      errorBug: "Gwall/Bwsg",
      misbehaviourAbuse: "Ymddygiad amhriodol/ Cam-drin",
      issueDescription: "Disgrifiad o'r mater: ",
      trackPatients: "Olrhain Clinigolion",
      physioProfile: "Proffil Ffisiotherapeutaidd",
      allocation: "Rhoir chi i ",
      patients: " clinigolion.",
      youHave: "Mae gennych ",
      consultationsMonth: " ymgynghoriadau y mis hwn.",
      slotsAvailable: " lleoliadau ar gael",
      patientsTrack: "Adroddiadau cleifion",
      change: "Newid",
      remove: "Tynnu",
      addSlots: "Ychwanegu Lleoliadau",
      removeSlots: "Tynnu Lleoliadau",
      welcomeDr: "Helo Dr. {{name}}!",
      enterSpeciality: "Rhowch Arbenigedd",
      yearsOfExperience: "Blwyddynau o Brofiad: ",
      enterYearsOfExperience: "Rhowch flynyddoedd o brofiad...",
      neurologicalDisorder: "Anhwylder niwrolegol",
      geriatrics: "Geriatrig",
      cardiovascularPulmonaryPhysiotherapy: "Ffisiotherapi Galwminol a Pulmonol",
      pediatricPhysiotherapy: "Ffisiotherapi plant",
      musculoskeletalPhysiotherapy: "Ffisiotherapi cyhyrol-astegol",
      sportsPhysiotherapy: "Ffisiotherapi chwaraeon",
      cardiovascularDisease: "Clefyd galwminol",
      orthopedics: "Ortopedeg",
      vestibularRehabilitation: "Ailafiaethu vestibwlarydd",
      homecarePhysiotherapy: "Ffisiotherapi cartref",
      pediatrics: "Plant",
      pelvicFloor: "Llaw ffelydd",
      womensHealthPhysiotherapy: "Ffisiotherapi iechyd menywod",
      acupuncture: "Acupuncture",
      magneticTherapy: "Therapi magnetig",
      manualTherapy: "Therapi llaw",
      oncology: "Oncoleg",
      postOperativePhysiotherapist: "Ffisiotherapeutaeth ar ôl gweithred",
      rehabilitation: "Ailafiaethu",
      chestPhysiotherapy: "Ffisiotherapi brên",
      womensHealth: "Iechyd menywod",
      pleaseAnswerAllQuestions: "Atebwch bob cwestiwn os gwelwch yn dda",
      physioTrackProgress: "Adroddiadau cleifion",
      noReportsFound: "Heb ddod o hyd i adroddiadau",
      question1: "Gwelliant wythnosol",
      question2: "Cytundeb fideo",
      specificFeedback: "Adborth agored",
      submittedAt: "Cyflwynwyd ar",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  da: { //Danish
    translation: {
      welcome: "Hej {{name}}!",
      today: "I dag er det {{date}}.",
      trackingCompleted: "Godt klaret! Du har fuldført denne uges sporingsplan.",
      trackingNotCompleted: "Du har ikke fuldført denne uges sporingsplan.",
      faqs: "Ofte Stillede Spørgsmål",
      home: "Hjem",
      trackProgress: "Følg Fremskridt",
      progressTrack: "Fremskridtssporing",
      completeTracking: "Er den ugentlige sporingsplan fuldført?",
      giveFeedback: "Giv Feedback?",
      weekFeedback: "Feedback på Ugentligt Træningsplan",
      qOne: "1. På en skala fra 0 til 5, hvor meget er du forbedret i forhold til sidste uge?",
      qTwo: "2. På en skala fra 0 til 5, hvor effektiv var den viste video?",
      qThree: "3. Eventuelle specifikke kommentarer?",
      cancel: "Annuller",
      submit: "Indsend",
      consultations: "Konsultationer",
      speciality: "Specialitet: ",
      location: "Placering: ",
      consultationTag: "Planlæg din personlige fysioterapikonsultation.",
      selectDateTime: "Vælg Dato og Tid: ",
      schedule: "Planlæg",
      scheduleWith: "Planlæg konsultation med ",
      videoLibrary: "Videobibliotek",
      selectCategory: "Vælg en kategori for at se videoer:",
      resistance: "Modstandsøvelser",
      stretching: "Strækøvelser",
      strengthening: "Styrkeøvelser",
      functional: "Funktionelle Øvelser",
      balanceNeuromuscular: "Balance- & Neuromuskulære Øvelser",
      backCategories: "Tilbage til Kategorier",
      watchVideo: "Se Video",
      watched: "Set",
      gFeedback: "Giv Feedback",
      rate: "Bedøm: ",
      selectRating: "Vælg Bedømmelse: ",
      submitRating: "Indsend Bedømmelse",
      noVideos: "Ingen videoer tilgængelige for denne kategori.",
      userProfile: "Brugerprofil",
      editProfile: "Rediger Profil",
      profilePicture: "Profilbillede: ",
      noFileChosen: "Ingen fil valgt",
      chooseFile: "Vælg fil",
      firstName: "Fornavn: ",
      lastName: "Efternavn: ",
      email: "Email: ",
      sex: "Køn: ",
      selectSex: "Vælg Køn",
      male: "Mand",
      female: "Kvinde",
      dob: "Fødselsdato: ",
      height: "Højde (cm): ",
      weight: "Vægt (kg): ",
      firstNameRequired: "Fornavn er påkrævet",
      lastNameRequired: "Efternavn er påkrævet",
      emailRequired: "Email er påkrævet",
      sexRequired: "Køn er påkrævet",
      dobRequired: "Fødselsdato er påkrævet",
      dobCorrect: "Indtast venligst en korrekt fødselsdato",
      heightRequired: "Højde er påkrævet",
      heightCorrect: "Indtast venligst en korrekt højde",
      weightRequired: "Vægt er påkrævet",
      weightCorrect: "Indtast venligst en korrekt vægt",
      saveProfile: "Gem Profil",
      profileSaved: "Profil gemt!",
      noImage: "Intet billede",
      settings: "Indstillinger",
      darkMode: "Mørk Tilstand",
      language: "Sprog",
      notificationPreference: "Notifikationspræference",
      lightMode: "Lys tilstand",
      emaiL: "Email",
      phone: "Telefonnummer",
      both: "Begge",
      login: "Log ind",
      register: "Registrer",
      firstname: "Fornavn",
      lastname: "Efternavn",
      password: "Adgangskode: ",
      invalidCredentials: "Ugyldig email eller adgangskode",
      fillAllFields: "Udfyld venligst alle felter",
      dontHaveAccount: "Har du ikke en konto? ",
      alreadyHaveAccount: "Har du allerede en konto? ",
      registerHere: "Registrer her",
      loginHere: "Log ind her",
      messages: "Chat",
      directMessages: "Direkte beskeder",
      typeYourMessage: "Skriv din besked...",
      you: "Du",
      send: "Send",
      patient: "Patient",
      physio: "Fysioterapeut",
      selectRole: "Vælg rolle",
      reportFeedback: "Rapportér",
      name: "Navn: ",
      reportType: "Vælg rapporttype: ",
      errorBug: "Fejl/Bug",
      misbehaviourAbuse: "Misbrug/adfærd",
      issueDescription: "Beskrivelse af problemet: ",
      trackPatients: "Spor patienter",
      physioProfile: "Fysioprofil",
      allocation: "Du er tildelt ",
      patients: " patienter.",
      youHave: "Du har ",
      consultationsMonth: " konsultationer denne måned.",
      slotsAvailable: " pladser tilgængelige.",
      patientsTrack: "Patientrapporter",
      change: "Skift",
      remove: "Fjern",
      addSlots: "Tilføj pladser",
      removeSlots: "Fjern pladser",
      welcomeDr: "Hej Dr. {{name}}!",
      enterSpeciality: "Indtast specialitet",
      yearsOfExperience: "År med erfaring: ",
      enterYearsOfExperience: "Indtast antal års erfaring...",
      neurologicalDisorder: "Neurologisk lidelse",
      geriatrics: "Geriatri",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskulær og pulmonal fysioterapi",
      pediatricPhysiotherapy: "Pædiatrisk fysioterapi",
      musculoskeletalPhysiotherapy: "Muskuloskeletal fysioterapi",
      sportsPhysiotherapy: "Sportsfysioterapi",
      cardiovascularDisease: "Kardiovaskulær sygdom",
      orthopedics: "Ortopædi",
      vestibularRehabilitation: "Vestibulær rehabilitering",
      homecarePhysiotherapy: "Physioterapi til hjemmepleje",
      pediatrics: "Pædiatri",
      pelvicFloor: "Bækkenbund",
      womensHealthPhysiotherapy: "Fysioterapi for kvinders sundhed",
      acupuncture: "Akupunktur",
      magneticTherapy: "Magnetisk terapi",
      manualTherapy: "Manuel terapi",
      oncology: "Onkologi",
      postOperativePhysiotherapist: "Postoperativ fysioterapeut",
      rehabilitation: "Rehabilitering",
      chestPhysiotherapy: "Brystfysioterapi",
      womensHealth: "Kvinders sundhed",
      pleaseAnswerAllQuestions: "Besvar venligst alle spørgsmål",
      physioTrackProgress: "Patientrapporter",
      noReportsFound: "Ingen rapporter fundet",
      question1: "Ugentlig forbedring",
      question2: "Video tilfredshed",
      specificFeedback: "Åben feedback",
      submittedAt: "Indsendt kl",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  de: { //German
    translation: {
      welcome: "Hallo {{name}}!",
      today: "Heute ist {{date}}.",
      trackingCompleted: "Gut gemacht! Sie haben den Tracking-Plan für diese Woche abgeschlossen.",
      trackingNotCompleted: "Sie haben den Trackingplan für diese Woche nicht abgeschlossen.",
      faqs: "Häufig gestellte Fragen",
      home: "Startseite",
      trackProgress: "Fortschritt Verfolgen",
      progressTrack: "Fortschrittsüberwachung",
      completeTracking: "Hast du den wöchentlichen Tracking-Plan abgeschlossen?",
      giveFeedback: "Feedback geben?",
      weekFeedback: "Feedback zum wöchentlichen Trainingsplan",
      qOne: "1. Auf einer Skala von 0 bis 5, wie sehr hast du dich im Vergleich zur letzten Woche verbessert?",
      qTwo: "2. Auf einer Skala von 0 bis 5, wie effektiv waren die bereitgestellten Videos?",
      qThree: "3. Irgendwelches spezifisches Feedback?",
      cancel: "Abbrechen",
      submit: "Absenden",
      consultations: "Konsultationen",
      speciality: "Fachgebiet: ",
      location: "Ort: ",
      consultationTag: "Vereinbare deinen persönlichen Physiotherapie-Termin.",
      selectDateTime: "Datum und Uhrzeit auswählen: ",
      schedule: "Planen",
      scheduleWith: "Vereinbare einen Termin mit ",
      videoLibrary: "Videothek",
      selectCategory: "Wähle eine Kategorie, um Videos anzusehen:",
      resistance: "Kraftübungen",
      stretching: "Dehnübungen",
      strengthening: "Kräftigungsübungen",
      functional: "Funktionelle Übungen",
      balanceNeuromuscular: "Balance- und neuromuskuläre Übungen",
      backCategories: "Zurück zu den Kategorien",
      watchVideo: "Video ansehen",
      watched: "Angesehen",
      gFeedback: "Feedback geben",
      rate: "Bewertung: ",
      selectRating: "Wähle eine Bewertung: ",
      submitRating: "Bewertung absenden",
      noVideos: "Für diese Kategorie sind keine Videos verfügbar.",
      userProfile: "Benutzerprofil",
      editProfile: "Profil Bearbeiten",
      profilePicture: "Profilbild: ",
      noFileChosen: "Keine Datei ausgewählt",
      chooseFile: "Datei auswählen",
      firstName: "Vorname: ",
      lastName: "Nachname: ",
      email: "E-Mail: ",
      sex: "Geschlecht: ",
      selectSex: "Geschlecht auswählen",
      male: "Männlich",
      female: "Weiblich",
      dob: "Geburtsdatum: ",
      height: "Größe (cm): ",
      weight: "Gewicht (kg): ",
      firstNameRequired: "Vorname ist erforderlich",
      lastNameRequired: "Nachname ist erforderlich",
      emailRequired: "E-Mail ist erforderlich",
      sexRequired: "Geschlecht ist erforderlich",
      dobRequired: "Geburtsdatum ist erforderlich",
      dobCorrect: "Bitte geben Sie ein korrektes Geburtsdatum ein",
      heightRequired: "Größe ist erforderlich",
      heightCorrect: "Bitte geben Sie eine korrekte Größe ein",
      weightRequired: "Gewicht ist erforderlich",
      weightCorrect: "Bitte geben Sie ein korrektes Gewicht ein",
      saveProfile: "Profil speichern",
      profileSaved: "Profil gespeichert!",
      noImage: "Kein Bild",
      settings: "Einstellungen",
      darkMode: "Dunkler Modus",
      language: "Sprache",
      notificationPreference: "Benachrichtigungspräferenz",
      lightMode: "Heller Modus",
      emaiL: "E-Mail",
      phone: "Telefonnummer",
      both: "Beide",
      login: "Anmelden",
      register: "Registrieren",
      firstname: "Vorname",
      lastname: "Nachname",
      password: "Passwort: ",
      invalidCredentials: "Ungültige E-Mail oder Passwort",
      fillAllFields: "Bitte füllen Sie alle Felder aus",
      dontHaveAccount: "Sie haben noch kein Konto? ",
      alreadyHaveAccount: "Sie haben bereits ein Konto? ",
      registerHere: "Hier registrieren",
      loginHere: "Hier anmelden",
      messages: "Chat",
      directMessages: "Direktnachrichten",
      typeYourMessage: "Geben Sie Ihre Nachricht ein...",
      you: "Sie",
      send: "Senden",
      patient: "Patient",
      physio: "Physiotherapeut",
      selectRole: "Rolle auswählen",
      reportFeedback: "Bericht erstatten",
      name: "Name: ",
      reportType: "Berichtstyp auswählen: ",
      errorBug: "Fehler/Bug",
      misbehaviourAbuse: "Fehlverhalten/Missbrauch",
      issueDescription: "Problembeschreibung: ",
      trackPatients: "Patienten verfolgen",
      physioProfile: "Physioprofil",
      allocation: "Sie sind zugeteilt zu ",
      patients: " Patienten.",
      youHave: "Sie haben ",
      consultationsMonth: " Konsultationen in diesem Monat.",
      slotsAvailable: " Plätze verfügbar.",
      patientsTrack: "Patientenberichte",
      change: "Ändern",
      remove: "Entfernen",
      addSlots: "Plätze hinzufügen",
      removeSlots: "Plätze entfernen",
      welcomeDr: "Hallo Dr. {{name}}!",
      enterSpeciality: "Fachgebiet eingeben",
      yearsOfExperience: "Jahre Erfahrung: ",
      enterYearsOfExperience: "Geben Sie die Jahre Erfahrung ein...",
      neurologicalDisorder: "Neurologische Störung",
      geriatrics: "Geriatrie",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskuläre und pulmonale Physiotherapie",
      pediatricPhysiotherapy: "Pädiatrische Physiotherapie",
      musculoskeletalPhysiotherapy: "Muskuloskelettale Physiotherapie",
      sportsPhysiotherapy: "Sportphysiotherapie",
      cardiovascularDisease: "Herz-Kreislauf-Erkrankung",
      orthopedics: "Orthopädie",
      vestibularRehabilitation: "Vestibuläre Rehabilitation",
      homecarePhysiotherapy: "Physiotherapie für die häusliche Pflege",
      pediatrics: "Pädiatrie",
      pelvicFloor: "Beckenboden",
      womensHealthPhysiotherapy: "Physiotherapie für Frauengesundheit",
      acupuncture: "Akupunktur",
      magneticTherapy: "Magnettherapie",
      manualTherapy: "Manuelle Therapie",
      oncology: "Onkologie",
      postOperativePhysiotherapist: "Postoperative Physiotherapie",
      rehabilitation: "Rehabilitation",
      chestPhysiotherapy: "Brustphysiotherapie",
      womensHealth: "Frauengesundheit",
      pleaseAnswerAllQuestions: "Bitte beantworten Sie alle Fragen",
      physioTrackProgress: "Patientenberichte",
      noReportsFound: "Keine Berichte gefunden",
      question1: "Wöchentliche Verbesserung",
      question2: "Videobezufriedenheit",
      specificFeedback: "Offenes Feedback",
      submittedAt: "Eingereicht am",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  el: { //Greek
    translation: {
      welcome: "Γεια σου, {{name}}!",
      today: "Σήμερα είναι {{date}}.",
      trackingCompleted: "Μπράβο! Ολοκλήρωσες το πρόγραμμα παρακολούθησης αυτής της εβδομάδας.",
      trackingNotCompleted: "Δεν ολοκλήρωσες το πρόγραμμα παρακολούθησης αυτής της εβδομάδας.",
      faqs: "Συχνές Ερωτήσεις",
      home: "Αρχική",
      trackProgress: "Παρακολούθησε την Πρόοδο",
      progressTrack: "Παρακολούθηση Προόδου",
      completeTracking: "Ολοκληρώθηκε το εβδομαδιαίο πρόγραμμα παρακολούθησης;",
      giveFeedback: "Δώσε Ανατροφοδότηση;",
      weekFeedback: "Ανατροφοδότηση για το Εβδομαδιαίο Πρόγραμμα Άσκησης",
      qOne: "1. Σε μια κλίμακα από 0 έως 5, πόσο έχεις βελτιωθεί σε σύγκριση με την προηγούμενη εβδομάδα;",
      qTwo: "2. Σε μια κλίμακα από 0 έως 5, πόσο αποτελεσματικά ήταν τα βίντεο που παρασχέθηκαν;",
      qThree: "3. Οποιαδήποτε συγκεκριμένα σχόλια;",
      cancel: "Ακύρωση",
      submit: "Υποβολή",
      consultations: "Συμβουλές",
      speciality: "Ειδικότητα: ",
      location: "Τοποθεσία: ",
      consultationTag: "Προγραμμάτισε τη δια ζώσης φυσιοθεραπεία σου.",
      selectDateTime: "Επιλογή Ημερομηνίας και Ώρας: ",
      schedule: "Προγραμμάτισε",
      scheduleWith: "Προγραμμάτισε Συνάντηση με ",
      videoLibrary: "Βιβλιοθήκη Βίντεο",
      selectCategory: "Επιλογή κατηγορίας για προβολή βίντεο:",
      resistance: "Ασκήσεις Αντίστασης",
      stretching: "Ασκήσεις Διατάσεων",
      strengthening: "Ασκήσεις Ενδυνάμωσης",
      functional: "Λειτουργικές Ασκήσεις",
      balanceNeuromuscular: "Ασκήσεις Ισορροπίας & Νευρομυϊκής Συντονισμού",
      backCategories: "Επιστροφή στις Κατηγορίες",
      watchVideo: "Παρακολούθησε το Βίντεο",
      watched: "Παρακολουθήθηκε",
      gFeedback: "Δώσε Ανατροφοδότηση",
      rate: "Βαθμολόγησε: ",
      selectRating: "Επίλεξε Βαθμολογία: ",
      submitRating: "Υποβολή Βαθμολογίας",
      noVideos: "Δεν υπάρχουν διαθέσιμα βίντεο για αυτήν την κατηγορία.",
      userProfile: "Προφίλ Χρήστη",
      editProfile: "Επεξεργασία Προφίλ",
      profilePicture: "Εικόνα Προφίλ: ",
      noFileChosen: "Κανένα αρχείο δεν επιλέχθηκε",
      chooseFile: "Επιλογή αρχείου",
      firstName: "Όνομα: ",
      lastName: "Επώνυμο: ",
      email: "Email: ",
      sex: "Φύλο: ",
      selectSex: "Επιλέξτε Φύλο",
      male: "Άνδρας",
      female: "Γυναίκα",
      dob: "Ημερομηνία Γέννησης: ",
      height: "Ύψος (cm): ",
      weight: "Βάρος (kg): ",
      firstNameRequired: "Το όνομα είναι υποχρεωτικό",
      lastNameRequired: "Το επώνυμο είναι υποχρεωτικό",
      emailRequired: "Το email είναι υποχρεωτικό",
      sexRequired: "Το φύλο είναι υποχρεωτικό",
      dobRequired: "Η ημερομηνία γέννησης είναι υποχρεωτική",
      dobCorrect: "Παρακαλώ εισάγετε μια σωστή ημερομηνία γέννησης",
      heightRequired: "Το ύψος είναι υποχρεωτικό",
      heightCorrect: "Παρακαλώ εισάγετε ένα σωστό ύψος",
      weightRequired: "Το βάρος είναι υποχρεωτικό",
      weightCorrect: "Παρακαλώ εισάγετε ένα σωστό βάρος",
      saveProfile: "Αποθήκευση Προφίλ",
      profileSaved: "Το προφίλ αποθηκεύτηκε!",
      noImage: "Καμία εικόνα",
      settings: "Ρυθμίσεις",
      darkMode: "Σκοτεινή Λειτουργία",
      language: "Γλώσσα",
      notificationPreference: "Προτίμηση ειδοποιήσεων",
      lightMode: "Φωτεινή λειτουργία",
      emaiL: "Ηλεκτρονικό ταχυδρομείο",
      phone: "Αριθμός τηλεφώνου",
      both: "Και τα δύο",
      login: "Σύνδεση",
      register: "Εγγραφή",
      firstname: "Όνομα",
      lastname: "Επώνυμο",
      password: "Κωδικός: ",
      invalidCredentials: "Μη έγκυρο email ή κωδικός",
      fillAllFields: "Παρακαλώ συμπληρώστε όλα τα πεδία",
      dontHaveAccount: "Δεν έχετε λογαριασμό; ",
      alreadyHaveAccount: "Έχετε ήδη λογαριασμό; ",
      registerHere: "Εγγραφείτε εδώ",
      loginHere: "Συνδεθείτε εδώ",
      messages: "Μηνύματα",
      directMessages: "Άμεσα μηνύματα",
      typeYourMessage: "Πληκτρολογήστε το μήνυμά σας...",
      you: "Εσείς",
      send: "Αποστολή",
      patient: "Ασθενής",
      physio: "Φυσιοθεραπευτής",
      selectRole: "Επιλέξτε ρόλο",
      reportFeedback: "Αναφορά",
      name: "Όνομα: ",
      reportType: "Επιλέξτε τύπο αναφοράς: ",
      errorBug: "Σφάλμα/Βλάβη",
      misbehaviourAbuse: "Κακή συμπεριφορά/Κακοποίηση",
      issueDescription: "Περιγραφή προβλήματος: ",
      trackPatients: "Παρακολούθηση ασθενών",
      physioProfile: "Προφίλ φυσιοθεραπευτή",
      allocation: "Έχετε ανατεθεί σε ",
      patients: " ασθενείς.",
      youHave: "Έχετε ",
      consultationsMonth: " συμβουλές αυτόν τον μήνα.",
      slotsAvailable: " διαθέσιμες θέσεις",
      patientsTrack: "Αναφορές ασθενών",
      change: "Αλλαγή",
      remove: "Κατάργηση",
      addSlots: "Προσθήκη θέσεων",
      removeSlots: "Κατάργηση θέσεων",
      welcomeDr: "Γεια σου Δρ. {{name}}!",
      enterSpeciality: "Εισάγετε ειδικότητα",
      yearsOfExperience: "Χρόνια εμπειρίας: ",
      enterYearsOfExperience: "Εισάγετε χρόνια εμπειρίας...",
      neurologicalDisorder: "Νευρολογική διαταραχή",
      geriatrics: "Γηριατρική",
      cardiovascularPulmonaryPhysiotherapy: "Καρδιοπνευμονική φυσιοθεραπεία",
      pediatricPhysiotherapy: "Παιδιατρική φυσιοθεραπεία",
      musculoskeletalPhysiotherapy: "Μυοσκελετική φυσιοθεραπεία",
      sportsPhysiotherapy: "Αθλητική φυσιοθεραπεία",
      cardiovascularDisease: "Καρδιοαγγειακή ασθένεια",
      orthopedics: "Ορθοπαιδική",
      vestibularRehabilitation: "Αναπλαστική αποκατάσταση",
      homecarePhysiotherapy: "Φυσιοθεραπεία στο σπίτι",
      pediatrics: "Παιδιατρική",
      pelvicFloor: "Πυελικό έδαφος",
      womensHealthPhysiotherapy: "Φυσιοθεραπεία για την υγεία των γυναικών",
      acupuncture: "Βελονισμός",
      magneticTherapy: "Μαγνητική θεραπεία",
      manualTherapy: "Χειροκίνητη θεραπεία",
      oncology: "Ογκολογία",
      postOperativePhysiotherapist: "Φυσιοθεραπευτής μετά από χειρουργική επέμβαση",
      rehabilitation: "Αποκατάσταση",
      chestPhysiotherapy: "Θωρακική φυσιοθεραπεία",
      womensHealth: "Υγεία γυναικών",
      pleaseAnswerAllQuestions: "Παρακαλώ απαντήστε σε όλες τις ερωτήσεις",
      physioTrackProgress: "Αναφορές ασθενών",
      noReportsFound: "Δεν βρέθηκαν αναφορές",
      question1: "Εβδομαδιαία βελτίωση",
      question2: "Ικανοποίηση βίντεο",
      specificFeedback: "Ανοιχτή ανατροφοδότηση",
      submittedAt: "Υποβλήθηκε στις",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  es: { //Spanish
    translation: {
      welcome: "¡Hola {{name}}!",
      today: "Hoy es {{date}}.",
      trackingCompleted: "¡Muy bien! Has completado el plan de seguimiento de esta semana.",
      trackingNotCompleted: "Aún no has completado el plan de seguimiento de esta semana.",
      faqs: "Preguntas Frecuentes",
      home: "Página Principal",
      trackProgress: "Seguir Progreso",
      progressTrack: "Seguimiento de Progreso",
      completeTracking: "¿Plan de Seguimiento Semanal Completado?",
      giveFeedback: "¿Aportar Comentarios?",
      weekFeedback: "Formulario del Plan de Seguimiento de la Semana",
      qOne: "1. Del 0 al 5, ¿cuánto has mejorado desde la semana pasada?",
      qTwo: "2. Del 0 al 5, ¿cómo de efectivo fueron los vídeos que se les dieron?",
      qThree: "3. ¿Algún comentario específico?",
      cancel: "Cancelar",
      submit: "Enviar",
      consultations: "Consultas",
      speciality: "Especialidad: ",
      location: "Ubicación: ",
      consultationTag: "Programa tu consulta fisioterapéutica presencial.",
      selectDateTime: "Selecciona Fecha y Hora: ",
      scheduleWith: "Programa tu Consulta con ",
      schedule: "Programar",
      videoLibrary: "Biblioteca de Vídeos",
      selectCategory: "Selecciona una categoría para ver vídeos:",
      resistance: "Ejercicios de Resistencia",
      stretching: "Ejercicios de Estiramiento",
      strengthening: "Ejercicios de Fortalecimiento",
      functional: "Ejercicios Funcionales",
      balanceNeuromuscular: "Ejercicios de Equilibrio y Neuromusculares",
      backCategories: "Volver a Categorías",
      watchVideo: "Ver Vídeo",
      watched: "Visto",
      gFeedback: "Dar Calificación",
      rate: "Calificar: ",
      selectRating: "Seleccionar Nota: ",
      submitRating: "Enviar Calificación",
      noVideos: "No hay vídeos disponibles para esta categoría.",
      userProfile: "Perfil de Usuario",
      editProfile: "Editar Perfil",
      profilePicture: "Foto de Perfil: ",
      chooseFile: "Elegir un archivo",
      noFileChosen: "Ningún archivo seleccionado",
      firstName: "Nombre: ",
      lastName: "Apellido(s): ",
      email: "Correo Electrónico: ",
      sex: "Sexo: ",
      selectSex: "Elegir Sexo",
      male: "Masculino",
      female: "Femenino",
      dob: "Fecha de Nacimiento: ",
      height: "Altura (cm): ",
      weight: "Peso (kg): ",
      firstNameRequired: "Nombre es requerido",
      lastNameRequired: "Apellido es requerido",
      emailRequired: "Correo electrónico es requerido",
      sexRequired: "Sexo es requerido",
      dobRequired: "Fecha de nacimiento es requerida",
      dobCorrect: "Por favor introduzca una fecha de nacimiento correcta",
      heightRequired: "Altura es requerida",
      heightCorrect: "Por favor introduzca una altura correcta",    
      weightRequired: "Peso es requerido",
      weightCorrect: "Por favor entre un peso correcto",
      saveProfile: "Guardar Perfil",
      profileSaved: "Perfil Guardado!",
      noImage: "Sin Imagen",
      settings: "Ajustes",
      lightMode: "Modo Claro",
      darkMode: "Modo Oscuro",
      notificationPreference: "Preferencia de Notificaciones",
      language: "Idioma",
      emaiL: "Email",
      phone: "Número de Teléfono",
      both: "Ambos",
      login: "Iniciar Sesión",
      register: "Registrarse",
      firstname: "Nombre",
      lastname: "Apellido(s)",
      password: "Contraseña: ",
      invalidCredentials: "Email o contraseña inválida",
      fillAllFields: "Por favor rellene todos las casillas",
      dontHaveAccount: "¿No tiene una cuenta?",
      alreadyHaveAccount: "¿Ya tiene una cuenta? ",
      registerHere: "Registrarse Aquí",
      loginHere: "Iniciar Sesión Aquí",
      messages: "Chat",
      directMessages: "Mensajes Directos",
      typeYourMessage: "Escriba su Mensaje..",
      you: "Tú",
      send: "Mandar",
      patient: "Paciente",
      physio: "Fisioterapeuta",
      selectRole: "Seleccionar Rol",
      reportFeedback: "Reportar",
      name: "Nombre: ",
      reportType: "Seleccionar Tipo de Reporte: ",
      errorBug: "Bug/Error",
      misbehaviourAbuse: "Mal Comportamiento/Abuso",
      issueDescription: "Descripción del Problema: ",
      trackPatients: "Seguir Pacientes",
      physioProfile: "Perfil de Fisio",
      allocation: "Está asignado a ",
      patients: " pacientes.",
      youHave: "Tiene ",
      consultationsMonth: " consultas este mes.",
      slotsAvailable: " espacios todavía disponibles.",
      patientsTrack: "Reportes de Pacientes",
      change: "Cambiar",
      remove: "Quitar",
      addSlots: "Añadir Espacios",
      removeSlots: "Quitar Espacios",
      welcomeDr: "Hola Dr. {{name}}!",
      enterSpeciality: "Introducir Especialidad",
      yearsOfExperience: "Años de Experiencia: ",
      enterYearsOfExperience: "Introduzca Años de Experiencia..",
      neurologicalDisorder: "Trastorno Neurológico",
      geriatrics: "Geriatría",
      cardiovascularPulmonaryPhysiotherapy: "Fisioterapia Cardiovascular y Pulmonar",
      pediatricPhysiotherapy: "Fisioterapia Pediátrica",
      musculoskeletalPhysiotherapy: "Fisioterapia Musculoesquelética",
      sportsPhysiotherapy: "Fisioterapia Deportiva",
      cardiovascularDisease: "Enfermedad Cardiovascular",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Rehabilitación Vestibular",
      homecarePhysiotherapy: "Fisioterapia de Atención Domiciliaria",
      pediatrics: "Pediatría",
      pelvicFloor: "Suelo Pélvico",
      womensHealthPhysiotherapy: "Fisioterapia de Salud Femenina",
      acupuncture: "Acupuntura",
      magneticTherapy: "Terapia Magnética",
      manualTherapy: "Terapia Manual",
      oncology: "Oncología",
      postOperativePhysiotherapist: "Fisioterapia Postoperativa",
      rehabilitation: "Rehabilitación",
      chestPhysiotherapy: "Fisioterapia Pectoral",
      womensHealth: "Salud de la Mujer",
      pleaseAnswerAllQuestions: "Por favor, conteste todas las preguntas",
      physioTrackProgress: "Reportes de Pacientes",
      noReportsFound: "Ningún Reporte Encontrado",
      question1: "Mejora Semanal",
      question2: "Satisfacción de los Vídeos",
      specificFeedback: "Comentarios",
      submittedAt: "Enviado en",
      logout: "Cerrar Sesión",
      phoneNumber: "Número de Teléfono: ",
      address: "Dirección: ",
      phoneNumberRequired: "Número de Teléfono es requerido",
      addressRequired: "Dirección es requerida",
      detectMyLocation: "Detectar Su Ubicación",
      search: "Buscar",
      pSelectSpeciality: "Por favor, seleccione una especialidad.",
      consultationScheduledWith: "Consulta programada para: ",
      searchingWith: "Buscando con:",
      pProvideLocation: "Por favor, proporcione su ubicación.",
      geolocation: "Geolocalización no es compatible con su navegador.",
      errorLocation: "Error detectando ubicación.",
      locationDetected: "Ubicación Detectada:",
      contact: "Contacto: ",
      physioFAQs: "Preguntas Frecuentes de Fisio",
      patientFAQs: "Preguntas Frecuentes de Paciente",
      PaQ1: "¿Cómo me registro en PhysioEase?",
      PaA1: "Presione el buton de Registrar en la página de iniciar sesión, meta sus detalles y podrá iniciar sesión con su correo electrónico y contraseña.",
      PaQ2: "¿Cómo programo una cita?",
      PaA2: "Cuándo esté la sesión iniciada, vaya a la página de Consultas, seleccione un fisioterapista y use el formulario para programar una cita.",
      PaQ3: "¿Cómo actualizo mi perfil?",
      PaA3: "Navege a su página de Perfil de Usuario, haga los cambios y presione Guardar para actualizar su información.",
      PaQ4: "¿A quién contacto si tengo problemas con la página web?",
      PaA4: "Contacte con nuestro equipo de soporte via contact.physioease@gmail.com.",
      PhQ1: "¿Cómo me registro como un fisioterapista?",
      PhA1: "Seleccione el rol de fisioterapista en la página de registro y complete sus detalles. Cuándo se registre, tendrá acceso al panel de fisio.",
      PhQ2: "¿Cómo asesoro mis citas?",
      PhA2: "Inicia sesión y navege a la página de Consultas para ver y manejar las citas de sus pacientes.",
      PhQ3: "¿Cómo me comunico con mis pacientes?",
      PhA3: "Use la página de Mensajes Directos para mandar y recibir mensajes con sus pacientes.",
      PhQ4: "¿Con quién contacto para soporte técnico?",
      PhA4: "Para problemas o soporte relacionado con la página web, por favor contacte con nuestro equipo de soporte via contact.physioease@gmail.com.",
      footer1: "Siga a PhysioEase en todas las redes sociales:",
      legalTerms: "Término Legales",
      privacyPolicy: "Política de Privacidad",
      cookies: "Cookies",
      contactUs: "Contáctenos",
      scrollDown: "Bajar Abajo",
      backToTop: "Subir Arriba",
    }
  },
  eu: { //Basque
    translation: {
      welcome: "Kaixo {{name}}!",
      today: "Gaur {{date}} da.",
      trackingCompleted: "Oso ondo! Asteko jarraipen plana amaitu duzu.",
      trackingNotCompleted: "Asteko jarraipen plana ez duzu amaitu.",
      faqs: "Maiz egiten diren galderak",
      home: "Hasiera",
      trackProgress: "Jarraitutako Aurrerapena",
      progressTrack: "Aurrerapenaren jarraipena",
      completeTracking: "Asteko jarraipen plana amaitu da?",
      giveFeedback: "Eman erantzuna?",
      weekFeedback: "Asteko ariketa plana buruzko erantzuna",
      qOne: "1. 0tik 5ra, zenbat hobe zaude aurreko astearekin alderatuta?",
      qTwo: "2. 0tik 5ra, zein eraginkorra izan ziren eman ziren bideoak?",
      qThree: "3. Edozein erantzun zehatz?",
      cancel: "Ezeztatu",
      submit: "Bidali",
      consultations: "Kontsultak",
      speciality: "Bereizgarria: ",
      location: "Kokapena: ",
      consultationTag: "Zure aurrez aurreko fisioterapia kontsulta ordainatu.",
      selectDateTime: "Data eta Ordua aukeratu: ",
      schedule: "Ordainatu",
      scheduleWith: "Kontsulta ordainatu honekin: ",
      videoLibrary: "Bideo Biltegia",
      selectCategory: "Bideoak ikusteko kategoria bat aukeratu:",
      resistance: "Erresistentzia ariketak",
      stretching: "Estiramiento ariketak",
      strengthening: "Indartze ariketak",
      functional: "Funtzional ariketak",
      balanceNeuromuscular: "Balantza eta neuromuskular ariketak",
      backCategories: "Itzuli kategorietara",
      watchVideo: "Begiratu Bideoa",
      watched: "Ikusi da",
      gFeedback: "Eman erantzuna",
      rate: "Baloratu: ",
      selectRating: "Balorazio aukeratu: ",
      submitRating: "Bidali Balorazioa",
      noVideos: "Ez dago bideo eskuragarri kategori honetarako.",
      userProfile: "Erabiltzaile Profila",
      editProfile: "Editatu Profila",
      profilePicture: "Profilaren Argazkia: ",
      noFileChosen: "Ez da fitxategirik aukeratu",
      chooseFile: "Fitxategia aukeratu",
      firstName: "Izena: ",
      lastName: "Abizena: ",
      email: "Email: ",
      sex: "Generoa: ",
      selectSex: "Aukeratu Generoa",
      male: "Gizonezkoa",
      female: "Emakumezkoa",
      dob: "Jaiotze Data: ",
      height: "Altuera (cm): ",
      weight: "Pisua (kg): ",
      firstNameRequired: "Izena beharrezkoa da",
      lastNameRequired: "Abizena beharrezkoa da",
      emailRequired: "Email beharrezkoa da",
      sexRequired: "Generoa beharrezkoa da",
      dobRequired: "Jaiotze data beharrezkoa da",
      dobCorrect: "Mesedez, sartu jaiotze data zuzena",
      heightRequired: "Altuera beharrezkoa da",
      heightCorrect: "Mesedez, sartu altuera zuzena",
      weightRequired: "Pisua beharrezkoa da",
      weightCorrect: "Mesedez, sartu pisu zuzena",
      saveProfile: "Gorde Profila",
      profileSaved: "Profila gorde da!",
      noImage: "Ez dago irudiik",
      settings: "Ezarpenak",
      darkMode: "Itzaltutako Modua",
      language: "Hizkuntza",
      notificationPreference: "Jakinarazpen aukerak",
      lightMode: "Argi modua",
      emaiL: "Posta elektronikoa",
      phone: "Telefono zenbakia",
      both: "Biak",
      login: "Saioa hasi",
      register: "Erregistratu",
      firstname: "Izena",
      lastname: "Abizena",
      password: "Pasahitza: ",
      invalidCredentials: "Posta edo pasahitza okerrak",
      fillAllFields: "Mesedez, bete eremu guztiak",
      dontHaveAccount: "Ez duzu konturik? ",
      alreadyHaveAccount: "Kontu bat daukat? ",
      registerHere: "Hemen erregistratu",
      loginHere: "Hemen saioa hasi",
      messages: "Mezua",
      directMessages: "Mezu zuzena",
      typeYourMessage: "Idatzi zure mezua...",
      you: "Zu",
      send: "Bidali",
      patient: "Gaixo",
      physio: "Fisioterapeuta",
      selectRole: "Aukeratu rola",
      reportFeedback: "Txostena",
      name: "Izena: ",
      reportType: "Aukeratu txosten mota: ",
      errorBug: "Akatsa/Bug",
      misbehaviourAbuse: "Jazarpen okerra/Abuso",
      issueDescription: "Arazoaren deskribapena: ",
      trackPatients: "Gaixoak jarraitu",
      physioProfile: "Fisioterapeuta profila",
      allocation: "Zure esleipenaren helburua: ",
      patients: " gaixo",
      youHave: "Du duzu ",
      consultationsMonth: " kontsultak hilabete honetan",
      slotsAvailable: " gelditzen diren lekuak",
      patientsTrack: "Gaixoen txostenak",
      change: "Aldatu",
      remove: "Kendu",
      addSlots: "Leku gehiago gehitu",
      removeSlots: "Lekuak ezabatu",
      welcomeDr: "Kaixo Dr. {{name}}!",
      enterSpeciality: "Sartu espezialitatea",
      yearsOfExperience: "Esperientzia urteak: ",
      enterYearsOfExperience: "Sartu urte esperientzia...",
      neurologicalDisorder: "Neurologiko arazoa",
      geriatrics: "Geriatria",
      cardiovascularPulmonaryPhysiotherapy: "Bihotz eta biriken fisioterapia",
      pediatricPhysiotherapy: "Haurren fisioterapia",
      musculoskeletalPhysiotherapy: "Muskulu-eskleletal fisioterapia",
      sportsPhysiotherapy: "Kirol fisioterapia",
      cardiovascularDisease: "Bihotz gaixotasuna",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Vestibular erreabilitazioa",
      homecarePhysiotherapy: "Etxeko fisioterapia",
      pediatrics: "Pediatria",
      pelvicFloor: "Bekkensol",
      womensHealthPhysiotherapy: "Emakumeen osasun fisio",
      acupuncture: "Akupuntura",
      magneticTherapy: "Magnetoterapia",
      manualTherapy: "Eskuzko terapia",
      oncology: "Onkologia",
      postOperativePhysiotherapist: "Operazio ondoren fisioterapeuta",
      rehabilitation: "Erreabilitazioa",
      chestPhysiotherapy: "Bular fisioterapia",
      womensHealth: "Emakumeen osasuna",
      pleaseAnswerAllQuestions: "Mesedez, erantzun galdera guztiak",
      physioTrackProgress: "Gaixoen txostenak",
      noReportsFound: "Ez da txostenik aurkitu",
      question1: "Asteaneko hobekuntza",
      question2: "Bideoarekiko asebetetze",
      specificFeedback: "Irekiko iritzia",
      submittedAt: "Bidali zen",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  fa: { //Farsi
    translation: {
      welcome: "سلام {{name}}",
      today: "امروز {{date}} است.",
      trackingCompleted: "آفرین! شما برنامه پیگیری این هفته را تکمیل کرده‌اید",
      trackingNotCompleted: "شما برنامه پیگیری این هفته را تکمیل نکرده‌اید",
      faqs: "سوالات متداول",
      home: "خانه",
      trackProgress: "پیگیری پیشرفت",
      progressTrack: "پیگیری پیشرفت",
      completeTracking: "آیا برنامه پیگیری هفتگی تکمیل شده است؟",
      giveFeedback: "بازخورد دهید؟",
      weekFeedback: "بازخورد برنامه تمرین هفتگی",
      qOne: "1. در مقیاس ۰ تا ۵، تا چه حد نسبت به هفته گذشته بهبود یافته‌اید؟",
      qTwo: "2. در مقیاس ۰ تا ۵، ویدیوهای ارائه شده چقدر موثر بودند؟",
      qThree: "3. آیا بازخورد خاصی دارید؟",
      cancel: "لغو",
      submit: "ارسال",
      consultations: "مشاوره‌ها",
      speciality: "تخصص: ",
      location: "موقعیت: ",
      consultationTag: "مشاوره حضوری فیزیوتراپی خود را برنامه‌ریزی کنید.",
      selectDateTime: "تاریخ و زمان را انتخاب کنید: ",
      schedule: "برنامه‌ریزی",
      scheduleWith: "مشاوره با ",
      videoLibrary: "کتابخانه ویدیو",
      selectCategory: "یک دسته‌بندی برای مشاهده ویدیوها انتخاب کنید:",
      resistance: "تمرینات مقاومتی",
      stretching: "تمرینات کششی",
      strengthening: "تمرینات تقویتی",
      functional: "تمرینات عملکردی",
      balanceNeuromuscular: "تمرینات تعادلی و نوروماسکولار",
      backCategories: "بازگشت به دسته‌بندی‌ها",
      watchVideo: "مشاهده ویدیو",
      watched: "مشاهده شده",
      gFeedback: "بازخورد دهید",
      rate: "امتیاز: ",
      selectRating: "امتیاز را انتخاب کنید: ",
      submitRating: "ارسال امتیاز",
      noVideos: "برای این دسته‌بندی ویدیویی موجود نیست.",
      userProfile: "پروفایل کاربر",
      editProfile: "ویرایش پروفایل",
      profilePicture: "تصویر پروفایل: ",
      noFileChosen: "هیچ فایلی انتخاب نشده",
      chooseFile: "انتخاب فایل",
      firstName: "نام: ",
      lastName: "نام خانوادگی: ",
      email: "ایمیل: ",
      sex: "جنسیت: ",
      selectSex: "انتخاب جنسیت",
      male: "مرد",
      female: "زن",
      dob: "تاریخ تولد: ",
      height: "قد (cm): ",
      weight: "وزن (kg): ",
      firstNameRequired: "وارد کردن نام الزامی است",
      lastNameRequired: "وارد کردن نام خانوادگی الزامی است",
      emailRequired: "وارد کردن ایمیل الزامی است",
      sexRequired: "انتخاب جنسیت الزامی است",
      dobRequired: "وارد کردن تاریخ تولد الزامی است",
      dobCorrect: "لطفاً تاریخ تولد صحیح وارد کنید",
      heightRequired: "وارد کردن قد الزامی است",
      heightCorrect: "لطفاً قد صحیح وارد کنید",
      weightRequired: "وارد کردن وزن الزامی است",
      weightCorrect: "لطفاً وزن صحیح وارد کنید",
      saveProfile: "ذخیره پروفایل",
      profileSaved: "پروفایل ذخیره شد!",
      noImage: "تصویری موجود نیست",
      settings: "تنظیمات",
      darkMode: "حالت تاریک",
      language: "زبان",
      notificationPreference: "ترجیحات اعلان",
      lightMode: "حالت روشن",
      emaiL: "ایمیل",
      phone: "شماره تلفن",
      both: "هر دو",
      login: "ورود",
      register: "ثبت نام",
      firstname: "نام",
      lastname: "نام خانوادگی",
      password: "رمز عبور: ",
      invalidCredentials: "ایمیل یا رمز عبور نامعتبر",
      fillAllFields: "لطفاً تمام فیلدها را پر کنید",
      dontHaveAccount: "حساب کاربری ندارید؟ ",
      alreadyHaveAccount: "قبلاً حساب دارید؟ ",
      registerHere: "اینجا ثبت نام کنید",
      loginHere: "اینجا وارد شوید",
      messages: "چت",
      directMessages: "پیام‌رسانی مستقیم",
      typeYourMessage: "پیام خود را تایپ کنید...",
      you: "شما",
      send: "ارسال",
      patient: "بیمار",
      physio: "فیزیوتراپیست",
      selectRole: "انتخاب نقش",
      reportFeedback: "گزارش",
      name: "نام: ",
      reportType: "نوع گزارش را انتخاب کنید: ",
      errorBug: "اشکال/خطا",
      misbehaviourAbuse: "رفتار نادرست/سوءاستفاده",
      issueDescription: "توضیح مشکل: ",
      trackPatients: "پیگیری بیماران",
      physioProfile: "پروفایل فیزیوتراپیست",
      allocation: "شما اختصاص داده شده‌اید به ",
      patients: " بیمار",
      youHave: "شما دارید ",
      consultationsMonth: " مشاوره این ماه",
      slotsAvailable: " جای خالی موجود",
      patientsTrack: "گزارش‌های بیمار",
      change: "تغییر",
      remove: "حذف",
      addSlots: "افزودن جای خالی",
      removeSlots: "حذف جای خالی",
      welcomeDr: "سلام دکتر {{name}}!",
      enterSpeciality: "تخصص را وارد کنید",
      yearsOfExperience: "سال‌های تجربه: ",
      enterYearsOfExperience: "سال‌های تجربه را وارد کنید...",
      neurologicalDisorder: "اختلال عصبی",
      geriatrics: "گریاتری",
      cardiovascularPulmonaryPhysiotherapy: "فیزیوتراپی قلبی عروقی و ریه‌ای",
      pediatricPhysiotherapy: "فیزیوتراپی کودکان",
      musculoskeletalPhysiotherapy: "فیزیوتراپی اسکلتی عضلانی",
      sportsPhysiotherapy: "فیزیوتراپی ورزشی",
      cardiovascularDisease: "بیماری قلبی عروقی",
      orthopedics: "ارتوپدی",
      vestibularRehabilitation: "توانبخشی وستیبولار",
      homecarePhysiotherapy: "فیزیوتراپی خانگی",
      pediatrics: "کودکان",
      pelvicFloor: "کف لگن",
      womensHealthPhysiotherapy: "فیزیوتراپی سلامت زنان",
      acupuncture: "طب سوزنی",
      magneticTherapy: "درمان مغناطیسی",
      manualTherapy: "درمان دستی",
      oncology: "سرطان‌شناسی",
      postOperativePhysiotherapist: "فیزیوتراپیست پس از عمل",
      rehabilitation: "توانبخشی",
      chestPhysiotherapy: "فیزیوتراپی سینه",
      womensHealth: "سلامت زنان",
      pleaseAnswerAllQuestions: "لطفاً به همه سوالات پاسخ دهید",
      physioTrackProgress: "گزارش‌های بیمار",
      noReportsFound: "هیچ گزارشی یافت نشد",
      question1: "بهبود هفتگی",
      question2: "رضایت از ویدیو",
      specificFeedback: "بازخورد آزاد",
      submittedAt: "ارسال شده در",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  fr: { //French
    translation: {
      welcome: "Salut {{name}}!",
      today: "Nous sommes le {{date}}.",
      trackingCompleted: "Tres bien! Vous avez terminé le plan de suivi de cette semaine.",
      trackingNotCompleted: "Vous n'avez pas encore terminé le plan de suivi de cette semaine.",
      faqs: "Questions Fréquemment Posées",
      home: "Page d'Accueil",
      trackProgress: "Suivre les Progrès",
      progressTrack: "Suivre des Progrès",
      completeTracking: "Plan de Suivi Hebdomadaire Terminé?",
      giveFeedback: "Donner du Feedback?",
      weekFeedback: "Formulario del Plan de Seguimiento de la Semana",
      qOne: "1. Del 0 al 5, ¿cuánto has mejorado desde la semana pasada?",
      qTwo: "2. Del 0 al 5, ¿cómo de efectivo fueron los vídeos que se les dieron?",
      qThree: "3. ¿Algún comentario específico?",
      cancel: "Annuler",
      submit: "Soumettre",
      consultations: "Consultations",
      speciality: "Spécialité: ",
      location: "Lieu: ",
      consultationTag: "Programmez votre consultation de physiothérapie en personne.",
      selectDateTime: "Sélectionnez la Date et l'Heure: ",
      scheduleWith: "Programmez une consultation avec ",
      schedule: "Programmez",
      videoLibrary: "Vidéothèque",
      selectCategory: "Sélectionnez une catégorie pour visionner les vidéos:",
      resistance: "Exercices de Résistance",
      stretching: "Exercices d'Étirement",
      strengthening: "Exercices de Renforcement",
      functional: "Exercices Fonctionnels",
      balanceNeuromuscular: "Exercices d'Équilibre et Neuromusculaires",
      backCategories: "Retour aux Catégories",
      watchVideo: "Regarder Vidéo",
      watched: "Déjà vu",
      gFeedback: "Donnez votre Avis",
      rate: "Evaluez: ",
      selectRating: "Sélectionnez une Note: ",
      submitRating: "Envoyer la Note",
      noVideos: "Aucune vidéo disponible pour cette catégorie.",
      userProfile: "Profil utilisateur",
      editProfile: "Modifier le profil",
      profilePicture: "Photo de profil",
      noFileChosen: "Aucun fichier sélectionné",
      chooseFile: "Choisir un fichier",
      firstName: "Prénom: ",
      lastName: "Nom de Famille: ",
      email: "Email: ",
      sex: "Sexe: ",
      selectSex: "Sélectionnez Sexe",
      male: "Homme",
      female: "Femme",
      dob: "Date de naissance: ",
      height: "Taille (cm): ",
      weight: "Poids (kg): ",
      firstNameRequired: "Le prénom est requis",
      lastNameRequired: "Le nom de famille est requis",
      emailRequired: "L'email est requis",
      sexRequired: "Le sexe est requis",
      dobRequired: "La date de naissance est requise",
      dobCorrect: "Veuillez entrer une date de naissance correcte",
      heightRequired: "La taille est requise",
      heightCorrect: "Veuillez entrer une taille correcte",
      weightRequired: "Le poids est requis",
      weightCorrect: "Veuillez entrer un poids correct",
      saveProfile: "Enregistrer le profil",
      profileSaved: "Profil enregistré!",
      noImage: "Pas d'image",
      settings: "Paramètres",
      darkMode: "Mode Sombre",
      language: "Langue",
      notificationPreference: "Préférence de notification",
      lightMode: "Mode Clair",
      emaiL: "Email",
      phone: "Numéro de téléphone",
      both: "Les deux",
      login: "Connexion",
      register: "Inscription",
      firstname: "Prénom",
      lastname: "Nom de Famille",
      password: "Mot de Passe: ",
      invalidCredentials: "Email ou mot de passe invalide",
      fillAllFields: "Veuillez remplir tous les champs",
      dontHaveAccount: "Vous n'avez pas de compte?",
      alreadyHaveAccount: "Vous avez déjà un compte?",
      registerHere: "Inscrivez-vous ici",
      loginHere: "Connectez-vous ici",
      messages: "Chat",
      directMessages: "Messagerie directe",
      typeYourMessage: "Tapez votre message...",
      you: "Vous",
      send: "Envoyer",
      patient: "Patient",
      physio: "Physiothérapeute",
      selectRole: "Sélectionnez le Rôle",
      reportFeedback: "Signaler",
      name: "Nom: ",
      reportType: "Sélectionnez le Type de Rapport: ",
      errorBug: "Bogue/Erreur",
      misbehaviourAbuse: "Mauvais Comportement/Abus",
      issueDescription: "Description du Problème: ",
      trackPatients: "Suivre les Patients",
      physioProfile: "Profil du Physio",
      allocation: "Vous êtes affecté à ",
      patients: " patients",
      youHave: "Vous avez ",
      consultationsMonth: " consultations ce mois-ci",
      slotsAvailable: " créneaux encore disponibles",
      patientsTrack: "Rapports des patients",
      change: "Changer",
      remove: "Supprimer",
      addSlots: "Ajouter des Créneaux",
      removeSlots: "Supprimer des Créneaux",
      welcomeDr: "Bonjour Dr. {{name}}!",
      enterSpeciality: "Entrez la Spécialité",
      yearsOfExperience: "Années d'Expérience: ",
      enterYearsOfExperience: "Entrez les Années d'Expérience...",
      neurologicalDisorder: "Trouble Neurologique",
      geriatrics: "Gériatrie",
      cardiovascularPulmonaryPhysiotherapy: "Physiothérapie Cardiovasculaire et Pulmonaire",
      pediatricPhysiotherapy: "Physiothérapie Pédiatrique",
      musculoskeletalPhysiotherapy: "Physiothérapie Musculosquelettique",
      sportsPhysiotherapy: "Physiothérapie Sportive",
      cardiovascularDisease: "Maladie Cardiovasculaire",
      orthopedics: "Orthopédie",
      vestibularRehabilitation: "Rééducation Vestibulaire",
      homecarePhysiotherapy: "Physiothérapie à Domicile",
      pediatrics: "Pédiatrie",
      pelvicFloor: "Plancher Pelvien",
      womensHealthPhysiotherapy: "Physiothérapie pour la Santé des Femmes",
      acupuncture: "Acupuncture",
      magneticTherapy: "Thérapie Magnétique",
      manualTherapy: "Thérapie Manuelle",
      oncology: "Oncologie",
      postOperativePhysiotherapist: "Physiothérapie Post-Opératoire",
      rehabilitation: "Réhabilitation",
      chestPhysiotherapy: "Physiothérapie Thoracique",
      womensHealth: "Santé des Femmes",
      pleaseAnswerAllQuestions: "Veuillez répondre à toutes les questions",
      physioTrackProgress: "Rapports des Patients",
      noReportsFound: "Aucun Rapport Trouvé",
      question1: "Amélioration Hebdomadaire",
      question2: "Satisfaction Vidéo",
      specificFeedback: "Retour d'Information Ouvert",
      submittedAt: "Soumis le",
      logout: "Log Out",
      phoneNumber: "Numéro de Téléphone: ",
    }
  },
  gl: { //Galician
    translation: {
      welcome: "Ola {{name}}!",
      today: "Hoxe é {{date}}.",
      trackingCompleted: "Ben feito! Completaches o plan de seguimento desta semana.",
      trackingNotCompleted: "Non completaches o plan de seguimento desta semana.",
      faqs: "Preguntas Frequentes",
      home: "Inicio",
      trackProgress: "Seguír o Progreso",
      progressTrack: "Seguimento do Progreso",
      completeTracking: "¿Completaches o plan semanal de seguimento?",
      giveFeedback: "¿Dar Feedback?",
      weekFeedback: "Feedback sobre o Plan Semanal de Exercicios",
      qOne: "1. Nunha escala do 0 ao 5, canto melloraches comparado coa semana pasada?",
      qTwo: "2. Nunha escala do 0 ao 5, canto efectivos foron os vídeos proporcionados?",
      qThree: "3. Algún comentario específico?",
      cancel: "Cancelar",
      submit: "Enviar",
      consultations: "Consultas",
      speciality: "Especialidade: ",
      location: "Localización: ",
      consultationTag: "Programa a túa consulta de fisioterapia presencial.",
      selectDateTime: "Selecciona Data e Hora: ",
      schedule: "Programar",
      scheduleWith: "Programa consulta con ",
      videoLibrary: "Biblioteca de Vídeos",
      selectCategory: "Selecciona unha categoría para ver vídeos:",
      resistance: "Exercicios de Resistencia",
      stretching: "Exercicios de Estiramento",
      strengthening: "Exercicios de Fortalecemento",
      functional: "Exercicios Funcionais",
      balanceNeuromuscular: "Exercicios de Equilibrio e Neuromusculares",
      backCategories: "Volver ás Categorías",
      watchVideo: "Ver Vídeo",
      watched: "Visto",
      gFeedback: "Dar Feedback",
      rate: "Calificar: ",
      selectRating: "Selecciona Nota: ",
      submitRating: "Enviar Calificación",
      noVideos: "Non hai vídeos dispoñibles para esta categoría.",
      userProfile: "Perfil de Usuario",
      editProfile: "Editar Perfil",
      profilePicture: "Foto de Perfil: ",
      noFileChosen: "Ningún ficheiro seleccionado",
      chooseFile: "Escoller ficheiro",
      firstName: "Nome: ",
      lastName: "Apelidos: ",
      email: "Email: ",
      sex: "Sexo: ",
      selectSex: "Escolla Sexo",
      male: "Masculino",
      female: "Feminino",
      dob: "Data de Nacemento: ",
      height: "Altura (cm): ",
      weight: "Peso (kg): ",
      firstNameRequired: "O nome é obligatorio",
      lastNameRequired: "Os apelidos son obrigatorios",
      emailRequired: "O email é obligatorio",
      sexRequired: "O sexo é obligatorio",
      dobRequired: "A data de nacemento é obrigatoria",
      dobCorrect: "Por favor, introduza unha data de nacemento correcta",
      heightRequired: "A altura é obrigatoria",
      heightCorrect: "Por favor, introduza unha altura correcta",
      weightRequired: "O peso é obligatorio",
      weightCorrect: "Por favor, introduza un peso correcto",
      saveProfile: "Gardar Perfil",
      profileSaved: "Perfil gardado!",
      noImage: "Sen imaxe",
      settings: "Axustes",
      darkMode: "Modo Escuro",
      language: "Lingua",
      notificationPreference: "Preferencia de notificación",
      lightMode: "Modo claro",
      emaiL: "Correo electrónico",
      phone: "Número de teléfono",
      both: "Ambos",
      login: "Acceder",
      register: "Rexistrarse",
      firstname: "Primeiro nome",
      lastname: "Apelidos",
      password: "Contrasinal: ",
      invalidCredentials: "Correo ou contrasinal non válidos",
      fillAllFields: "Por favor, enche todos os campos",
      dontHaveAccount: "Non tes conta? ",
      alreadyHaveAccount: "Xa tes conta? ",
      registerHere: "Rexístrate aquí",
      loginHere: "Accede aquí",
      messages: "Chat",
      directMessages: "Mensaxería directa",
      typeYourMessage: "Escribe a túa mensaxe...",
      you: "Ti",
      send: "Enviar",
      patient: "Paciente",
      physio: "Fisioterapeuta",
      selectRole: "Selecciona o rol",
      reportFeedback: "Informar",
      name: "Nome: ",
      reportType: "Selecciona o tipo de informe: ",
      errorBug: "Erro/Bug",
      misbehaviourAbuse: "Mal comportamento/Abuso",
      issueDescription: "Descrición do problema: ",
      trackPatients: "Rastrear pacientes",
      physioProfile: "Perfil do fisioterapeuta",
      allocation: "Estás asignado a ",
      patients: " pacientes",
      youHave: "Tes ",
      consultationsMonth: " consultas este mes",
      slotsAvailable: " espazos aínda dispoñibles",
      patientsTrack: "Informes dos pacientes",
      change: "Cambiar",
      remove: "Eliminar",
      addSlots: "Engadir espazos",
      removeSlots: "Eliminar espazos",
      welcomeDr: "Ola Dr. {{name}}!",
      enterSpeciality: "Introduce a especialidade",
      yearsOfExperience: "Anos de experiencia: ",
      enterYearsOfExperience: "Introduce os anos de experiencia...",
      neurologicalDisorder: "Perturbação neurolóxica",
      geriatrics: "Geriatría",
      cardiovascularPulmonaryPhysiotherapy: "Fisioterapia cardiovascular e pulmonar",
      pediatricPhysiotherapy: "Fisioterapia pediátrica",
      musculoskeletalPhysiotherapy: "Fisioterapia musculoesquelética",
      sportsPhysiotherapy: "Fisioterapia deportiva",
      cardiovascularDisease: "Doenzas cardiovasculares",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Rehabilitación vestibular",
      homecarePhysiotherapy: "Fisioterapia domiciliaria",
      pediatrics: "Pediatría",
      pelvicFloor: "Suelos pélvicos",
      womensHealthPhysiotherapy: "Fisioterapia para a saúde das mulleres",
      acupuncture: "Acupuntura",
      magneticTherapy: "Terapia magnética",
      manualTherapy: "Terapia manual",
      oncology: "Oncología",
      postOperativePhysiotherapist: "Fisioterapeuta postoperatorio",
      rehabilitation: "Rehabilitación",
      chestPhysiotherapy: "Fisioterapia torácica",
      womensHealth: "Saúde das mulleres",
      pleaseAnswerAllQuestions: "Por favor, responde a todas as preguntas",
      physioTrackProgress: "Informes dos pacientes",
      noReportsFound: "Non se atoparon informes",
      question1: "Mellora setmanal",
      question2: "Satisfacción co vídeo",
      specificFeedback: "Feedback aberto",
      submittedAt: "Enviado ás",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  he: { //Hebrew
    translation: {
      welcome: "שלום {{name}}",
      today: "היום הוא {{date}}",
      trackingCompleted: "כל הכבוד! השלמת את תוכנית המעקב של השבוע",
      trackingNotCompleted: "לא השלמת את תוכנית המעקב של השבוע",
      faqs: "שאלות נפוצות",
      home: "דף הבית",
      trackProgress: "עקוב אחרי ההתקדמות",
      progressTrack: "מעקב ההתקדמות",
      completeTracking: "האם השלמת את תוכנית המעקב השבועית?",
      giveFeedback: "האם ברצונך לתת משוב?",
      weekFeedback: "משוב על תוכנית האימונים השבועית",
      qOne: "1. בסולם מ-0 עד 5, עד כמה השתפרת לעומת השבוע שעבר?",
      qTwo: "2. בסולם מ-0 עד 5, כמה היו הווידאוים יעילים?",
      qThree: "3. האם יש משוב ספציפי?",
      cancel: "ביטול",
      submit: "שלח",
      consultations: "התייעצויות",
      speciality: "התמחות: ",
      location: "מיקום: ",
      consultationTag: "תכנן את הפגישה האישית שלך עם הפיזיותרפיסט.",
      selectDateTime: "בחר תאריך ושעה: ",
      schedule: "תכנן",
      scheduleWith: "תכנן פגישה עם ",
      videoLibrary: "ספריית וידאו",
      selectCategory: "בחר קטגוריה לצפייה בווידאו:",
      resistance: "תרגילים נגד התנגדות",
      stretching: "תרגילי מתיחות",
      strengthening: "תרגילי חיזוק",
      functional: "תרגילים פונקציונליים",
      balanceNeuromuscular: "תרגילים לשיווי משקל ונוירומסקולרי",
      backCategories: "חזרה לקטגוריות",
      watchVideo: "צפה בווידאו",
      watched: "נצפה",
      gFeedback: "תן משוב",
      rate: "דירוג: ",
      selectRating: "בחר דירוג: ",
      submitRating: "שלח דירוג",
      noVideos: "אין וידאו זמינים לקטגוריה זו.",
      userProfile: "פרופיל משתמש",
      editProfile: "ערוך פרופיל",
      profilePicture: "תמונת פרופיל: ",
      noFileChosen: "לא נבחר קובץ",
      chooseFile: "בחר קובץ",
      firstName: "שם פרטי: ",
      lastName: "שם משפחה: ",
      email: "אימייל: ",
      sex: "מגדר: ",
      selectSex: "בחר מגדר",
      male: "זכר",
      female: "נקבה",
      dob: "תאריך לידה: ",
      height: "גובה (cm): ",
      weight: "משקל (kg): ",
      firstNameRequired: "שם פרטי הוא חובה",
      lastNameRequired: "שם משפחה הוא חובה",
      emailRequired: "אימייל הוא חובה",
      sexRequired: "מגדר הוא חובה",
      dobRequired: "תאריך לידה הוא חובה",
      dobCorrect: "אנא הזן תאריך לידה נכון",
      heightRequired: "גובה הוא חובה",
      heightCorrect: "אנא הזן גובה נכון",
      weightRequired: "משקל הוא חובה",
      weightCorrect: "אנא הזן משקל נכון",
      saveProfile: "שמור פרופיל",
      profileSaved: "הפרופיל נשמר!",
      noImage: "אין תמונה",
      settings: "הגדרות",
      darkMode: "מצב כהה",
      language: "שפה",
      notificationPreference: "העדפת התראות",
      lightMode: "מצב בהיר",
      emaiL: "אימייל",
      phone: "מספר טלפון",
      both: "שניהם",
      login: "התחבר",
      register: "הרשם",
      firstname: "שם פרטי",
      lastname: "שם משפחה",
      password: "סיסמה: ",
      invalidCredentials: "אימייל או סיסמה לא תקינים",
      fillAllFields: "אנא מלא את כל השדות",
      dontHaveAccount: "אין לך חשבון? ",
      alreadyHaveAccount: "כבר יש לך חשבון? ",
      registerHere: "הרשם כאן",
      loginHere: "התחבר כאן",
      messages: "צ'אט",
      directMessages: "הודעות ישירות",
      typeYourMessage: "הקלד את הודעתך...",
      you: "אתה",
      send: "שלח",
      patient: "מטופל",
      physio: "פיזיותרפיסט",
      selectRole: "בחר תפקיד",
      reportFeedback: "דווח",
      name: "שם: ",
      reportType: "בחר סוג דיווח: ",
      errorBug: "באג/שגיאה",
      misbehaviourAbuse: "התנהגות לא הולמת/התעללות",
      issueDescription: "תיאור הבעיה: ",
      trackPatients: "עקוב אחרי מטופלים",
      physioProfile: "פרופיל פיזיותרפיסט",
      allocation: "אתה מוקצה ל",
      patients: " מטופלים",
      youHave: "יש לך ",
      consultationsMonth: " ייעוצים החודש",
      slotsAvailable: " מקומות זמינים",
      patientsTrack: "דוחות מטופלים",
      change: "שנה",
      remove: "הסר",
      addSlots: "הוסף מקומות",
      removeSlots: "הסר מקומות",
      welcomeDr:"שלום דר {{name}}!",
      enterSpeciality: "הזן התמחויות",
      yearsOfExperience: "שנות ניסיון: ",
      enterYearsOfExperience: "הזן שנות ניסיון...",
      neurologicalDisorder: "הפרעה נוירולוגית",
      geriatrics: "ג'ריאטריה",
      cardiovascularPulmonaryPhysiotherapy: "פיזיותרפיה לבבית-ריאתית",
      pediatricPhysiotherapy: "פיזיותרפיה לילדים",
      musculoskeletalPhysiotherapy: "פיזיותרפיה מערכת שריר-עצם",
      sportsPhysiotherapy: "פיזיותרפיה ספורטיבית",
      cardiovascularDisease: "מחלות לב וכלי דם",
      orthopedics: "אורתופדיה",
      vestibularRehabilitation: "שיקום וסטיבולרי",
      homecarePhysiotherapy: "פיזיותרפיה ביתית",
      pediatrics: "פדיאטריה",
      pelvicFloor: "רצפת האגן",
      womensHealthPhysiotherapy: "פיזיותרפיה לבריאות נשים",
      acupuncture: "דיקור סיני",
      magneticTherapy: "טיפול מגנטי",
      manualTherapy: "טיפול ידני",
      oncology: "אונקולוגיה",
      postOperativePhysiotherapist: "פיזיותרפיסט לאחר ניתוח",
      rehabilitation: "שיקום",
      chestPhysiotherapy: "פיזיותרפיה לחזה",
      womensHealth: "בריאות נשים",
      pleaseAnswerAllQuestions: "אנא ענה על כל השאלות",
      physioTrackProgress: "דוחות מטופלים",
      noReportsFound: "לא נמצאו דוחות",
      question1: "שיפור שבועי",
      question2: "שביעות רצון מהווידאו",
      specificFeedback: "משוב פתוח",
      submittedAt: "נשלח ב",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  hi: { //Hindi
    translation: {
      welcome: "नमस्ते {{name}}!",
      today: "आज {{date}} है।",
      trackingCompleted: "शाबाश! आपने इस सप्ताह की ट्रैकिंग योजना पूरी कर ली है।",
      trackingNotCompleted: "आपने इस सप्ताह की ट्रैकिंग योजना पूरी नहीं की है।",
      faqs: "अक्सर पूछे जाने वाले प्रश्न",
      home: "होम",
      trackProgress: "प्रगति ट्रैक करें",
      progressTrack: "प्रगति ट्रैकिंग",
      completeTracking: "क्या आपने साप्ताहिक ट्रैकिंग योजना पूरी कर ली है?",
      giveFeedback: "क्या आप प्रतिक्रिया देना चाहेंगे?",
      weekFeedback: "साप्ताहिक व्यायाम योजना पर प्रतिक्रिया",
      qOne: "1. 0 से 5 के पैमाने पर, पिछले सप्ताह की तुलना में आप कितना सुधार हुए हैं?",
      qTwo: "2. 0 से 5 के पैमाने पर, दी गई वीडियो कितनी प्रभावी थीं?",
      qThree: "3. कोई विशेष प्रतिक्रिया?",
      cancel: "रद्द करें",
      submit: "सबमिट करें",
      consultations: "सलाहकार",
      speciality: "विशेषता: ",
      location: "स्थान: ",
      consultationTag: "अपनी व्यक्तिगत फिजियोथेरेपी परामर्श अनुसूचित करें।",
      selectDateTime: "तारीख और समय चुनें: ",
      schedule: "शेड्यूल करें",
      scheduleWith: "के साथ परामर्श अनुसूचित करें: ",
      videoLibrary: "वीडियो लाइब्रेरी",
      selectCategory: "वीडियो देखने के लिए एक श्रेणी चुनें:",
      resistance: "प्रतिरोध व्यायाम",
      stretching: "स्ट्रेचिंग व्यायाम",
      strengthening: "मजबूतीकरण व्यायाम",
      functional: "कार्यात्मक व्यायाम",
      balanceNeuromuscular: "संतुलन और न्यूरोमस्कुलर व्यायाम",
      backCategories: "श्रेणियों पर वापस जाएँ",
      watchVideo: "वीडियो देखें",
      watched: "देखा हुआ",
      gFeedback: "प्रतिक्रिया दें",
      rate: "रेट: ",
      selectRating: "रेटिंग चुनें: ",
      submitRating: "रेटिंग सबमिट करें",
      noVideos: "इस श्रेणी के लिए कोई वीडियो उपलब्ध नहीं है।",
      userProfile: "यूजर प्रोफाइल",
      editProfile: "प्रोफ़ाइल संपादित करें",
      profilePicture: "प्रोफ़ाइल चित्र: ",
      noFileChosen: "कोई फ़ाइल नहीं चुनी गई",
      chooseFile: "फ़ाइल चुनें",
      firstName: "पहला नाम: ",
      lastName: "अंतिम नाम: ",
      email: "ईमेल: ",
      sex: "लिंग: ",
      selectSex: "लिंग चुनें",
      male: "पुरुष",
      female: "महिला",
      dob: "जन्म तिथि: ",
      height: "ऊंचाई (सेमी): ",
      weight: "वज़न (किग्रा): ",
      firstNameRequired: "पहला नाम आवश्यक है",
      lastNameRequired: "अंतिम नाम आवश्यक है",
      emailRequired: "ईमेल आवश्यक है",
      sexRequired: "लिंग आवश्यक है",
      dobRequired: "जन्म तिथि आवश्यक है",
      dobCorrect: "कृपया सही जन्म तिथि दर्ज करें",
      heightRequired: "ऊंचाई आवश्यक है",
      heightCorrect: "कृपया सही ऊंचाई दर्ज करें",
      weightRequired: "वज़न आवश्यक है",
      weightCorrect: "कृपया सही वजन दर्ज करें",
      saveProfile: "प्रोफ़ाइल सेव करें",
      profileSaved: "प्रोफ़ाइल सेव हो गई!",
      noImage: "कोई छवि नहीं",
      settings: "सेटिंग्स",
      darkMode: "डार्क मोड",
      language: "भाषा",
      notificationPreference: "सूचना प्राथमिकता",
      lightMode: "लाइट मोड",
      emaiL: "ईमेल",
      phone: "फ़ोन नंबर",
      both: "दोनों",
      login: "लॉग इन",
      register: "रजिस्टर",
      firstname: "पहला नाम",
      lastname: "अंतिम नाम",
      password: "पासवर्ड: ",
      invalidCredentials: "अमान्य ईमेल या पासवर्ड",
      fillAllFields: "कृपया सभी फ़ील्ड भरें",
      dontHaveAccount: "खाता नहीं है? ",
      alreadyHaveAccount: "पहले से खाता है? ",
      registerHere: "यहाँ रजिस्टर करें",
      loginHere: "यहाँ लॉग इन करें",
      messages: "चैट",
      directMessages: "प्रत्यक्ष संदेश",
      typeYourMessage: "अपना संदेश लिखें...",
      you: "आप",
      send: "भेजें",
      patient: "मरीज",
      physio: "फिजियोथेरेपिस्ट",
      selectRole: "भूमिका चुनें",
      reportFeedback: "रिपोर्ट करें",
      name: "नाम: ",
      reportType: "रिपोर्ट प्रकार चुनें: ",
      errorBug: "बग/त्रुटि",
      misbehaviourAbuse: "गलत व्यवहार/दुरुपयोग",
      issueDescription: "समस्याओं का विवरण: ",
      trackPatients: "मरीजों का ट्रैक रखें",
      physioProfile: "फिजियो प्रोफाइल",
      allocation: "आपको सौंपा गया है ",
      patients: " मरीज",
      youHave: "आपके पास हैं ",
      consultationsMonth: " इस महीने की सलाह",
      slotsAvailable: " स्लॉट उपलब्ध हैं",
      patientsTrack: "मरीज रिपोर्ट्स",
      change: "बदलें",
      remove: "हटाएं",
      addSlots: "स्लॉट जोड़ें",
      removeSlots: "स्लॉट हटाएं",
      welcomeDr: "नमस्ते डॉ. {{name}}!",
      enterSpeciality: "विशेषता दर्ज करें",
      yearsOfExperience: "अनुभव के वर्ष: ",
      enterYearsOfExperience: "अनुभव के वर्ष दर्ज करें...",
      neurologicalDisorder: "स्नायु संबंधी विकार",
      geriatrics: "जेरियाट्रिक्स",
      cardiovascularPulmonaryPhysiotherapy: "हृदय एवं फेफड़ों की फिजियोथेरेपी",
      pediatricPhysiotherapy: "बाल फिजियोथेरेपी",
      musculoskeletalPhysiotherapy: "मांसपेशीय-हड्डी फिजियोथेरेपी",
      sportsPhysiotherapy: "खेल फिजियोथेरेपी",
      cardiovascularDisease: "हृदय रोग",
      orthopedics: "ऑर्थोपेडिक्स",
      vestibularRehabilitation: "वेस्टिबुलर पुनर्वास",
      homecarePhysiotherapy: "होमकेयर फिजियोथेरेपी",
      pediatrics: "बाल चिकित्सा",
      pelvicFloor: "पेल्विक फ्लोर",
      womensHealthPhysiotherapy: "महिलाओं की फिजियोथेरेपी",
      acupuncture: "एक्यूपंक्चर",
      magneticTherapy: "मैग्नेटिक थेरेपी",
      manualTherapy: "मैनुअल थेरेपी",
      oncology: "ऑन्कोलॉजी",
      postOperativePhysiotherapist: "ऑपरेशन के बाद फिजियोथेरेपिस्ट",
      rehabilitation: "पुनर्वास",
      chestPhysiotherapy: "छाती की फिजियोथेरेपी",
      womensHealth: "महिलाओं का स्वास्थ्य",
      pleaseAnswerAllQuestions: "कृपया सभी प्रश्नों का उत्तर दें",
      physioTrackProgress: "मरीज रिपोर्ट्स",
      noReportsFound: "कोई रिपोर्ट नहीं मिली",
      question1: "साप्ताहिक सुधार",
      question2: "वीडियो संतुष्टि",
      specificFeedback: "खुला फीडबैक",
      submittedAt: "सबमिट किया गया",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  hu: { //Hungarian
    translation: {
      welcome: "Helló {{name}}!",
      today: "Ma {{date}} van.",
      trackingCompleted: "Jól csináltad! Teljesítetted a heti nyomon követési tervet.",
      trackingNotCompleted: "Nem teljesítetted a heti nyomon követési tervet.",
      faqs: "Gyakran Ismételt Kérdések",
      home: "Kezdőlap",
      trackProgress: "Kövesd a Haladást",
      progressTrack: "Haladáskövetés",
      completeTracking: "Teljesítetted a heti nyomon követési tervet?",
      giveFeedback: "Adj visszajelzést?",
      weekFeedback: "Heti Edzésterv Visszajelzés",
      qOne: "1. 0-tól 5-ig terjedő skálán, mennyit javultál a múlt héthez képest?",
      qTwo: "2. 0-tól 5-ig terjedő skálán, mennyire voltak hatékonyak a megadott videók?",
      qThree: "3. Van-e konkrét visszajelzésed?",
      cancel: "Mégse",
      submit: "Küldés",
      consultations: "Konzultációk",
      speciality: "Szakértelem: ",
      location: "Helyszín: ",
      consultationTag: "Időpontot kell foglalnod személyes fizioterápiára.",
      selectDateTime: "Válassz Dátumot és Időt: ",
      schedule: "Ütemezés",
      scheduleWith: "Konzultáció időpont foglalása: ",
      videoLibrary: "Videókönyvtár",
      selectCategory: "Válassz kategóriát a videók megtekintéséhez:",
      resistance: "Ellenállásos Gyakorlatok",
      stretching: "Nyújtó Gyakorlatok",
      strengthening: "Erősítő Gyakorlatok",
      functional: "Funkcionális Gyakorlatok",
      balanceNeuromuscular: "Egyensúly és neuromuszkuláris Gyakorlatok",
      backCategories: "Vissza a Kategóriákhoz",
      watchVideo: "Videó Megtekintése",
      watched: "Megtekintve",
      gFeedback: "Adj visszajelzést",
      rate: "Értékeld: ",
      selectRating: "Válassz Értékelést: ",
      submitRating: "Értékelés Küldése",
      noVideos: "Nincsenek videók elérhetőek ehhez a kategóriához.",
      userProfile: "Felhasználói Profil",
      editProfile: "Profil Szerkesztése",
      profilePicture: "Profilkép: ",
      noFileChosen: "Nem választottál fájlt",
      chooseFile: "Válassz fájlt",
      firstName: "Keresztnév: ",
      lastName: "Vezetéknév: ",
      email: "Email: ",
      sex: "Nem: ",
      selectSex: "Válassz nemet",
      male: "Férfi",
      female: "Nő",
      dob: "Születési Dátum: ",
      height: "Magasság (cm): ",
      weight: "Súly (kg): ",
      firstNameRequired: "A keresztnév kötelező",
      lastNameRequired: "A vezetéknév kötelező",
      emailRequired: "Az email kötelező",
      sexRequired: "A nem megadása kötelező",
      dobRequired: "A születési dátum kötelező",
      dobCorrect: "Kérjük, adjon meg egy helyes születési dátumot",
      heightRequired: "A magasság kötelező",
      heightCorrect: "Kérjük, adjon meg egy helyes magasságot",
      weightRequired: "A súly kötelező",
      weightCorrect: "Kérjük, adjon meg egy helyes súlyt",
      saveProfile: "Mentés",
      profileSaved: "Profil mentve!",
      noImage: "Nincs kép",
      settings: "Beállítások",
      darkMode: "Sötét mód",
      language: "Nyelv",
      notificationPreference: "Értesítési preferencia",
      lightMode: "Világos mód",
      emaiL: "Email",
      phone: "Telefonszám",
      both: "Mindkettő",
      login: "Bejelentkezés",
      register: "Regisztráció",
      firstname: "Keresztnév",
      lastname: "Vezetéknév",
      password: "Jelszó: ",
      invalidCredentials: "Érvénytelen email vagy jelszó",
      fillAllFields: "Kérjük, töltse ki az összes mezőt",
      dontHaveAccount: "Nincs fiókja? ",
      alreadyHaveAccount: "Már van fiókja? ",
      registerHere: "Regisztráljon itt",
      loginHere: "Jelentkezzen be itt",
      messages: "Chat",
      directMessages: "Közvetlen üzenetek",
      typeYourMessage: "Írja be az üzenetét...",
      you: "Ön",
      send: "Küldés",
      patient: "Beteg",
      physio: "Fizioterapeuta",
      selectRole: "Válasszon szerepet",
      reportFeedback: "Jelentés",
      name: "Név: ",
      reportType: "Válassza ki a jelentés típusát: ",
      errorBug: "Hiba/Bug",
      misbehaviourAbuse: "Rossz viselkedés/Missbrauch",
      issueDescription: "A probléma leírása: ",
      trackPatients: "Betegkövetés",
      physioProfile: "Fizioterapeuta profil",
      allocation: "Ön hozzárendelve van ",
      patients: " beteg",
      youHave: "Önnek van ",
      consultationsMonth: " konzultáció ebben a hónapban",
      slotsAvailable: " elérhető hely",
      patientsTrack: "Beteg jelentések",
      change: "Módosít",
      remove: "Eltávolít",
      addSlots: "Hely hozzáadása",
      removeSlots: "Hely eltávolítása",
      welcomeDr: "Üdvözöljük Dr. {{name}}!",
      enterSpeciality: "Adja meg a szakterületet",
      yearsOfExperience: "Évek tapasztalata: ",
      enterYearsOfExperience: "Írja be a tapasztalat éveit...",
      neurologicalDisorder: "Neurológiai rendellenesség",
      geriatrics: "Geriatria",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaszkuláris és pulmonális fizioterápia",
      pediatricPhysiotherapy: "Pediátriai fizioterápia",
      musculoskeletalPhysiotherapy: "Mozgásszervi fizioterápia",
      sportsPhysiotherapy: "Sportfizioterápia",
      cardiovascularDisease: "Kardiovaszkuláris betegség",
      orthopedics: "Ortopédia",
      vestibularRehabilitation: "Vestibuláris rehabilitáció",
      homecarePhysiotherapy: "Otthoni fizioterápia",
      pediatrics: "Pediátria",
      pelvicFloor: "Medencefenék",
      womensHealthPhysiotherapy: "Női egészség fizioterápiája",
      acupuncture: "Akupunktúra",
      magneticTherapy: "Mágneses terápia",
      manualTherapy: "Manuálterápia",
      oncology: "Onkológia",
      postOperativePhysiotherapist: "Műtét utáni fizioterapeuta",
      rehabilitation: "Rehabilitáció",
      chestPhysiotherapy: "Mellkasi fizioterápia",
      womensHealth: "Női egészség",
      pleaseAnswerAllQuestions: "Kérjük, válaszoljon minden kérdésre",
      physioTrackProgress: "Beteg jelentések",
      noReportsFound: "Nincs jelentés",
      question1: "Heti javulás",
      question2: "Videó elégedettség",
      specificFeedback: "Nyílt visszajelzés",
      submittedAt: "Elküldve",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  id: { //Indonesian
    translation: {
      welcome: "Halo {{name}}!",
      today: "Hari ini adalah {{date}}.",
      trackingCompleted: "Kerja bagus! Anda telah menyelesaikan rencana pelacakan minggu ini.",
      trackingNotCompleted: "Anda belum menyelesaikan rencana pelacakan minggu ini.",
      faqs: "Pertanyaan yang Sering Diajukan",
      home: "Beranda",
      trackProgress: "Lacak Kemajuan",
      progressTrack: "Pelacakan Kemajuan",
      completeTracking: "Apakah Rencana Pelacakan Mingguan telah diselesaikan?",
      giveFeedback: "Berikan umpan balik?",
      weekFeedback: "Umpan Balik Rencana Latihan Mingguan",
      qOne: "1. Dalam skala 0 hingga 5, seberapa banyak Anda meningkat dibanding minggu lalu?",
      qTwo: "2. Dalam skala 0 hingga 5, seberapa efektif video yang diberikan?",
      qThree: "3. Apakah ada umpan balik khusus?",
      cancel: "Batal",
      submit: "Kirim",
      consultations: "Konsultasi",
      speciality: "Spesialisasi: ",
      location: "Lokasi: ",
      consultationTag: "Jadwalkan konsultasi fisioterapi langsung Anda.",
      selectDateTime: "Pilih Tanggal dan Waktu: ",
      schedule: "Jadwalkan",
      scheduleWith: "Jadwalkan Konsultasi dengan ",
      videoLibrary: "Perpustakaan Video",
      selectCategory: "Pilih kategori untuk melihat video:",
      resistance: "Latihan Resistensi",
      stretching: "Latihan Peregangan",
      strengthening: "Latihan Penguatan",
      functional: "Latihan Fungsional",
      balanceNeuromuscular: "Latihan Keseimbangan & Neuromuskular",
      backCategories: "Kembali ke Kategori",
      watchVideo: "Tonton Video",
      watched: "Sudah ditonton",
      gFeedback: "Berikan Umpan Balik",
      rate: "Nilai: ",
      selectRating: "Pilih Nilai: ",
      submitRating: "Kirim Nilai",
      noVideos: "Tidak ada video yang tersedia untuk kategori ini.",
      userProfile: "Profil Pengguna",
      editProfile: "Edit Profil",
      profilePicture: "Gambar Profil: ",
      noFileChosen: "Tidak ada file yang dipilih",
      chooseFile: "Pilih file",
      firstName: "Nama Depan: ",
      lastName: "Nama Belakang: ",
      email: "Email: ",
      sex: "Jenis Kelamin: ",
      selectSex: "Pilih Jenis Kelamin",
      male: "Pria",
      female: "Wanita",
      dob: "Tanggal Lahir: ",
      height: "Tinggi (cm): ",
      weight: "Berat (kg): ",
      firstNameRequired: "Nama depan wajib diisi",
      lastNameRequired: "Nama belakang wajib diisi",
      emailRequired: "Email wajib diisi",
      sexRequired: "Jenis kelamin wajib diisi",
      dobRequired: "Tanggal lahir wajib diisi",
      dobCorrect: "Harap masukkan tanggal lahir yang benar",
      heightRequired: "Tinggi wajib diisi",
      heightCorrect: "Harap masukkan tinggi yang benar",
      weightRequired: "Berat wajib diisi",
      weightCorrect: "Harap masukkan berat yang benar",
      saveProfile: "Simpan Profil",
      profileSaved: "Profil disimpan!",
      noImage: "Tidak ada gambar",
      settings: "Pengaturan",
      darkMode: "Mode Gelap",
      language: "Bahasa",
      notificationPreference: "Preferensi Notifikasi",
      lightMode: "Mode Terang",
      emaiL: "Email",
      phone: "Nomor Telepon",
      both: "Keduanya",
      login: "Masuk",
      register: "Daftar",
      firstname: "Nama Depan",
      lastname: "Nama Belakang",
      password: "Kata Sandi: ",
      invalidCredentials: "Email atau kata sandi tidak valid",
      fillAllFields: "Harap isi semua kolom",
      dontHaveAccount: "Tidak punya akun? ",
      alreadyHaveAccount: "Sudah punya akun? ",
      registerHere: "Daftar di sini",
      loginHere: "Masuk di sini",
      messages: "Chat",
      directMessages: "Pesan Langsung",
      typeYourMessage: "Ketik pesan Anda...",
      you: "Anda",
      send: "Kirim",
      patient: "Pasien",
      physio: "Fisioterapis",
      selectRole: "Pilih Peran",
      reportFeedback: "Laporkan",
      name: "Nama: ",
      reportType: "Pilih Jenis Laporan: ",
      errorBug: "Bug/Eror",
      misbehaviourAbuse: "Perilaku buruk/Penyalahgunaan",
      issueDescription: "Deskripsi Masalah: ",
      trackPatients: "Lacak Pasien",
      physioProfile: "Profil Fisioterapis",
      allocation: "Anda dialokasikan ke ",
      patients: " pasien",
      youHave: "Anda memiliki ",
      consultationsMonth: " konsultasi bulan ini",
      slotsAvailable: " slot tersedia",
      patientsTrack: "Laporan Pasien",
      change: "Ubah",
      remove: "Hapus",
      addSlots: "Tambahkan Slot",
      removeSlots: "Hapus Slot",
      welcomeDr: "Halo Dr. {{name}}!",
      enterSpeciality: "Masukkan Spesialisasi",
      yearsOfExperience: "Tahun Pengalaman: ",
      enterYearsOfExperience: "Masukkan Tahun Pengalaman...",
      neurologicalDisorder: "Gangguan Neurologis",
      geriatrics: "Geriatri",
      cardiovascularPulmonaryPhysiotherapy: "Fisioterapi Kardiovaskular dan Paru",
      pediatricPhysiotherapy: "Fisioterapi Pediatrik",
      musculoskeletalPhysiotherapy: "Fisioterapi Muskuloskeletal",
      sportsPhysiotherapy: "Fisioterapi Olahraga",
      cardiovascularDisease: "Penyakit Kardiovaskular",
      orthopedics: "Ortopedi",
      vestibularRehabilitation: "Rehabilitasi Vestibular",
      homecarePhysiotherapy: "Fisioterapi Perawatan Rumah",
      pediatrics: "Pediatri",
      pelvicFloor: "Lantai Panggul",
      womensHealthPhysiotherapy: "Fisioterapi Kesehatan Wanita",
      acupuncture: "Akupunktur",
      magneticTherapy: "Terapi Magnetik",
      manualTherapy: "Terapi Manual",
      oncology: "Onkologi",
      postOperativePhysiotherapist: "Fisioterapis Pascabedah",
      rehabilitation: "Rehabilitasi",
      chestPhysiotherapy: "Fisioterapi Dada",
      womensHealth: "Kesehatan Wanita",
      pleaseAnswerAllQuestions: "Harap jawab semua pertanyaan",
      physioTrackProgress: "Laporan Pasien",
      noReportsFound: "Tidak ada laporan ditemukan",
      question1: "Peningkatan Mingguan",
      question2: "Kepuasan Video",
      specificFeedback: "Umpan Balik Terbuka",
      submittedAt: "Dikirim pada",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  it: { //Italian
    translation: {
      welcome: "Ciao {{name}}!",
      today: "Oggi è {{date}}.",
      trackingCompleted: "Bravo! Hai completato il piano di monitoraggio di questa settimana.",
      trackingNotCompleted: "Non hai completato il piano di monitoraggio di questa settimana.",
      faqs: "Domande Frequenti",
      home: "Pagina Iniziale",
      trackProgress: "Monitorare i Progressi",
      progressTrack: "Monitoraggio del progresso",
      completeTracking: "Hai completato il piano di monitoraggio settimanale?",
      giveFeedback: "Dai il tuo feedback?",
      weekFeedback: "Feedback sul piano di esercizi settimanale",
      qOne: "1. Su una scala da 0 a 5, quanto sei migliorato rispetto alla scorsa settimana?",
      qTwo: "2. Su una scala da 0 a 5, quanto sono stati efficaci i video forniti?",
      qThree: "3. Qualche commento specifico?",
      cancel: "Annulla",
      submit: "Invia",
      consultations: "Consultazioni",
      speciality: "Specialità: ",
      location: "Luogo: ",
      consultationTag: "Prenota la tua consulenza fisioterapica in persona.",
      selectDateTime: "Seleziona data e ora: ",
      schedule: "Pianifica",
      scheduleWith: "Pianifica una consulenza con ",
      videoLibrary: "Videoteca",
      selectCategory: "Seleziona una categoria per visualizzare i video:",
      resistance: "Esercizi di resistenza",
      stretching: "Esercizi di stretching",
      strengthening: "Esercizi di potenziamento",
      functional: "Esercizi funzionali",
      balanceNeuromuscular: "Esercizi di equilibrio e neuromuscolari",
      backCategories: "Torna alle categorie",
      watchVideo: "Guarda il video",
      watched: "Visto",
      gFeedback: "Dai il tuo feedback",
      rate: "Valuta: ",
      selectRating: "Seleziona la valutazione: ",
      submitRating: "Invia la valutazione",
      noVideos: "Nessun video disponibile per questa categoria.",
      userProfile: "Profilo Utente",
      editProfile: "Modifica Profilo",
      profilePicture: "Foto Profilo: ",
      noFileChosen: "Nessun file selezionato",
      chooseFile: "Scegli file",
      firstName: "Nome: ",
      lastName: "Cognome: ",
      email: "Email: ",
      sex: "Sesso: ",
      selectSex: "Seleziona sesso",
      male: "Maschio",
      female: "Femmina",
      dob: "Data di nascita: ",
      height: "Altezza (cm): ",
      weight: "Peso (kg): ",
      firstNameRequired: "Il nome è obbligatorio",
      lastNameRequired: "Il cognome è obbligatorio",
      emailRequired: "L'email è obbligatoria",
      sexRequired: "Il sesso è obbligatorio",
      dobRequired: "La data di nascita è obbligatoria",
      dobCorrect: "Inserisci una data di nascita corretta",
      heightRequired: "L'altezza è obbligatoria",
      heightCorrect: "Inserisci un'altezza corretta",
      weightRequired: "Il peso è obbligatorio",
      weightCorrect: "Inserisci un peso corretto",
      saveProfile: "Salva Profilo",
      profileSaved: "Profilo salvato!",
      noImage: "Nessuna immagine",
      settings: "Impostazioni",
      darkMode: "Modalità Scura",
      language: "Lingua",
      notificationPreference: "Preferenza di notifica",
      lightMode: "Modalità chiara",
      emaiL: "Email",
      phone: "Numero di telefono",
      both: "Entrambi",
      login: "Accedi",
      register: "Registrati",
      firstname: "Nome",
      lastname: "Cognome",
      password: "Password: ",
      invalidCredentials: "Email o password non validi",
      fillAllFields: "Per favore, compila tutti i campi",
      dontHaveAccount: "Non hai un account? ",
      alreadyHaveAccount: "Hai già un account? ",
      registerHere: "Registrati qui",
      loginHere: "Accedi qui",
      messages: "Chat",
      directMessages: "Messaggistica diretta",
      typeYourMessage: "Digita il tuo messaggio...",
      you: "Tu",
      send: "Invia",
      patient: "Paziente",
      physio: "Fisioterapista",
      selectRole: "Seleziona ruolo",
      reportFeedback: "Segnala",
      name: "Nome: ",
      reportType: "Seleziona il tipo di segnalazione: ",
      errorBug: "Bug/Errore",
      misbehaviourAbuse: "Comportamento scorretto/Abuso",
      issueDescription: "Descrizione del problema: ",
      trackPatients: "Traccia pazienti",
      physioProfile: "Profilo del fisioterapista",
      allocation: "Sei assegnato a ",
      patients: " pazienti",
      youHave: "Hai ",
      consultationsMonth: " consulenze questo mese",
      slotsAvailable: " slot ancora disponibili",
      patientsTrack: "Report dei pazienti",
      change: "Cambia",
      remove: "Rimuovi",
      addSlots: "Aggiungi slot",
      removeSlots: "Rimuovi slot",
      welcomeDr: "Ciao Dr. {{name}}!",
      enterSpeciality: "Inserisci specialità",
      yearsOfExperience: "Anni di esperienza: ",
      enterYearsOfExperience: "Inserisci gli anni di esperienza...",
      neurologicalDisorder: "Disturbo neurologico",
      geriatrics: "Geriatria",
      cardiovascularPulmonaryPhysiotherapy: "Fisioterapia cardiovascolare e polmonare",
      pediatricPhysiotherapy: "Fisioterapia pediatrica",
      musculoskeletalPhysiotherapy: "Fisioterapia muscolo-scheletrica",
      sportsPhysiotherapy: "Fisioterapia sportiva",
      cardiovascularDisease: "Malattia cardiovascolare",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Riabilitazione vestibolare",
      homecarePhysiotherapy: "Fisioterapia domiciliare",
      pediatrics: "Pediatria",
      pelvicFloor: "Pavimento pelvico",
      womensHealthPhysiotherapy: "Fisioterapia per la salute delle donne",
      acupuncture: "Agopuntura",
      magneticTherapy: "Terapia magnetica",
      manualTherapy: "Terapia manuale",
      oncology: "Oncologia",
      postOperativePhysiotherapist: "Fisioterapia post-operatoria",
      rehabilitation: "Riabilitazione",
      chestPhysiotherapy: "Fisioterapia toracica",
      womensHealth: "Salute delle donne",
      pleaseAnswerAllQuestions: "Rispondi a tutte le domande",
      physioTrackProgress: "Report dei pazienti",
      noReportsFound: "Nessun report trovato",
      question1: "Miglioramento settimanale",
      question2: "Soddisfazione video",
      specificFeedback: "Feedback aperto",
      submittedAt: "Inviato alle",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ja: { //Japanese
    translation: {
      welcome: "こんにちは、{{name}}さん！",
      today: "今日は{{date}}です。",
      trackingCompleted: "よくやった！今週の進捗プランを完了しました。",
      trackingNotCompleted: "今週の進捗プランは完了していません。",
      faqs: "よくある質問",
      home: "ホーム",
      trackProgress: "進捗を追跡する",
      progressTrack: "進捗追跡",
      completeTracking: "週間の進捗プランは完了しましたか？",
      giveFeedback: "フィードバックを送りますか？",
      weekFeedback: "週間運動プランのフィードバック",
      qOne: "1. 0から5のスケールで、先週に比べてどのくらい改善しましたか？",
      qTwo: "2. 0から5のスケールで、提供されたビデオはどれくらい効果的でしたか？",
      qThree: "3. 何か具体的なフィードバックはありますか？",
      cancel: "キャンセル",
      submit: "送信",
      consultations: "相談",
      speciality: "専門分野: ",
      location: "場所: ",
      consultationTag: "対面の理学療法相談を予約してください。",
      selectDateTime: "日付と時間を選択：",
      schedule: "スケジュール",
      scheduleWith: "との相談を予約する: ",
      videoLibrary: "ビデオライブラリ",
      selectCategory: "動画を見るためのカテゴリーを選択してください：",
      resistance: "レジスタンスエクササイズ",
      stretching: "ストレッチエクササイズ",
      strengthening: "筋力トレーニング",
      functional: "機能的エクササイズ",
      balanceNeuromuscular: "バランス＆ニューロマスキュラーエクササイズ",
      backCategories: "カテゴリーに戻る",
      watchVideo: "動画を見る",
      watched: "視聴済み",
      gFeedback: "フィードバックを送る",
      rate: "評価: ",
      selectRating: "評価を選択：",
      submitRating: "評価を送信",
      noVideos: "このカテゴリーには利用可能な動画がありません。",
      userProfile: "ユーザープロフィール",
      editProfile: "プロフィール編集",
      profilePicture: "プロフィール画像: ",
      noFileChosen: "ファイルが選択されていません",
      chooseFile: "ファイルを選択",
      firstName: "名: ",
      lastName: "姓: ",
      email: "メール: ",
      sex: "性別: ",
      selectSex: "性別を選択してください",
      male: "男性",
      female: "女性",
      dob: "生年月日: ",
      height: "身長（cm): ",
      weight: "体重（kg): ",
      firstNameRequired: "名は必須です",
      lastNameRequired: "姓は必須です",
      emailRequired: "メールは必須です",
      sexRequired: "性別は必須です",
      dobRequired: "生年月日は必須です",
      dobCorrect: "正しい生年月日を入力してください",
      heightRequired: "身長は必須です",
      heightCorrect: "正しい身長を入力してください",
      weightRequired: "体重は必須です",
      weightCorrect: "正しい体重を入力してください",
      saveProfile: "プロフィールを保存",
      profileSaved: "プロフィールが保存されました！",
      noImage: "画像なし",
      settings: "設定",
      darkMode: "ダークモード",
      language: "言語",
      notificationPreference: "通知設定",
      lightMode: "ライトモード",
      emaiL: "メール",
      phone: "電話番号",
      both: "両方",
      login: "ログイン",
      register: "登録",
      firstname: "名",
      lastname: "姓",
      password: "パスワード: ",
      invalidCredentials: "無効なメールまたはパスワード",
      fillAllFields: "全ての項目を入力してください",
      dontHaveAccount: "アカウントがありませんか？ ",
      alreadyHaveAccount: "既にアカウントをお持ちですか？ ",
      registerHere: "こちらで登録",
      loginHere: "こちらでログイン",
      messages: "チャット",
      directMessages: "ダイレクトメッセージ",
      typeYourMessage: "メッセージを入力してください...",
      you: "あなた",
      send: "送信",
      patient: "患者",
      physio: "理学療法士",
      selectRole: "役割を選択",
      reportFeedback: "報告する",
      name: "名前: ",
      reportType: "報告タイプを選択: ",
      errorBug: "バグ/エラー",
      misbehaviourAbuse: "不正行動/虐待",
      issueDescription: "問題の説明: ",
      trackPatients: "患者を追跡",
      physioProfile: "理学療法士プロフィール",
      allocation: "割り当てられています: ",
      patients: " 患者",
      youHave: "あなたには ",
      consultationsMonth: " 今月の相談",
      slotsAvailable: " 利用可能なスロット",
      patientsTrack: "患者のレポート",
      change: "変更",
      remove: "削除",
      addSlots: "スロットを追加",
      removeSlots: "スロットを削除",
      welcomeDr: "こんにちは、Dr. {{name}}!",
      enterSpeciality: "専門分野を入力してください",
      yearsOfExperience: "経験年数: ",
      enterYearsOfExperience: "経験年数を入力してください...",
      neurologicalDisorder: "神経障害",
      geriatrics: "高齢者医療",
      cardiovascularPulmonaryPhysiotherapy: "心血管・肺の理学療法",
      pediatricPhysiotherapy: "小児理学療法",
      musculoskeletalPhysiotherapy: "筋骨格系理学療法",
      sportsPhysiotherapy: "スポーツ理学療法",
      cardiovascularDisease: "心血管疾患",
      orthopedics: "整形外科",
      vestibularRehabilitation: "前庭リハビリテーション",
      homecarePhysiotherapy: "在宅理学療法",
     pediatrics: "小児科",
      pelvicFloor: "骨盤底",
      womensHealthPhysiotherapy: "女性の健康理学療法",
      acupuncture: "鍼治療",
      magneticTherapy: "磁気療法",
      manualTherapy: "手動療法",
      oncology: "腫瘍学",
      postOperativePhysiotherapist: "術後理学療法士",
      rehabilitation: "リハビリテーション",
      chestPhysiotherapy: "胸部理学療法",
      womensHealth: "女性の健康",
      pleaseAnswerAllQuestions: "すべての質問に答えてください",
      physioTrackProgress: "患者レポート",
      noReportsFound: "レポートが見つかりません",
      question1: "週ごとの改善",
      question2: "ビデオの満足度",
      specificFeedback: "自由なフィードバック",
      submittedAt: "提出日時",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ko: { //Korean
    translation: {
      welcome: "안녕하세요, {{name}}님!",
      today: "오늘은 {{date}}입니다.",
      trackingCompleted: "잘하셨어요! 이번 주 추적 계획을 완료하셨습니다.",
      trackingNotCompleted: "이번 주 추적 계획을 완료하지 않으셨습니다.",
      faqs: "자주 묻는 질문",
      home: "홈",
      trackProgress: "진행 상황 추적",
      progressTrack: "진행 상황 모니터링",
      completeTracking: "주간 추적 계획을 완료하셨나요?",
      giveFeedback: "피드백을 제공하시겠습니까?",
      weekFeedback: "주간 운동 계획 피드백",
      qOne: "1. 0에서 5까지의 척도에서 지난주와 비교하여 얼마나 개선되었습니까?",
      qTwo: "2. 0에서 5까지의 척도에서 제공된 비디오의 효과는 어땠습니까?",
      qThree: "3. 구체적인 피드백이 있습니까?",
      cancel: "취소",
      submit: "제출",
      consultations: "상담",
      speciality: "전문 분야: ",
      location: "위치: ",
      consultationTag: "개인 물리치료 상담을 예약하세요.",
      selectDateTime: "날짜와 시간을 선택하세요: ",
      schedule: "예약",
      scheduleWith: "와(과) 상담 예약: ",
      videoLibrary: "비디오 라이브러리",
      selectCategory: "비디오를 볼 카테고리를 선택하세요:",
      resistance: "저항 운동",
      stretching: "스트레칭 운동",
      strengthening: "근력 강화 운동",
      functional: "기능적 운동",
      balanceNeuromuscular: "균형 및 신경근 운동",
      backCategories: "카테고리로 돌아가기",
      watchVideo: "비디오 보기",
      watched: "시청됨",
      gFeedback: "피드백 제공",
      rate: "평가: ",
      selectRating: "평가 선택: ",
      submitRating: "평가 제출",
      noVideos: "이 카테고리에는 이용 가능한 비디오가 없습니다.",
      userProfile: "사용자 프로필",
      editProfile: "프로필 편집",
      profilePicture: "프로필 사진: ",
      noFileChosen: "파일이 선택되지 않음",
      chooseFile: "파일 선택",
      firstName: "이름: ",
      lastName: "성: ",
      email: "이메일: ",
      sex: "성별: ",
      selectSex: "성별 선택",
      male: "남성",
      female: "여성",
      dob: "생년월일: ",
      height: "신장 (cm): ",
      weight: "체중 (kg): ",
      firstNameRequired: "이름은 필수입니다",
      lastNameRequired: "성이 필수입니다",
      emailRequired: "이메일은 필수입니다",
      sexRequired: "성별은 필수입니다",
      dobRequired: "생년월일은 필수입니다",
      dobCorrect: "올바른 생년월일을 입력해 주세요",
      heightRequired: "신장은 필수입니다",
      heightCorrect: "올바른 신장을 입력해 주세요",
      weightRequired: "체중은 필수입니다",
      weightCorrect: "올바른 체중을 입력해 주세요",
      saveProfile: "프로필 저장",
      profileSaved: "프로필이 저장되었습니다!",
      noImage: "이미지가 없습니다",
      settings: "설정",
      darkMode: "다크 모드",
      language: "언어",
      notificationPreference: "알림 기본 설정",
      lightMode: "라이트 모드",
      emaiL: "이메일",
      phone: "전화번호",
      both: "둘 다",
      login: "로그인",
      register: "회원가입",
      firstname: "이름",
      lastname: "성",
      password: "비밀번호: ",
      invalidCredentials: "잘못된 이메일 또는 비밀번호",
      fillAllFields: "모든 필드를 입력해 주세요",
      dontHaveAccount: "계정이 없으신가요? ",
      alreadyHaveAccount: "이미 계정이 있으신가요? ",
      registerHere: "여기서 회원가입",
      loginHere: "여기서 로그인",
      messages: "채팅",
      directMessages: "직접 메시지",
      typeYourMessage: "메시지를 입력하세요...",
      you: "당신",
      send: "보내기",
      patient: "환자",
      physio: "물리치료사",
      selectRole: "역할 선택",
      reportFeedback: "신고",
      name: "이름: ",
      reportType: "신고 유형 선택: ",
      errorBug: "버그/오류",
      misbehaviourAbuse: "부적절한 행동/학대",
      issueDescription: "문제 설명: ",
      trackPatients: "환자 추적",
      physioProfile: "물리치료사 프로필",
      allocation: "할당됨: ",
      patients: "명의 환자",
      youHave: "당신에게는 ",
      consultationsMonth: "이번 달 상담",
      slotsAvailable: "남은 슬롯",
      patientsTrack: "환자 보고서",
      change: "변경",
      remove: "제거",
      addSlots: "슬롯 추가",
      removeSlots: "슬롯 제거",
      welcomeDr: "안녕하세요, Dr. {{name}}!",
      enterSpeciality: "전문 분야 입력",
      yearsOfExperience: "경험 연수: ",
      enterYearsOfExperience: "경험 연수를 입력하세요...",
      neurologicalDisorder: "신경 장애",
      geriatrics: "노인의학",
      cardiovascularPulmonaryPhysiotherapy: "심혈관 및 폐 물리치료",
      pediatricPhysiotherapy: "소아 물리치료",
      musculoskeletalPhysiotherapy: "근골격 물리치료",
      sportsPhysiotherapy: "스포츠 물리치료",
      cardiovascularDisease: "심혈관 질환",
      orthopedics: "정형외과",
      vestibularRehabilitation: "전정 재활",
      homecarePhysiotherapy: "재택 물리치료",
      pediatrics: "소아과",
      pelvicFloor: "골반저",
      womensHealthPhysiotherapy: "여성 건강 물리치료",
      acupuncture: "침술",
      magneticTherapy: "자기 치료",
      manualTherapy: "수기 치료",
      oncology: "종양학",
      postOperativePhysiotherapist: "수술 후 물리치료사",
      rehabilitation: "재활",
      chestPhysiotherapy: "흉부 물리치료",
      womensHealth: "여성 건강",
      pleaseAnswerAllQuestions: "모든 질문에 답해주세요",
      physioTrackProgress: "환자 보고서",
      noReportsFound: "보고서를 찾을 수 없습니다",
      question1: "주간 개선",
      question2: "비디오 만족도",
      specificFeedback: "자유로운 피드백",
      submittedAt: "제출됨",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ku: { //Kurdish (Kurmanji)
    translation: {
      welcome: "Silav {{name}}!",
      today: "Îro {{date}} e.",
      trackingCompleted: "Baş e! Hûn plana şopandina hefteyê qedandine.",
      trackingNotCompleted: "Hûn plana şopandina hefteyê qedan nekirin.",
      faqs: "Pirsa Pirsan",
      home: "Malpera Serekî",
      trackProgress: "Pêşketina şop bike",
      progressTrack: "Şopkirina Pêşketinê",
      completeTracking: "Plana şopandina hefteyê qedaye?",
      giveFeedback: "Feedback bidin?",
      weekFeedback: "Feedback li ser plana hefteyê ya exerciseyan",
      qOne: "1. Li ser skala 0 heta 5, çiqas lihevhatine te di hefteya borî de?",
      qTwo: "2. Li ser skala 0 heta 5, videoyên hatine pêşkêş çawa bûn?",
      qThree: "3. Hinek feedback taybet heye?",
      cancel: "Betal bike",
      submit: "Şandin",
      consultations: "Şêwirmendiyên",
      speciality: "Taybetmendî: ",
      location: "Cih: ",
      consultationTag: "Şêwirmendiya fizioterapî ya bi kesane rêkeve.",
      selectDateTime: "Dîrok û Dem hilbijêre: ",
      schedule: "Rêkeve",
      scheduleWith: "Şêwirmendî rêkeve bi ",
      videoLibrary: "Pirtûkxaneya Vîdyoyan",
      selectCategory: "Kategoriya ku hûn dixwazin vîdyoyan bibînin hilbijêre:",
      resistance: "Exerciseên Berxwedanê",
      stretching: "Exerciseên Berfirehkirinê",
      strengthening: "Exerciseên Hêzdarî",
      functional: "Exerciseên Fonkîsyonal",
      balanceNeuromuscular: "Exerciseên Balance & Neuromuskular",
      backCategories: "Vegere kategoriyan",
      watchVideo: "Vîdyo temaşe bike",
      watched: "Temaşekirî",
      gFeedback: "Feedback bidin",
      rate: "Rate: ",
      selectRating: "Rate hilbijêre: ",
      submitRating: "Rate şandin",
      noVideos: "Ji bo vê kategoriyê hich vîdyo tune.",
      userProfile: "Profîla Bikarhêner",
      editProfile: "Profîl biguherîne",
      profilePicture: "Wêneya Profîlê: ",
      noFileChosen: "Tu pel nehatiye hilbijartin",
      chooseFile: "Pel hilbijêre",
      firstName: "Nav: ",
      lastName: "Paşnav: ",
      email: "Email: ",
      sex: "Rewş: ",
      selectSex: "Rewş hilbijêre",
      male: "Mêr",
      female: "Mê",
      dob: "Rojbûn: ",
      height: "Dirêjahiya (cm): ",
      weight: "Qeza (kg): ",
      firstNameRequired: "Nav pêdivî ye",
      lastNameRequired: "Paşnav pêdivî ye",
      emailRequired: "Email pêdivî ye",
      sexRequired: "Rewş pêdivî ye",
      dobRequired: "Rojbûn pêdivî ye",
      dobCorrect: "Ji kerema xwe rojbûna rast binivîse",
      heightRequired: "Dirêjahiya pêdivî ye",
      heightCorrect: "Ji kerema xwe dirêjahiya rast binivîse",
      weightRequired: "Qeza pêdivî ye",
      weightCorrect: "Ji kerema xwe qeza rast binivîse",
      saveProfile: "Profîlê Tomar Bike",
      profileSaved: "Profîl tomarkirî ye!",
      noImage: "Wêne tune",
      settings: "Mîheng",
      darkMode: "Moda Tarî",
      language: "Ziman",
      notificationPreference: "Pêşniyaza agahdariyê",
      lightMode: "Moda ronak",
      emaiL: "Email",
      phone: "Hejmara telefonê",
      both: "Herdu",
      login: "Têkevin",
      register: "Qeyd bikin",
      firstname: "Navê yekem",
      lastname: "Navê paşîn",
      password: "Şîfre: ",
      invalidCredentials: "Email an şîfre ne rast",
      fillAllFields: "Hemî zeviyên tije bikin",
      dontHaveAccount: "Hesab tune? ",
      alreadyHaveAccount: "Hesab hene? ",
      registerHere: "Li vir qeyd bikin",
      loginHere: "Li vir têkevin",
      messages: "Peyam",
      directMessages: "Peyama rast",
      typeYourMessage: "Peyama xwe binivîse...",
      you: "Tu",
      send: "Şandin",
      patient: "Nexweş",
      physio: "Fîzyoterapîst",
      selectRole: "Rola xwe hilbijêre",
      reportFeedback: "Raport",
      name: "Nav: ",
      reportType: "Tîpa raporê hilbijêre: ",
      errorBug: "Xeta/Bug",
      misbehaviourAbuse: "Rewşa nebaş/Mîsbehaviour",
      issueDescription: "Terîfa pirsgirêkê: ",
      trackPatients: "Nexweşan şop bike",
      physioProfile: "Profîla fîzyoterapîstê",
      allocation: "Hatî veqetandin bo ",
      patients: " nexweş",
      youHave: "Tu hêyî ",
      consultationsMonth: " konsultasyonên vê mehê",
      slotsAvailable: " cihên belaş hene",
      patientsTrack: "Raporên nexweşan",
      change: "Guhertin",
      remove: "Jêbirin",
      addSlots: "Cihên zêde bikin",
      removeSlots: "Cihên jê bikin",
      welcomeDr: "Silav Dr. {{name}}!",
      enterSpeciality: "Taybetmendiyê binivîse",
      yearsOfExperience: "Salên tecrûbe: ",
      enterYearsOfExperience: "Salên tecrûbe binivîse...",
      neurologicalDisorder: "Tewandina nevrî",
      geriatrics: "Gerîatrî",
      cardiovascularPulmonaryPhysiotherapy: "Fîzyoterapîya dil û hestî",
      pediatricPhysiotherapy: "Fîzyoterapîya zarokan",
      musculoskeletalPhysiotherapy: "Fîzyoterapîya girtî û hêz",
      sportsPhysiotherapy: "Fîzyoterapîya sporê",
      cardiovascularDisease: "Nexweşiya dilî",
      orthopedics: "Ortopedî",
      vestibularRehabilitation: "Rehabilitasyona vestibulêr",
      homecarePhysiotherapy: "Fîzyoterapîya malê",
      pediatrics: "Zaroknaz",
      pelvicFloor: "Erdekê pelvîk",
      womensHealthPhysiotherapy: "Fîzyoterapîya tenduristiya jinan",
      acupuncture: "Akupunktur",
      magneticTherapy: "Terapîya maqnêtîk",
      manualTherapy: "Terapîya destî",
      oncology: "Onkolojî",
      postOperativePhysiotherapist: "Fîzyoterapîsta paş-opêrasyonê",
      rehabilitation: "Rehabilitasyon",
      chestPhysiotherapy: "Fîzyoterapîya sinê",
      womensHealth: "Tenduristiya jinan",
      pleaseAnswerAllQuestions: "Ji kerema xwe hemî pirsan bersiv bidin",
      physioTrackProgress: "Raporên nexweşan",
      noReportsFound: "Rapor nehat dîtin",
      question1: "Pêşkeftina hefteyane",
      question2: "Razîbûn ji videoyê",
      specificFeedback: "Feedback vekirî",
      submittedAt: "Hat şandin li",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  my: { //Burmese
    translation: {
      welcome: "မင်္ဂလာပါ {{name}}!",
      today: "ယနေ့ {{date}} ဖြစ်သည်။",
      trackingCompleted: "ကောင်းပါသည်! သင်သည် ဒီအပတ်၏ ထိန်းသိမ်းရေးအစီအစဉ်ကို ပြီးစီးခဲ့သည်။",
      trackingNotCompleted: "သင်သည် ဒီအပတ်၏ ထိန်းသိမ်းရေးအစီအစဉ်ကို ပြီးစီးခြင်း မရှိပါ။",
      faqs: "မကြာခဏမေးလေ့ရှိသောမေးခွန်းများ",
      home: "မူလစာမျက်နှာ",
      trackProgress: "တိုးတက်မှုကိုလိုက်လံကြည့်ရှုရန်",
      progressTrack: "တိုးတက်မှုလိုက်လံခြင်း",
      completeTracking: "အပတ်စဉ်ထိန်းသိမ်းရေးအစီအစဉ် ပြီးစီးပါသလား?",
      giveFeedback: "အကြံပြုချက်ပေးမည်လား?",
      weekFeedback: "အပတ်စဉ်လေ့ကျင့်ခန်းအစီအစဉ် အကြံပြုချက်",
      qOne: "1. 0 ကနေ 5 အထိ အတိုင်းအတာအရ၊ မနေ့ကအပတ်နဲ့ နှိုင်းယှဉ်၍ သင် ဘယ်လောက်တိုးတက်ခဲ့သလဲ?",
      qTwo: "2. 0 ကနေ 5 အထိ အတိုင်းအတာအရ၊ ပေးထားသောဗီဒီယိုများ ဘယ်လောက်ထိရည်ရွယ်ချက်ရှိသလဲ?",
      qThree: "3. တိကျသော အကြံပြုချက်ရှိပါသလား?",
      cancel: "မလုပ်ပါနှင့်",
      submit: "တင်သွင်းမည်",
      consultations: "အကြံဉာဏ်များ",
      speciality: "အထူးပြု: ",
      location: "တည်နေရာ: ",
      consultationTag: "သင်၏ ကိုယ်တိုင့်ဖိဇိုသရပ်ဆေးကုထုံး အကြံဉာဏ်ကို စီစဉ်ပါ။",
      selectDateTime: "ရက်စွဲနှင့် အချိန်ကို ရွေးချယ်ပါ: ",
      schedule: "စီစဉ်မည်",
      scheduleWith: "နှင့် အကြံဉာဏ် စီစဉ်မည်: ",
      videoLibrary: "ဗီဒီယို စာကြည့်တိုက်",
      selectCategory: "ဗီဒီယိုများကြည့်ရန် အမျိုးအစားရွေးချယ်ပါ:",
      resistance: "တုန့်ပြန်ခန္ဓာကိုယ်လေ့ကျင့်ခန်းများ",
      stretching: "တိုးလျှော့လေ့ကျင့်ခန်းများ",
      strengthening: "ကြံ့ခိုင်စေရေးလေ့ကျင့်ခန်းများ",
      functional: "လည်ပတ်နိုင်သော လေ့ကျင့်ခန်းများ",
      balanceNeuromuscular: "ချိန်ညှိမှုနှင့် နို့ကြည့်ကြည့်လေ့ကျင့်ခန်းများ",
      backCategories: "အမျိုးအစားများသို့ ပြန်သွားရန်",
      watchVideo: "ဗီဒီယိုကြည့်ပါ",
      watched: "ကြည့်ပြီး",
      gFeedback: "အကြံပြုချက်ပေးပါ",
      rate: "အဆင့်ပေးပါ: ",
      selectRating: "အဆင့်ရွေးပါ: ",
      submitRating: "အဆင့်တင်ပါ",
      noVideos: "ဤအမျိုးအစားအတွက်ဗီဒီယိုမရှိပါ။",
      userProfile: "အသုံးပြုသူပရိုဖိုင်",
      editProfile: "ပရိုဖိုင်ပြင်ပါ",
      profilePicture: "ပရိုဖိုင်ပုံ: ",
      noFileChosen: "ဖိုင်မရွေးထားပါ",
      chooseFile: "ဖိုင်ရွေးပါ",
      firstName: "နာမည်: ",
      lastName: "အမည်နောက်: ",
      email: "အီးမေးလ်: ",
      sex: "ကျား/မ: ",
      selectSex: "ကျား/မရွေးပါ",
      male: "ကျား",
      female: "မ",
      dob: "မွေးသက္ကရာဇ်: ",
      height: "အမြင့် (cm): ",
      weight: "အလေးချိန် (kg): ",
      firstNameRequired: "နာမည်လိုအပ်သည်",
      lastNameRequired: "နောက်အမည်လိုအပ်သည်",
      emailRequired: "အီးမေးလ်လိုအပ်သည်",
      sexRequired: "ကျား/မလိုအပ်သည်",
      dobRequired: "မွေးသက္ကရာဇ်လိုအပ်သည်",
      dobCorrect: "မှန်ကန်သော မွေးသက္ကရာဇ်ကို ရိုက်ထည့်ပါ",
      heightRequired: "အမြင့်လိုအပ်သည်",
      heightCorrect: "မှန်ကန်သော အမြင့်ကို ရိုက်ထည့်ပါ",
      weightRequired: "အလေးချိန်လိုအပ်သည်",
      weightCorrect: "မှန်ကန်သော အလေးချိန်ကို ရိုက်ထည့်ပါ",
      saveProfile: "ပရိုဖိုင်သိမ်းဆည်းပါ",
      profileSaved: "ပရိုဖိုင် သိမ်းဆည်းပြီးပါပြီ!",
      noImage: "ပုံမရှိ",
      settings: "ဆက်တင်များ",
      darkMode: "မှောင်မိုက်မှု",
      language: "ဘာသာစကား",
      notificationPreference: "အသိပေးချက်နှစ်သက်မှု",
      lightMode: "အလင်းမုဒ်",
      emaiL: "အီးမေးလ်",
      phone: "ဖုန်းနံပါတ်",
      both: "နှစ်ခုလုံး",
      login: "လော့ဂ်အင်",
      register: "စာရင်းသွင်းရန်",
      firstname: "နာမည်",
      lastname: "မိသားစုအမည်",
      password: "စကားဝှက်: ",
      invalidCredentials: "အီးမေးလ် သို့မဟုတ် စကားဝှက်မမှန်ပါ",
      fillAllFields: "ကျေးဇူးပြု၍ အကွက်အားလုံးကိုဖြည့်ပါ",
      dontHaveAccount: "အကောင့်မရှိပါလား? ",
      alreadyHaveAccount: "အကောင့်ရှိပြီးပါပြီ? ",
      registerHere: "ဒီမှာစာရင်းသွင်းပါ",
      loginHere: "ဒီမှာလော့ဂ်အင်လုပ်ပါ",
      messages: "ချက်(စ်)",
      directMessages: "တိုက်ရိုက်မက်ဆေ့ချ်",
      typeYourMessage: "သင့်မက်ဆေ့ချ်ကိုရိုက်ထည့်ပါ...",
      you: "သင်",
      send: "ပို့ပါ",
      patient: "လူနာ",
      physio: "ရုပ်ပိုင်းဆိုင်ရာကုထုံးပညာရှင်",
      selectRole: "အခန်းကဏ္ဍရွေးပါ",
      reportFeedback: "တင်ပြချက်",
      name: "နာမည်: ",
      reportType: "တင်ပြချက်အမျိုးအစား ရွေးပါ: ",
      errorBug: "ပြဿနာ/အမှား",
      misbehaviourAbuse: "မလိုလားအပ်သောအပြုအမူ/ဆက်ဆံမှုပျက်ကွက်ခြင်း",
      issueDescription: "ပြဿနာဖော်ပြချက်: ",
      trackPatients: "လူနာများကိုလိုက်လံကြည့်ရှုခြင်း",
      physioProfile: "ရုပ်ပိုင်းဆိုင်ရာကုထုံးပညာရှင်ပရိုဖိုင်း",
      allocation: "သင့်အားချထားပါသည် ",
      patients: " လူနာများ",
      youHave: "သင့်တွင်ရှိသည် ",
      consultationsMonth: "လအတွင်းအကြံပြုချက်များ",
      slotsAvailable: "ရရှိနိုင်သည့်နေရာများ",
      patientsTrack: "လူနာအစီရင်ခံစာများ",
      change: "ပြောင်းပါ",
      remove: "ဖယ်ရှားပါ",
      addSlots: "နေရာများထည့်ပါ",
      removeSlots: "နေရာများဖယ်ရှားပါ",
      welcomeDr: "မင်္ဂလာပါ ဒေါက်တာ {{name}}!",
      enterSpeciality: "အထူးပြုဘာသာရပ်ထည့်ပါ",
      yearsOfExperience: "အတွေ့အကြုံနှစ်များ: ",
      enterYearsOfExperience: "အတွေ့အကြုံနှစ်များထည့်ပါ...",
      neurologicalDisorder: "နယူးရိုလိုဂျီဆိုင်ရာပြဿနာ",
      geriatrics: "အိုမင်းဆိုင်ရာ",
      cardiovascularPulmonaryPhysiotherapy: "နှလုံးနှင့်ရှူလမ်းအခြေခံရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      pediatricPhysiotherapy: "ကလေးရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      musculoskeletalPhysiotherapy: "အရိုး၊ကြွက်သားနှင့်ရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      sportsPhysiotherapy: "အားကစားရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      cardiovascularDisease: "နှလုံးရောဂါ",
      orthopedics: "အရိုးအဆစ်ဆိုင်ရာ",
      vestibularRehabilitation: "နားလည်ရုပ်ပိုင်းဆိုင်ရာပြန်လည်ကောင်းမွန်စေမှု",
      homecarePhysiotherapy: "အိမ်တွင်းရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      pediatrics: "ကလေးဆိုင်ရာ",
      pelvicFloor: "ရုပ်ပိုင်းဆိုင်ရာ အောက်ခံ",
      womensHealthPhysiotherapy: "မိန်းကလေးများအတွက်ရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      acupuncture: "သွန်ဖြတ်ကုထုံး",
      magneticTherapy: "သံလိုက်ကုထုံး",
      manualTherapy: "လက်ဖြင့်ကုထုံး",
      oncology: "ကင်ဆာပညာ",
      postOperativePhysiotherapist: "အင်္ဂါရပ်နောက်က ရုပ်ပိုင်းဆိုင်ရာကုထုံး",
      rehabilitation: "ပြန်လည်ကောင်းမွန်ရေး",
      chestPhysiotherapy: "ရုပ်ပိုင်းဆိုင်ရာ ဆူး",
      womensHealth: "မိန်းကလေးများ၏ကျန်းမာရေး",
      pleaseAnswerAllQuestions: "ကျေးဇူးပြု၍ မေးခွန်းအားလုံးကိုဖြေပါ",
      physioTrackProgress: "လူနာအစီရင်ခံစာများ",
      noReportsFound: "အစီရင်ခံစာ မတွေ့ပါ",
      question1: "အပတ်စဉ်တိုးတက်မှု",
      question2: "ဗွီဒီယိုကျေနပ်မှု",
      specificFeedback: "ဖွင့်လှစ်သောတုံ့ပြန်ချက်",
      submittedAt: "တင်သွင်းသည့်အချိန်",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  nl: { //Dutch
    translation: {
      welcome: "Hallo {{name}}!",
      today: "Vandaag is het {{date}}.",
      trackingCompleted: "Goed gedaan! Je hebt het trackingplan van deze week voltooid.",
      trackingNotCompleted: "Je hebt het trackingplan van deze week niet voltooid.",
      faqs: "Veelgestelde Vragen",
      home: "Startpagina",
      trackProgress: "Volg Voortgang",
      progressTrack: "Voortgangscontrole",
      completeTracking: "Wekelijks trackingplan voltooid?",
      giveFeedback: "Feedback geven?",
      weekFeedback: "Feedback op wekelijks oefenplan",
      qOne: "1. Op een schaal van 0 tot 5, hoeveel ben je verbeterd vergeleken met vorige week?",
      qTwo: "2. Op een schaal van 0 tot 5, hoe effectief waren de video's die werden getoond?",
      qThree: "3. Specifieke feedback?",
      cancel: "Annuleren",
      submit: "Verzenden",
      consultations: "Consultaties",
      speciality: "Specialiteit: ",
      location: "Locatie: ",
      consultationTag: "Plan je persoonlijke fysiotherapiesessie.",
      selectDateTime: "Selecteer Datum en Tijd: ",
      schedule: "Plannen",
      scheduleWith: "Plan Consultatie met ",
      videoLibrary: "Videobibliotheek",
      selectCategory: "Selecteer een categorie om video's te bekijken:",
      resistance: "Weerstandsoefeningen",
      stretching: "Rekoefeningen",
      strengthening: "Versterkingsoefeningen",
      functional: "Functionele oefeningen",
      balanceNeuromuscular: "Balans- & neuromuskulære oefeningen",
      backCategories: "Terug naar Categorieën",
      watchVideo: "Bekijk Video",
      watched: "Bekeken",
      gFeedback: "Feedback geven",
      rate: "Beoordeel: ",
      selectRating: "Selecteer Beoordeling: ",
      submitRating: "Verzend Beoordeling",
      noVideos: "Geen video's beschikbaar voor deze categorie.",
      userProfile: "Gebruikersprofiel",
      editProfile: "Profiel bewerken",
      profilePicture: "Profielfoto: ",
      noFileChosen: "Geen bestand gekozen",
      chooseFile: "Kies bestand",
      firstName: "Voornaam: ",
      lastName: "Achternaam: ",
      email: "E-mail: ",
      sex: "Geslacht: ",
      selectSex: "Selecteer Geslacht",
      male: "Man",
      female: "Vrouw",
      dob: "Geboortedatum: ",
      height: "Lengte (cm): ",
      weight: "Gewicht (kg): ",
      firstNameRequired: "Voornaam is verplicht",
      lastNameRequired: "Achternaam is verplicht",
      emailRequired: "E-mail is verplicht",
      sexRequired: "Geslacht is verplicht",
      dobRequired: "Geboortedatum is verplicht",
      dobCorrect: "Voer een correcte geboortedatum in",
      heightRequired: "Lengte is verplicht",
      heightCorrect: "Voer een correcte lengte in",
      weightRequired: "Gewicht is verplicht",
      weightCorrect: "Voer een correct gewicht in",
      saveProfile: "Profiel opslaan",
      profileSaved: "Profiel opgeslagen!",
      noImage: "Geen afbeelding",
      settings: "Instellingen",
      darkMode: "Donkere modus",
      language: "Taal",
      notificationPreference: "Meldingsvoorkeur",
      lightMode: "Licht modus",
      emaiL: "Email",
      phone: "Telefoonnummer",
      both: "Beide",
      login: "Inloggen",
      register: "Registreren",
      firstname: "Voornaam",
      lastname: "Achternaam",
      password: "Wachtwoord: ",
      invalidCredentials: "Ongeldig email of wachtwoord",
      fillAllFields: "Vul alle velden in",
      dontHaveAccount: "Heb je geen account? ",
      alreadyHaveAccount: "Heb je al een account? ",
      registerHere: "Registreer hier",
      loginHere: "Log hier in",
      messages: "Chat",
      directMessages: "Directe berichten",
      typeYourMessage: "Typ je bericht...",
      you: "Jij",
      send: "Verzenden",
      patient: "Patiënt",
      physio: "Fysiotherapeut",
      selectRole: "Selecteer rol",
      reportFeedback: "Rapporteren",
      name: "Naam: ",
      reportType: "Selecteer rapporttype: ",
      errorBug: "Bug/Fout",
      misbehaviourAbuse: "Misdraging/Misbruik",
      issueDescription: "Probleembeschrijving: ",
      trackPatients: "Volg patiënten",
      physioProfile: "Fysiotherapeut profiel",
      allocation: "Je bent toegewezen aan ",
      patients: " patiënten",
      youHave: "Je hebt ",
      consultationsMonth: " consultaties deze maand",
      slotsAvailable: " beschikbare slots",
      patientsTrack: "Patiëntrapporten",
      change: "Wijzig",
      remove: "Verwijder",
      addSlots: "Voeg slots toe",
      removeSlots: "Verwijder slots",
      welcomeDr: "Hallo Dr. {{name}}!",
      enterSpeciality: "Voer specialiteit in",
      yearsOfExperience: "Jaren ervaring: ",
      enterYearsOfExperience: "Voer jaren ervaring in...",
      neurologicalDisorder: "Neurologische aandoening",
      geriatrics: "Geriatrie",
      cardiovascularPulmonaryPhysiotherapy: "Cardiovasculaire en pulmonale fysiotherapie",
      pediatricPhysiotherapy: "Pediatrische fysiotherapie",
      musculoskeletalPhysiotherapy: "Muskuloskeletale fysiotherapie",
      sportsPhysiotherapy: "Sportfysiotherapie",
      cardiovascularDisease: "Cardiovasculaire ziekte",
      orthopedics: "Orthopedie",
      vestibularRehabilitation: "Vestibulaire revalidatie",
      homecarePhysiotherapy: "Fysiotherapie thuis",
      pediatrics: "Kindergeneeskunde",
      pelvicFloor: "Bekkenbodem",
      womensHealthPhysiotherapy: "Fysiotherapie voor vrouwen",
      acupuncture: "Acupunctuur",
      magneticTherapy: "Magnetische therapie",
      manualTherapy: "Manuele therapie",
      oncology: "Oncologie",
      postOperativePhysiotherapist: "Postoperatieve fysiotherapeut",
      rehabilitation: "Revalidatie",
      chestPhysiotherapy: "Borsten fysiotherapie",
      womensHealth: "Vrouwengezondheid",
      pleaseAnswerAllQuestions: "Beantwoord alle vragen",
      physioTrackProgress: "Patiëntrapporten",
      noReportsFound: "Geen rapporten gevonden",
      question1: "Weekelijkse verbetering",
      question2: "Videotilfredshet",
      specificFeedback: "Open feedback",
      submittedAt: "Ingediend op",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  no: { //Norwegian
    translation: {
      welcome: "Hei {{name}}!",
      today: "I dag er det {{date}}.",
      trackingCompleted: "Bra jobbet! Du har fullført denne ukens sporingsplan.",
      trackingNotCompleted: "Du har ikke fullført denne ukens sporingsplan.",
      faqs: "Ofte stilte spørsmål",
      home: "Hjem",
      trackProgress: "Følg fremgang",
      progressTrack: "Fremgangssporing",
      completeTracking: "Er den ukentlige sporingsplanen fullført?",
      giveFeedback: "Gi tilbakemelding?",
      weekFeedback: "Tilbakemelding på ukentlig treningsplan",
      qOne: "1. På en skala fra 0 til 5, hvor mye har du forbedret deg sammenlignet med forrige uke?",
      qTwo: "2. På en skala fra 0 til 5, hvor effektive var videoene som ble gitt?",
      qThree: "3. Noen spesifikke tilbakemeldinger?",
      cancel: "Avbryt",
      submit: "Send",
      consultations: "Konsultasjoner",
      speciality: "Spesialitet: ",
      location: "Sted: ",
      consultationTag: "Planlegg din personlige fysioterapikonsultasjon.",
      selectDateTime: "Velg dato og tid: ",
      schedule: "Planlegg",
      scheduleWith: "Planlegg konsultasjon med ",
      videoLibrary: "Videobibliotek",
      selectCategory: "Velg en kategori for å se videoer:",
      resistance: "Motstandsøvelser",
      stretching: "Tøyeøvelser",
      strengthening: "Styrkeøvelser",
      functional: "Funksjonelle øvelser",
      balanceNeuromuscular: "Balans- og nevromuskulære øvelser",
      backCategories: "Tilbake til kategorier",
      watchVideo: "Se video",
      watched: "Sett",
      gFeedback: "Gi tilbakemelding",
      rate: "Vurder: ",
      selectRating: "Velg vurdering: ",
      submitRating: "Send vurdering",
      noVideos: "Ingen videoer tilgjengelig for denne kategorien.",
      userProfile: "Brukerprofil",
      editProfile: "Rediger profil",
      profilePicture: "Profilbilde: ",
      noFileChosen: "Ingen fil valgt",
      chooseFile: "Velg fil",
      firstName: "Fornavn: ",
      lastName: "Etternavn: ",
      email: "E-post: ",
      sex: "Kjønn: ",
      selectSex: "Velg kjønn",
      male: "Mann",
      female: "Kvinne",
      dob: "Fødselsdato: ",
      height: "Høyde (cm): ",
      weight: "Vekt (kg): ",
      firstNameRequired: "Fornavn er påkrevd",
      lastNameRequired: "Etternavn er påkrevd",
      emailRequired: "E-post er påkrevd",
      sexRequired: "Kjønn er påkrevd",
      dobRequired: "Fødselsdato er påkrevd",
      dobCorrect: "Vennligst oppgi en korrekt fødselsdato",
      heightRequired: "Høyde er påkrevd",
      heightCorrect: "Vennligst oppgi en korrekt høyde",
      weightRequired: "Vekt er påkrevd",
      weightCorrect: "Vennligst oppgi en korrekt vekt",
      saveProfile: "Lagre profil",
      profileSaved: "Profil lagret!",
      noImage: "Ingen bilde",
      settings: "Innstillinger",
      darkMode: "Mørk modus",
      language: "Språk",
      notificationPreference: "Varslingspreferanse",
      lightMode: "Lysmodus",
      emaiL: "E-post",
      phone: "Telefonnummer",
      both: "Begge",
      login: "Logg inn",
      register: "Registrer deg",
      firstname: "Fornavn",
      lastname: "Etternavn",
      password: "Passord: ",
      invalidCredentials: "Ugyldig e-post eller passord",
      fillAllFields: "Vennligst fyll ut alle feltene",
      dontHaveAccount: "Har du ikke en konto? ",
      alreadyHaveAccount: "Har du allerede en konto? ",
      registerHere: "Registrer deg her",
      loginHere: "Logg inn her",
      messages: "Chat",
      directMessages: "Direktemeldinger",
      typeYourMessage: "Skriv din melding...",
      you: "Du",
      send: "Send",
      patient: "Pasient",
      physio: "Fysioterapeut",
      selectRole: "Velg rolle",
      reportFeedback: "Rapporter",
      name: "Navn: ",
      reportType: "Velg rapporttype: ",
      errorBug: "Feil/Bug",
      misbehaviourAbuse: "Feil oppførsel/Misbruk",
      issueDescription: "Beskrivelse av problem: ",
      trackPatients: "Spor pasienter",
      physioProfile: "Fysioterapeutprofil",
      allocation: "Du er tildelt ",
      patients: " pasienter",
      youHave: "Du har ",
      consultationsMonth: " konsultasjoner denne måneden",
      slotsAvailable: " ledige plasser",
      patientsTrack: "Pasientrapporter",
      change: "Endre",
      remove: "Fjern",
      addSlots: "Legg til plasser",
      removeSlots: "Fjern plasser",
      welcomeDr: "Hei Dr. {{name}}!",
      enterSpeciality: "Skriv inn spesialitet",
      yearsOfExperience: "Erfaringsår: ",
      enterYearsOfExperience: "Skriv inn antall erfaringsår...",
      neurologicalDisorder: "Nevrologisk lidelse",
      geriatrics: "Geriatri",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskulær og pulmonal fysioterapi",
      pediatricPhysiotherapy: "Pediatrisk fysioterapi",
      musculoskeletalPhysiotherapy: "Muskuloskeletal fysioterapi",
      sportsPhysiotherapy: "Sportsfysioterapi",
      cardiovascularDisease: "Kardiovaskulær sykdom",
      orthopedics: "Ortopedi",
      vestibularRehabilitation: "Vestibulær rehabilitering",
      homecarePhysiotherapy: "Hjemmefysioterapi",
      pediatrics: "Pediatri",
      pelvicFloor: "Bekkenbunn",
      womensHealthPhysiotherapy: "Fysioterapi for kvinners helse",
      acupuncture: "Akupunktur",
      magneticTherapy: "Magnetisk terapi",
      manualTherapy: "Manuell terapi",
      oncology: "Onkologi",
      postOperativePhysiotherapist: "Postoperativ fysioterapeut",
      rehabilitation: "Rehabilitering",
      chestPhysiotherapy: "Brystfysioterapi",
      womensHealth: "Kvinners helse",
      pleaseAnswerAllQuestions: "Vennligst svar på alle spørsmål",
      physioTrackProgress: "Pasientrapporter",
      noReportsFound: "Ingen rapporter funnet",
      question1: "Ukentlig forbedring",
      question2: "Videotilfredshet",
      specificFeedback: "Åpen tilbakemelding",
      submittedAt: "Innsendt",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  pl: { //Polish
    translation: {
      welcome: "Cześć {{name}}!",
      today: "Dzisiaj jest {{date}}.",
      trackingCompleted: "Dobra robota! Ukończyłeś plan śledzenia na ten tydzień.",
      trackingNotCompleted: "Nie ukończyłeś planu śledzenia na ten tydzień.",
      faqs: "Najczęściej zadawane pytania",
      home: "Strona główna",
      trackProgress: "Śledź postępy",
      progressTrack: "Monitorowanie postępów",
      completeTracking: "Czy ukończyłeś tygodniowy plan śledzenia?",
      giveFeedback: "Czy chcesz dać opinię?",
      weekFeedback: "Opinie dotyczące tygodniowego planu ćwiczeń",
      qOne: "1. Na skali od 0 do 5, o ile poprawiłeś się w porównaniu z zeszłym tygodniem?",
      qTwo: "2. Na skali od 0 do 5, jak skuteczne były podane filmy?",
      qThree: "3. Czy masz jakieś konkretne uwagi?",
      cancel: "Anuluj",
      submit: "Wyślij",
      consultations: "Konsultacje",
      speciality: "Specjalność: ",
      location: "Lokalizacja: ",
      consultationTag: "Umów się na osobistą konsultację fizjoterapeutyczną.",
      selectDateTime: "Wybierz datę i godzinę: ",
      schedule: "Umów",
      scheduleWith: "Umów konsultację z ",
      videoLibrary: "Biblioteka Wideo",
      selectCategory: "Wybierz kategorię do oglądania filmów:",
      resistance: "Ćwiczenia oporowe",
      stretching: "Ćwiczenia rozciągające",
      strengthening: "Ćwiczenia wzmacniające",
      functional: "Ćwiczenia funkcjonalne",
      balanceNeuromuscular: "Ćwiczenia równowagi i neuromięśniowe",
      backCategories: "Powrót do kategorii",
      watchVideo: "Obejrzyj film",
      watched: "Obejrzane",
      gFeedback: "Daj opinię",
      rate: "Oceń: ",
      selectRating: "Wybierz ocenę: ",
      submitRating: "Wyślij ocenę",
      noVideos: "Brak filmów dostępnych dla tej kategorii.",
      userProfile: "Profil użytkownika",
      editProfile: "Edytuj profil",
      profilePicture: "Zdjęcie profilowe: ",
      noFileChosen: "Nie wybrano pliku",
      chooseFile: "Wybierz plik",
      firstName: "Imię: ",
      lastName: "Nazwisko: ",
      email: "Email: ",
      sex: "Płeć: ",
      selectSex: "Wybierz płeć",
      male: "Męska",
      female: "Kobieca",
      dob: "Data urodzenia: ",
      height: "Wzrost (cm): ",
      weight: "Waga (kg): ",
      firstNameRequired: "Imię jest wymagane",
      lastNameRequired: "Nazwisko jest wymagane",
      emailRequired: "Email jest wymagany",
      sexRequired: "Płeć jest wymagana",
      dobRequired: "Data urodzenia jest wymagana",
      dobCorrect: "Proszę podać poprawną datę urodzenia",
      heightRequired: "Wzrost jest wymagany",
      heightCorrect: "Proszę podać poprawny wzrost",
      weightRequired: "Waga jest wymagana",
      weightCorrect: "Proszę podać poprawną wagę",
      saveProfile: "Zapisz profil",
      profileSaved: "Profil zapisany!",
      noImage: "Brak obrazu",
      settings: "Ustawienia",
      darkMode: "Ciemny tryb",
      language: "Język",
      notificationPreference: "Preferencje powiadomień",
      lightMode: "Tryb jasny",
      emaiL: "Email",
      phone: "Numer telefonu",
      both: "Oboje",
      login: "Zaloguj się",
      register: "Zarejestruj się",
      firstname: "Imię",
      lastname: "Nazwisko",
      password: "Hasło: ",
      invalidCredentials: "Nieprawidłowy email lub hasło",
      fillAllFields: "Proszę wypełnić wszystkie pola",
      dontHaveAccount: "Nie masz konta? ",
      alreadyHaveAccount: "Masz już konto? ",
      registerHere: "Zarejestruj się tutaj",
      loginHere: "Zaloguj się tutaj",
      messages: "Czat",
      directMessages: "Wiadomości bezpośrednie",
      typeYourMessage: "Wpisz swoją wiadomość...",
      you: "Ty",
      send: "Wyślij",
      patient: "Pacjent",
      physio: "Fizjoterapeuta",
      selectRole: "Wybierz rolę",
      reportFeedback: "Zgłoś",
      name: "Imię: ",
      reportType: "Wybierz typ zgłoszenia: ",
      errorBug: "Błąd/Problem",
      misbehaviourAbuse: "Niewłaściwe zachowanie/Nadużycie",
      issueDescription: "Opis problemu: ",
      trackPatients: "Śledź pacjentów",
      physioProfile: "Profil fizjoterapeuty",
      allocation: "Przydzielono ci ",
      patients: " pacjentów.",
      youHave: "Masz ",
      consultationsMonth: " konsultacje w tym miesiącu.",
      slotsAvailable: " wolne miejsca.",
      patientsTrack: "Raporty pacjentów",
      change: "Zmień",
      remove: "Usuń",
      addSlots: "Dodaj miejsca",
      removeSlots: "Usuń miejsca",
      welcomeDr: "Witaj dr. {{name}}!",
      enterSpeciality: "Wprowadź specjalizację",
      yearsOfExperience: "Lata doświadczenia: ",
      enterYearsOfExperience: "Wprowadź lata doświadczenia...",
      neurologicalDisorder: "Zaburzenie neurologiczne",
      geriatrics: "Geriatria",
      cardiovascularPulmonaryPhysiotherapy: "Fizjoterapia sercowo-naczyniowo-płucna",
      pediatricPhysiotherapy: "Fizjoterapia pediatryczna",
      musculoskeletalPhysiotherapy: "Fizjoterapia mięśniowo-szkieletowa",
      sportsPhysiotherapy: "Fizjoterapia sportowa",
      cardiovascularDisease: "Choroba sercowo-naczyniowa",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Rehabilitacja przedsionkowa",
      homecarePhysiotherapy: "Fizjoterapia domowa",
      pediatrics: "Pediatria",
      pelvicFloor: "Mięśnie dna miednicy",
      womensHealthPhysiotherapy: "Fizjoterapia zdrowia kobiet",
      acupuncture: "Akupunktura",
      magneticTherapy: "Terapia magnetyczna",
      manualTherapy: "Terapia manualna",
      oncology: "Onkologia",
      postOperativePhysiotherapist: "Fizjoterapeuta po operacji",
      rehabilitation: "Rehabilitacja",
      chestPhysiotherapy: "Fizjoterapia klatki piersiowej",
      womensHealth: "Zdrowie kobiet",
      pleaseAnswerAllQuestions: "Proszę odpowiedzieć na wszystkie pytania",
      physioTrackProgress: "Raporty pacjentów",
      noReportsFound: "Nie znaleziono raportów",
      question1: "Poprawa tygodniowa",
      question2: "Satysfakcja z wideo",
      specificFeedback: "Otwarta opinia",
      submittedAt: "Przesłano o",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  pt: { //Portuguese
    translation: {
      welcome: "Olá {{name}}!",
      today: "Hoje é {{date}}.",
      trackingCompleted: "Bom trabalho! Concluiu o plano de monitorização desta semana.",
      trackingNotCompleted: "Não concluiu o plano de monitorização desta semana.",
      faqs: "Perguntas Frequentes",
      home: "Início",
      trackProgress: "Acompanhar o Progresso",
      progressTrack: "Monitorização do Progresso",
      completeTracking: "Você completou o plano de monitorização semanal?",
      giveFeedback: "Dar feedback?",
      weekFeedback: "Feedback sobre o plano de exercícios semanal",
      qOne: "1. Numa escala de 0 a 5, quanto melhorou em comparação com a semana passada?",
      qTwo: "2. Numa escala de 0 a 5, quão eficazes foram os vídeos apresentados?",
      qThree: "3. Algum feedback específico?",
      cancel: "Cancelar",
      submit: "Enviar",
      consultations: "Consultas",
      speciality: "Especialidade: ",
      location: "Localização: ",
      consultationTag: "Agende a sua consulta presencial de fisioterapia.",
      selectDateTime: "Selecione a data e hora: ",
      schedule: "Agendar",
      scheduleWith: "Agende uma consulta com ",
      videoLibrary: "Biblioteca de Vídeos",
      selectCategory: "Selecione uma categoria para ver os vídeos:",
      resistance: "Exercícios de resistência",
      stretching: "Exercícios de alongamento",
      strengthening: "Exercícios de fortalecimento",
      functional: "Exercícios funcionais",
      balanceNeuromuscular: "Exercícios de equilíbrio e neuromusculares",
      backCategories: "Voltar às categorias",
      watchVideo: "Assistir ao vídeo",
      watched: "Visto",
      gFeedback: "Dar feedback",
      rate: "Avaliação: ",
      selectRating: "Selecione uma avaliação: ",
      submitRating: "Enviar avaliação",
      noVideos: "Não há vídeos disponíveis para esta categoria.",
      userProfile: "Perfil do Utilizador",
      editProfile: "Editar Perfil",
      profilePicture: "Foto de Perfil: ",
      noFileChosen: "Nenhum ficheiro selecionado",
      chooseFile: "Escolher ficheiro",
      firstName: "Primeiro Nome: ",
      lastName: "Último Nome: ",
      email: "Email: ",
      sex: "Sexo: ",
      selectSex: "Selecione o sexo",
      male: "Masculino",
      female: "Feminino",
      dob: "Data de Nascimento: ",
      height: "Altura (cm): ",
      weight: "Peso (kg): ",
      firstNameRequired: "O primeiro nome é obrigatório",
      lastNameRequired: "O sobrenome é obrigatório",
      emailRequired: "O email é obrigatório",
      sexRequired: "O sexo é obrigatório",
      dobRequired: "A data de nascimento é obrigatória",
      dobCorrect: "Por favor, insira uma data de nascimento correta",
      heightRequired: "A altura é obrigatória",
      heightCorrect: "Por favor, insira uma altura correta",
      weightRequired: "O peso é obrigatório",
      weightCorrect: "Por favor, insira um peso correto",
      saveProfile: "Guardar perfil",
      profileSaved: "Perfil guardado!",
      noImage: "Sem imagem",
      settings: "Configurações",
      darkMode: "Modo Escuro",
      language: "Idioma",
      notificationPreference: "Preferência de Notificação",
      lightMode: "Modo Claro",
      emaiL: "Email",
      phone: "Número de Telefone",
      both: "Ambos",
      login: "Entrar",
      register: "Registar",
      firstname: "Primeiro Nome",
      lastname: "Último Nome",
      password: "Palavra-passe: ",
      invalidCredentials: "Email ou palavra-passe inválidos",
      fillAllFields: "Por favor, preencha todos os campos",
      dontHaveAccount: "Não tem conta? ",
      alreadyHaveAccount: "Já tem conta? ",
      registerHere: "Registe-se aqui",
      loginHere: "Entre aqui",
      messages: "Chat",
      directMessages: "Mensagens Diretas",
      typeYourMessage: "Digite a sua mensagem...",
      you: "Você",
      send: "Enviar",
      patient: "Paciente",
      physio: "Fisioterapeuta",
      selectRole: "Selecionar Função",
      reportFeedback: "Reportar",
      name: "Nome: ",
      reportType: "Selecionar Tipo de Reporte: ",
      errorBug: "Erro/Bug",
      misbehaviourAbuse: "Mau Comportamento/Abuso",
      issueDescription: "Descrição do Problema: ",
      trackPatients: "Acompanhar Pacientes",
      physioProfile: "Perfil do Fisioterapeuta",
      allocation: "Você está alocado para ",
      patients: " pacientes.",
      youHave: "Você tem ",
      consultationsMonth: " consultas este mês.",
      slotsAvailable: " vagas disponíveis.",
      patientsTrack: "Relatórios dos Pacientes",
      change: "Alterar",
      remove: "Remover",
      addSlots: "Adicionar Vagas",
      removeSlots: "Remover Vagas",
      welcomeDr: "Olá Dr. {{name}}!",
      enterSpeciality: "Insira a Especialidade",
      yearsOfExperience: "Anos de Experiência: ",
      enterYearsOfExperience: "Insira os Anos de Experiência...",
      neurologicalDisorder: "Transtorno Neurológico",
      geriatrics: "Geriatria",
      cardiovascularPulmonaryPhysiotherapy: "Fisioterapia Cardiovascular e Pulmonar",
      pediatricPhysiotherapy: "Fisioterapia Pediátrica",
      musculoskeletalPhysiotherapy: "Fisioterapia Musculoesquelética",
      sportsPhysiotherapy: "Fisioterapia Esportiva",
      cardiovascularDisease: "Doença Cardiovascular",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Reabilitação Vestibular",
       homecarePhysiotherapy: "Fisioterapia Domiciliar",
      pediatrics: "Pediatria",
      pelvicFloor: "Assoalho Pélvico",
      womensHealthPhysiotherapy: "Fisioterapia para a Saúde da Mulher",
      acupuncture: "Acupuntura",
      magneticTherapy: "Terapia Magnética",
      manualTherapy: "Terapia Manual",
      oncology: "Oncologia",
      postOperativePhysiotherapist: "Fisioterapia Pós-operatória",
      rehabilitation: "Reabilitação",
      chestPhysiotherapy: "Fisioterapia Torácica",
      womensHealth: "Saúde da Mulher",
      pleaseAnswerAllQuestions: "Por favor, responda a todas as perguntas",
      physioTrackProgress: "Relatórios dos Pacientes",
      noReportsFound: "Nenhum relatório encontrado",
      question1: "Melhoria semanal",
      question2: "Satisfação com o vídeo",
      specificFeedback: "Feedback Aberto",
      submittedAt: "Enviado às",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ro: { //Romanian
    translation: {
      welcome: "Salut {{name}}!",
      today: "Astăzi este {{date}}.",
      trackingCompleted: "Bravo! Ai finalizat planul de urmărire al acestei săptămâni.",
      trackingNotCompleted: "Nu ai finalizat planul de urmărire al acestei săptămâni.",
      faqs: "Întrebări frecvente",
      home: "Acasă",
      trackProgress: "Urmărește progresul",
      progressTrack: "Monitorizarea progresului",
      completeTracking: "Ai finalizat planul săptămânal de urmărire?",
      giveFeedback: "Vrei să oferi feedback?",
      weekFeedback: "Feedback pentru planul de exerciții săptămânal",
      qOne: "1. Pe o scară de la 0 la 5, cât de mult te-ai îmbunătățit față de săptămâna trecută?",
      qTwo: "2. Pe o scară de la 0 la 5, cât de eficiente au fost videoclipurile oferite?",
      qThree: "3. Ai feedback specific?",
      cancel: "Anulează",
      submit: "Trimite",
      consultations: "Consultații",
      speciality: "Specialitate: ",
      location: "Locație: ",
      consultationTag: "Programează-ți consultația personală de fizioterapie.",
      selectDateTime: "Selectează data și ora: ",
      schedule: "Programează",
      scheduleWith: "Programează consultație cu ",
      videoLibrary: "Biblioteca Video",
      selectCategory: "Selectează o categorie pentru a vizualiza videoclipurile:",
      resistance: "Exerciții de rezistență",
      stretching: "Exerciții de întindere",
      strengthening: "Exerciții de întărire",
      functional: "Exerciții funcționale",
      balanceNeuromuscular: "Exerciții de echilibru și neuromusculare",
      backCategories: "Înapoi la categorii",
      watchVideo: "Urmărește videoclipul",
      watched: "Văzut",
      gFeedback: "Oferă feedback",
      rate: "Evaluează: ",
      selectRating: "Selectează evaluarea: ",
      submitRating: "Trimite evaluarea",
      noVideos: "Nu există videoclipuri disponibile pentru această categorie.",
      userProfile: "Profil utilizator",
      editProfile: "Editează profilul",
      profilePicture: "Fotografie profil: ",
      noFileChosen: "Niciun fișier selectat",
      chooseFile: "Alege fișier",
      firstName: "Prenume: ",
      lastName: "Nume: ",
      email: "Email: ",
      sex: "Sex: ",
      selectSex: "Selectează sexul",
      male: "Masculin",
      female: "Feminin",
      dob: "Data nașterii: ",
      height: "Înălțime (cm): ",
      weight: "Greutate (kg): ",
      firstNameRequired: "Prenumele este obligatoriu",
      lastNameRequired: "Numele este obligatoriu",
      emailRequired: "Emailul este obligatoriu",
      sexRequired: "Sexul este obligatoriu",
      dobRequired: "Data nașterii este obligatorie",
      dobCorrect: "Vă rugăm să introduceți o dată de naștere corectă",
      heightRequired: "Înălțimea este obligatorie",
      heightCorrect: "Vă rugăm să introduceți o înălțime corectă",
      weightRequired: "Greutatea este obligatorie",
      weightCorrect: "Vă rugăm să introduceți o greutate corectă",
      saveProfile: "Salvează profilul",
      profileSaved: "Profil salvat!",
      noImage: "Fără imagine",
      settings: "Setări",
      darkMode: "Mod întunecat",
      language: "Limbă",
      notificationPreference: "Preferință notificări",
      lightMode: "Mod luminos",
      emaiL: "Email",
      phone: "Număr de telefon",
      both: "Ambele",
      login: "Autentificare",
      register: "Înregistrare",
      firstname: "Prenume",
      lastname: "Nume de familie",
      password: "Parolă: ",
      invalidCredentials: "Email sau parolă invalide",
      fillAllFields: "Vă rugăm să completați toate câmpurile",
      dontHaveAccount: "Nu ai cont? ",
      alreadyHaveAccount: "Ai deja cont? ",
      registerHere: "Înregistrează-te aici",
      loginHere: "Autentifică-te aici",
      messages: "Chat",
      directMessages: "Mesagerie directă",
      typeYourMessage: "Tastează mesajul tău...",
      you: "Tu",
      send: "Trimite",
      patient: "Pacient",
      physio: "Fizioterapeut",
      selectRole: "Selectează rol",
      reportFeedback: "Raportează",
      name: "Nume: ",
      reportType: "Selectează tipul de raport: ",
      errorBug: "Eroare/Bug",
      misbehaviourAbuse: "Comportament neadecvat/Abuz",
      issueDescription: "Descrierea problemei: ",
      trackPatients: "Urmărește pacienții",
      physioProfile: "Profil fizioterapeut",
      allocation: "Ești alocat la ",
      patients: " pacienți.",
      youHave: "Ai ",
      consultationsMonth: " consultații în această lună.",
      slotsAvailable: " locuri disponibile.",
      patientsTrack: "Rapoarte pacienți",
      change: "Schimbă",
      remove: "Elimină",
      addSlots: "Adaugă locuri",
      removeSlots: "Elimină locuri",
      welcomeDr: "Bună, Dr. {{name}}!",
      enterSpeciality: "Introdu specialitatea",
      yearsOfExperience: "Ani de experiență: ",
      enterYearsOfExperience: "Introdu anii de experiență...",
      neurologicalDisorder: "Tulburare neurologică",
      geriatrics: "Geriatrie",
      cardiovascularPulmonaryPhysiotherapy: "Fizioterapie cardiovasculară și pulmonară",
      pediatricPhysiotherapy: "Fizioterapie pediatrică",
      musculoskeletalPhysiotherapy: "Fizioterapie musculoscheletală",
      sportsPhysiotherapy: "Fizioterapie sportivă",
      cardiovascularDisease: "Boală cardiovasculară",
      orthopedics: "Ortopedie",
      vestibularRehabilitation: "Reabilitare vestibulară",
      homecarePhysiotherapy: "Fizioterapie la domiciliu",
      pediatrics: "Pediatrie",
      pelvicFloor: "Podeaua pelviană",
      womensHealthPhysiotherapy: "Fizioterapie pentru sănătatea femeilor",
      acupuncture: "Acupunctură",
      magneticTherapy: "Terapie magnetică",
      manualTherapy: "Terapie manuală",
      oncology: "Oncologie",
      postOperativePhysiotherapist: "Fizioterapeut post-operator",
      rehabilitation: "Reabilitare",
      chestPhysiotherapy: "Fizioterapie toracică",
      womensHealth: "Sănătatea femeilor",
      pleaseAnswerAllQuestions: "Vă rugăm să răspundeți la toate întrebările",
      physioTrackProgress: "Rapoarte pacienți",
      noReportsFound: "Nu s-au găsit rapoarte",
      question1: "Îmbunătățire săptămânală",
      question2: "Satisfacție video",
      specificFeedback: "Feedback deschis",
      submittedAt: "Trimis la",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ru: { //Russian
    translation: {
      welcome: "Привет, {{name}}!",
      today: "Сегодня {{date}}",
      trackingCompleted: "Отлично! Вы завершили план отслеживания на эту неделю.",
      trackingNotCompleted: "Вы не завершили план отслеживания на эту неделю.",
      faqs: "Часто задаваемые вопросы",
      home: "Главная",
      trackProgress: "Отслеживать прогресс",
      progressTrack: "Отслеживание прогресса",
      completeTracking: "План еженедельного отслеживания завершён?",
      giveFeedback: "Оставить отзыв?",
      weekFeedback: "Обратная связь по еженедельному плану упражнений",
      qOne: "1. По шкале от 0 до 5, насколько вы улучшились по сравнению с прошлой неделей?",
      qTwo: "2. По шкале от 0 до 5, насколько эффективны были предложенные видео?",
      qThree: "3. Есть ли какие-либо конкретные замечания?",
      cancel: "Отмена",
      submit: "Отправить",
      consultations: "Консультации",
      speciality: "Специализация: ",
      location: "Местоположение: ",
      consultationTag: "Запланируйте личную консультацию по физиотерапии.",
      selectDateTime: "Выберите дату и время: ",
      schedule: "Запланировать",
      scheduleWith: "Запланировать консультацию с ",
      videoLibrary: "Видео библиотека",
      selectCategory: "Выберите категорию для просмотра видео:",
      resistance: "Упражнения на сопротивление",
      stretching: "Упражнения на растяжку",
      strengthening: "Укрепляющие упражнения",
      functional: "Функциональные упражнения",
      balanceNeuromuscular: "Упражнения на баланс и нейромышечное взаимодействие",
      backCategories: "Вернуться к категориям",
      watchVideo: "Смотреть видео",
      watched: "Просмотрено",
      gFeedback: "Оставить отзыв",
      rate: "Оценка: ",
      selectRating: "Выберите оценку: ",
      submitRating: "Отправить оценку",
      noVideos: "Видео для этой категории отсутствуют.",
      userProfile: "Профиль пользователя",
      editProfile: "Редактировать профиль",
      profilePicture: "Фотография профиля: ",
      noFileChosen: "Файл не выбран",
      chooseFile: "Выбрать файл",
      firstName: "Имя: ",
      lastName: "Фамилия: ",
      email: "Электронная почта: ",
      sex: "Пол: ",
      selectSex: "Выберите пол",
      male: "Мужской",
      female: "Женский",
      dob: "Дата рождения: ",
      height: "Рост (см): ",
      weight: "Вес (кг): ",
      firstNameRequired: "Требуется имя",
      lastNameRequired: "Требуется фамилия",
      emailRequired: "Требуется электронная почта",
      sexRequired: "Требуется выбор пола",
      dobRequired: "Требуется дата рождения",
      dobCorrect: "Пожалуйста, введите корректную дату рождения",
      heightRequired: "Требуется рост",
      heightCorrect: "Пожалуйста, введите корректный рост",
      weightRequired: "Требуется вес",
      weightCorrect: "Пожалуйста, введите корректный вес",
      saveProfile: "Сохранить профиль",
      profileSaved: "Профиль сохранён!",
      noImage: "Нет изображения",
      settings: "Настройки",
      darkMode: "Тёмный режим",
      language: "Язык",
      notificationPreference: "Настройки уведомлений",
      lightMode: "Светлый режим",
      emaiL: "Электронная почта",
      phone: "Номер телефона",
      both: "Оба",
      login: "Войти",
      register: "Регистрация",
      firstname: "Имя",
      lastname: "Фамилия",
      password: "Пароль: ",
      invalidCredentials: "Неверный email или пароль",
      fillAllFields: "Пожалуйста, заполните все поля",
      dontHaveAccount: "Нет аккаунта? ",
      alreadyHaveAccount: "Уже есть аккаунт? ",
      registerHere: "Зарегистрируйтесь здесь",
      loginHere: "Войдите здесь",
      messages: "Чат",
      directMessages: "Прямые сообщения",
      typeYourMessage: "Введите ваше сообщение...",
      you: "Вы",
      send: "Отправить",
      patient: "Пациент",
      physio: "Физиотерапевт",
      selectRole: "Выберите роль",
      reportFeedback: "Сообщить",
      name: "Имя: ",
      reportType: "Выберите тип отчёта: ",
      errorBug: "Ошибка/Баг",
      misbehaviourAbuse: "Неподобающее поведение/Злоупотребление",
      issueDescription: "Описание проблемы: ",
      trackPatients: "Отслеживать пациентов",
      physioProfile: "Профиль физиотерапевта",
      allocation: "Вам назначено ",
      patients: " пациентов.",
      youHave: "У вас есть ",
      consultationsMonth: " консультации в этом месяце.",
      slotsAvailable: " доступных мест.",
      patientsTrack: "Отчёты пациентов",
      change: "Изменить",
      remove: "Удалить",
      addSlots: "Добавить места",
      removeSlots: "Удалить места",
      welcomeDr: "Здравствуйте, д-р {{name}}!",
      enterSpeciality: "Введите специализацию",
      yearsOfExperience: "Годы опыта: ",
      enterYearsOfExperience: "Введите годы опыта...",
      neurologicalDisorder: "Неврологическое расстройство",
      geriatrics: "Гериатрия",
      cardiovascularPulmonaryPhysiotherapy: "Кардиоваскулярная и легочная физиотерапия",
      pediatricPhysiotherapy: "Педиатрическая физиотерапия",
      musculoskeletalPhysiotherapy: "Мускулоскелетная физиотерапия",
      sportsPhysiotherapy: "Спортивная физиотерапия",
      cardiovascularDisease: "Сердечно-сосудистое заболевание",
      orthopedics: "Ортопедия",
      vestibularRehabilitation: "Вестибулярная реабилитация",
      homecarePhysiotherapy: "Домашняя физиотерапия",
      pediatrics: "Педиатрия",
      pelvicFloor: "Мышцы тазового дна",
      womensHealthPhysiotherapy: "Физиотерапия женского здоровья",
      acupuncture: "Акупунктура",
      magneticTherapy: "Магнитотерапия",
      manualTherapy: "Мануальная терапия",
      oncology: "Онкология",
      postOperativePhysiotherapist: "Физиотерапия после операции",
      rehabilitation: "Реабилитация",
      chestPhysiotherapy: "Физиотерапия грудной клетки",
      womensHealth: "Женское здоровье",
      pleaseAnswerAllQuestions: "Пожалуйста, ответьте на все вопросы",
      physioTrackProgress: "Отчёты пациентов",
      noReportsFound: "Отчёты не найдены",
      question1: "Недельное улучшение",
      question2: "Удовлетворённость видео",
      specificFeedback: "Открытый отзыв",
      submittedAt: "Отправлено в",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  sr: { //Serbian
    translation: {
      welcome: "Zdravo {{name}}!",
      today: "Danas je {{date}}",
      trackingCompleted: "Bravo! Završili ste plan praćenja za ovu sedmicu.",
      trackingNotCompleted: "Niste završili plan praćenja za ovu sedmicu.",
      faqs: "Često postavljana pitanja",
      home: "Početna",
      trackProgress: "Prati napredak",
      progressTrack: "Praćenje napretka",
      completeTracking: "Jeste li završili sedmični plan praćenja?",
      giveFeedback: "Želite li dati povratnu informaciju?",
      weekFeedback: "Povratna informacija za sedmični plan vežbi",
      qOne: "1. Na skali od 0 do 5, koliko ste se poboljšali u odnosu na prošlu sedmicu?",
      qTwo: "2. Na skali od 0 do 5, koliko su efikasni bili prikazani videozapisi?",
      qThree: "3. Imate li neke specifične komentare?",
      cancel: "Odustani",
      submit: "Pošalji",
      consultations: "Konsultacije",
      speciality: "Specijalnost: ",
      location: "Lokacija: ",
      consultationTag: "Zakažite svoju osobnu fizioterapijsku konsultaciju.",
      selectDateTime: "Odaberite datum i vrijeme: ",
      schedule: "Zakaži",
      scheduleWith: "Zakaži konsultaciju sa ",
      videoLibrary: "Video biblioteka",
      selectCategory: "Odaberite kategoriju za pregled videozapisa:",
      resistance: "Vježbe otpora",
      stretching: "Vježbe istezanja",
      strengthening: "Vježbe jačanja",
      functional: "Funkcionalne vježbe",
      balanceNeuromuscular: "Vježbe ravnoteže i neuromišićne kontrole",
      backCategories: "Nazad na kategorije",
      watchVideo: "Pogledaj video",
      watched: "Pogledano",
      gFeedback: "Daj povratnu informaciju",
      rate: "Ocijeni: ",
      selectRating: "Odaberite ocjenu: ",
      submitRating: "Pošalji ocjenu",
      noVideos: "Nema dostupnih videozapisa za ovu kategoriju.",
      userProfile: "Korisnički profil",
      editProfile: "Uredi profil",
      profilePicture: "Profilna slika: ",
      noFileChosen: "Nije odabran nijedan fajl",
      chooseFile: "Odaberi fajl",
      firstName: "Ime: ",
      lastName: "Prezime: ",
      email: "Email: ",
      sex: "Spol: ",
      selectSex: "Odaberite spol",
      male: "Muški",
      female: "Ženski",
      dob: "Datum rođenja: ",
      height: "Visina (cm): ",
      weight: "Težina (kg): ",
      firstNameRequired: "Ime je obavezno",
      lastNameRequired: "Prezime je obavezno",
      emailRequired: "Email je obavezan",
      sexRequired: "Spol je obavezan",
      dobRequired: "Datum rođenja je obavezan",
      dobCorrect: "Molimo unesite ispravan datum rođenja",
      heightRequired: "Visina je obavezna",
      heightCorrect: "Molimo unesite ispravnu visinu",
      weightRequired: "Težina je obavezna",
      weightCorrect: "Molimo unesite ispravnu težinu",
      saveProfile: "Spremi profil",
      profileSaved: "Profil spremljen!",
      noImage: "Nema slike",
      settings: "Postavke",
      darkMode: "Tamni način",
      language: "Jezik",
      notificationPreference: "Preferencija obavijesti",
      lightMode: "Svijetli način",
      emaiL: "Email",
      phone: "Telefonski broj",
      both: "Oboje",
      login: "Prijava",
      register: "Registracija",
      firstname: "Ime",
      lastname: "Prezime",
      password: "Lozinka: ",
      invalidCredentials: "Neispravan email ili lozinka",
      fillAllFields: "Molimo, ispunite sva polja",
      dontHaveAccount: "Nemate račun? ",
      alreadyHaveAccount: "Već imate račun? ",
      registerHere: "Registrirajte se ovdje",
      loginHere: "Prijavite se ovdje",
      messages: "Chat",
      directMessages: "Izravne poruke",
      typeYourMessage: "Upišite svoju poruku...",
      you: "Vi",
      send: "Pošalji",
      patient: "Pacijent",
      physio: "Fizioterapeut",
      selectRole: "Odaberite ulogu",
      reportFeedback: "Prijavi",
      name: "Ime: ",
      reportType: "Odaberite tip izvješća: ",
      errorBug: "Greška/Bug",
      misbehaviourAbuse: "Neprimjereno ponašanje/ Zlostavljanje",
      issueDescription: "Opis problema: ",
      trackPatients: "Prati pacijente",
      physioProfile: "Profil fizioterapeuta",
      allocation: "Dodijeljeno vam je ",
      patients: " pacijenata.",
      youHave: "Imate ",
      consultationsMonth: " konzultacija ovaj mjesec.",
      slotsAvailable: " slobodnih mjesta.",
      patientsTrack: "Izvješća pacijenata",
      change: "Promijeni",
      remove: "Ukloni",
      addSlots: "Dodaj mjesta",
      removeSlots: "Ukloni mjesta",
      welcomeDr: "Pozdrav, dr. {{name}}!",
      enterSpeciality: "Unesite specijalnost",
      yearsOfExperience: "Godine iskustva: ",
      enterYearsOfExperience: "Unesite godine iskustva...",
      neurologicalDisorder: "Neurološki poremećaj",
      geriatrics: "Geriatrija",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskularna i plućna fizioterapija",
      pediatricPhysiotherapy: "Pedijatrijska fizioterapija",
      musculoskeletalPhysiotherapy: "Mišićno-koštana fizioterapija",
      sportsPhysiotherapy: "Sportska fizioterapija",
      cardiovascularDisease: "Kardiovaskularna bolest",
      orthopedics: "Ortopedija",
      vestibularRehabilitation: "Vestibularna rehabilitacija",
      homecarePhysiotherapy: "Fizioterapija kod kuće",
      pediatrics: "Pedijatrija",
      pelvicFloor: "Dno zdjelice",
      womensHealthPhysiotherapy: "Fizioterapija za zdravlje žena",
      acupuncture: "Akupunktura",
      magneticTherapy: "Magnetska terapija",
      manualTherapy: "Manualna terapija",
      oncology: "Onkologija",
      postOperativePhysiotherapist: "Fizioterapeut nakon operacije",
      rehabilitation: "Rehabilitacija",
      chestPhysiotherapy: "Fizioterapija prsnog koša",
      womensHealth: "Zdravlje žena",
      pleaseAnswerAllQuestions: "Molimo odgovorite na sva pitanja",
      physioTrackProgress: "Izvješća pacijenata",
      noReportsFound: "Nema pronađenih izvješća",
      question1: "Tjedno poboljšanje",
      question2: "Zadovoljstvo videom",
      specificFeedback: "Otvorena povratna informacija",
      submittedAt: "Poslano u",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  sq: { //Albanian
    translation: {
      welcome: "Përshëndetje {{name}}!",
      today: "Sot është {{date}}.",
      trackingCompleted: "Shkëlqyeshëm! Ke përfunduar planin e ndjekjes për këtë javë.",
      trackingNotCompleted: "Nuk ke përfunduar planin e ndjekjes për këtë javë.",
      faqs: "Pyetje të Shpeshta",
      home: "Faqja Kryesore",
      trackProgress: "Ndjek Progresin",
      progressTrack: "Monitorimi i Progresit",
      completeTracking: "A ke përfunduar planin javor të ndjekjes?",
      giveFeedback: "A dëshiron të japësh reagim?",
      weekFeedback: "Reagim për Planin Javor të Ushtrimeve",
      qOne: "1. Në një shkallë nga 0 deri në 5, sa ke përmirësuar krahasuar me javën e kaluar?",
      qTwo: "2. Në një shkallë nga 0 deri në 5, sa efektivë ishin videot e paraqitura?",
      qThree: "3. Ka ndonjë reagim specifik?",
      cancel: "Anulo",
      submit: "Dërgo",
      consultations: "Konsultime",
      speciality: "Specializimi: ",
      location: "Vendndodhja: ",
      consultationTag: "Cakto konsultimin tënd personal të fizioterapisë.",
      selectDateTime: "Zgjidh Datën dhe Orën: ",
      schedule: "Cakto",
      scheduleWith: "Cakto Konsultim me ",
      videoLibrary: "Biblioteka e Videove",
      selectCategory: "Zgjidh një kategori për të parë videot:",
      resistance: "Ushtrime Rezistence",
      stretching: "Ushtrime Shtrënguese",
      strengthening: "Ushtrime Forcuese",
      functional: "Ushtrime Funksionale",
      balanceNeuromuscular: "Ushtrime Balancimi dhe Neuromuskulare",
      backCategories: "Kthehu te Kategoritë",
      watchVideo: "Shiko Video",
      watched: "E shikuar",
      gFeedback: "Jep reagim",
      rate: "Vlerëso: ",
      selectRating: "Zgjidh Vlerësimin: ",
      submitRating: "Dërgo Vlerësimin",
      noVideos: "Nuk ka video në dispozicion për këtë kategori.",
      userProfile: "Profili i Përdoruesit",
      editProfile: "Ndrysho Profilin",
      profilePicture: "Fotoja e Profilit: ",
      noFileChosen: "Asnjë skedar nuk është zgjedhur",
      chooseFile: "Zgjidh skedarin",
      firstName: "Emri: ",
      lastName: "Mbiemri: ",
      email: "Email: ",
      sex: "Gjinia: ",
      selectSex: "Zgjidh Gjinia",
      male: "Mashkull",
      female: "Femër",
      dob: "Data e Lindjes: ",
      height: "Lartësia (cm): ",
      weight: "Pesha (kg): ",
      firstNameRequired: "Emri është i detyrueshëm",
      lastNameRequired: "Mbiemri është i detyrueshëm",
      emailRequired: "Email është i detyrueshëm",
      sexRequired: "Gjinia është e detyrueshme",
      dobRequired: "Data e lindjes është e detyrueshme",
      dobCorrect: "Ju lutemi vendosni një datë të saktë të lindjes",
      heightRequired: "Lartësia është e detyrueshme",
      heightCorrect: "Ju lutemi vendosni një lartësi të saktë",
      weightRequired: "Pesha është e detyrueshme",
      weightCorrect: "Ju lutemi vendosni një peshë të saktë",
      saveProfile: "Ruaj Profilin",
      profileSaved: "Profili u ruajt!",
      noImage: "Asnjë imazh nuk është e disponueshme",
      settings: "Cilësimet",
      darkMode: "Modalitet i errët",
      language: "Gjuhë",
      notificationPreference: "Preferenca e njoftimeve",
      lightMode: "Modalitet i ndritshëm",
      emaiL: "Email",
      phone: "Numri i telefonit",
      both: "Të dyja",
      login: "Hyni",
      register: "Regjistrohu",
      firstname: "Emri",
      lastname: "Mbiemri",
      password: "Fjalëkalimi: ",
      invalidCredentials: "Email ose fjalëkalim i pavlefshëm",
      fillAllFields: "Ju lutemi plotësoni të gjitha fushat",
      dontHaveAccount: "Nuk keni llogari? ",
      alreadyHaveAccount: "Keni tashmë llogari? ",
      registerHere: "Regjistrohu këtu",
      loginHere: "Hyni këtu",
      messages: "Bisedë",
      directMessages: "Mesazhe të drejtpërdrejta",
      typeYourMessage: "Shkruani mesazhin tuaj...",
      you: "Ju",
      send: "Dërgo",
      patient: "Pacient",
      physio: "Fizioterapist",
      selectRole: "Zgjidhni rol",
      reportFeedback: "Raporto",
      name: "Emri: ",
      reportType: "Zgjidhni llojin e raportit: ",
      errorBug: "Gabim/Bug",
      misbehaviourAbuse: "Sjellje e papërshtatshme/Abuzim",
      issueDescription: "Përshkrimi i çështjes: ",
      trackPatients: "Ndiq pacientët",
      physioProfile: "Profili i fizioterapistit",
      allocation: "Jeni caktuar tek ",
      patients: " pacientë.",
      youHave: "Ju keni ",
      consultationsMonth: " konsultime këtë muaj.",
      slotsAvailable: " vende të lira",
      patientsTrack: "Raportet e pacientëve",
      change: "Ndrysho",
      remove: "Hiq",
      addSlots: "Shto vende",
      removeSlots: "Hiq vende",
      welcomeDr: "Përshëndetje Dr. {{name}}!",
      enterSpeciality: "Shkruani specialitetin",
      yearsOfExperience: "Vitet e përvojës: ",
      enterYearsOfExperience: "Shkruani vitet e përvojës...",
      neurologicalDisorder: "Çrregullim neurologjik",
      geriatrics: "Geriatri",
      cardiovascularPulmonaryPhysiotherapy: "Fizioterapia kardiovaskulare dhe pulmonare",
      pediatricPhysiotherapy: "Fizioterapia pediatrike",
      musculoskeletalPhysiotherapy: "Fizioterapia muskuloskletale",
      sportsPhysiotherapy: "Fizioterapia sportive",
      cardiovascularDisease: "Sëmundje kardiovaskulare",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Rehabilitimi vestibular",
      homecarePhysiotherapy: "Fizioterapia në shtëpi",
      pediatrics: "Pediatri",
      pelvicFloor: "Dera pelviane",
      womensHealthPhysiotherapy: "Fizioterapia për shëndetin e grave",
      acupuncture: "Akupunkturë",
      magneticTherapy: "Terapia magnetike",
      manualTherapy: "Terapia manuale",
      oncology: "Onkologji",
      postOperativePhysiotherapist: "Fizioterapist pas operacionit",
      rehabilitation: "Rehabilitim",
      chestPhysiotherapy: "Fizioterapia e gjoksit",
      womensHealth: "Shëndeti i grave",
      pleaseAnswerAllQuestions: "Ju lutemi përgjigjuni të gjitha pyetjeve",
      physioTrackProgress: "Raportet e pacientëve",
      noReportsFound: "Nuk u gjetën raporte",
      question1: "Përmirësim javor",
      question2: "Kënaqësi nga video",
      specificFeedback: "Feedback i hapur",
      submittedAt: "Paraqitur më",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  sv: { //Swedish
    translation: {
      welcome: "Hej {{name}}!",
      today: "Idag är det {{date}}.",
      trackingCompleted: "Bra jobbat! Du har slutfört veckans spårningsplan.",
      trackingNotCompleted: "Du har inte slutfört veckans spårningsplan.",
      faqs: "Vanliga Frågor",
      home: "Hem",
      trackProgress: "Följ Framsteg",
      progressTrack: "Framstegsövervakning",
      completeTracking: "Är veckans spårningsplan klar?",
      giveFeedback: "Ge feedback?",
      weekFeedback: "Feedback på veckans träningsplan",
      qOne: "1. På en skala från 0 till 5, hur mycket har du förbättrats jämfört med förra veckan?",
      qTwo: "2. På en skala från 0 till 5, hur effektiva var de visade videorna?",
      qThree: "3. Några specifika kommentarer?",
      cancel: "Avbryt",
      submit: "Skicka",
      consultations: "Konsultationer",
      speciality: "Specialitet: ",
      location: "Plats: ",
      consultationTag: "Boka din personliga fysioterapikonsultation.",
      selectDateTime: "Välj datum och tid: ",
      schedule: "Boka",
      scheduleWith: "Boka konsultation med ",
      videoLibrary: "Videobibliotek",
      selectCategory: "Välj en kategori för att se videor:",
      resistance: "Motståndsövningar",
      stretching: "Stretchövningar",
      strengthening: "Styrkeövningar",
      functional: "Funktionella övningar",
      balanceNeuromuscular: "Balans- & neuromuskulära övningar",
      backCategories: "Tillbaka till kategorier",
      watchVideo: "Titta på video",
      watched: "Set",
      gFeedback: "Ge feedback",
      rate: "Betyg: ",
      selectRating: "Välj betyg: ",
      submitRating: "Skicka betyg",
      noVideos: "Inga videor finns för denna kategori.",
      userProfile: "Användarprofil",
      editProfile: "Redigera profil",
      profilePicture: "Profilbild: ",
      noFileChosen: "Ingen fil vald",
      chooseFile: "Välj fil",
      firstName: "Förnamn: ",
      lastName: "Efternamn: ",
      email: "Email: ",
      sex: "Kön: ",
      selectSex: "Välj kön",
      male: "Man",
      female: "Kvinna",
      dob: "Födelsedatum: ",
      height: "Längd (cm): ",
      weight: "Vikt (kg): ",
      firstNameRequired: "Förnamn krävs",
      lastNameRequired: "Efternamn krävs",
      emailRequired: "Email krävs",
      sexRequired: "Kön krävs",
      dobRequired: "Födelsedatum krävs",
      dobCorrect: "Ange ett korrekt födelsedatum",
      heightRequired: "Längd krävs",
      heightCorrect: "Ange en korrekt längd",
      weightRequired: "Vikt krävs",
      weightCorrect: "Ange en korrekt vikt",
      saveProfile: "Spara profil",
      profileSaved: "Profil sparad!",
      noImage: "Inget bild",
      settings: "Inställningar",
      darkMode: "Mörkt läge",
      language: "Språk",
      notificationPreference: "Notifikationspreferens",
      lightMode: "Ljust läge",
      emaiL: "Email",
      phone: "Telefonnummer",
      both: "Båda",
      login: "Logga in",
      register: "Registrera",
      firstname: "Förnamn",
      lastname: "Efternamn",
      password: "Lösenord: ",
      invalidCredentials: "Ogiltig email eller lösenord",
      fillAllFields: "Fyll i alla fält",
      dontHaveAccount: "Har du inget konto? ",
      alreadyHaveAccount: "Har du redan ett konto? ",
      registerHere: "Registrera dig här",
      loginHere: "Logga in här",
      messages: "Chatt",
      directMessages: "Direktmeddelanden",
      typeYourMessage: "Skriv ditt meddelande...",
      you: "Du",
      send: "Skicka",
      patient: "Patient",
      physio: "Fysioterapeut",
      selectRole: "Välj roll",
      reportFeedback: "Rapportera",
      name: "Namn: ",
      reportType: "Välj rapporttyp: ",
      errorBug: "Bug/Fel",
      misbehaviourAbuse: "Felaktigt beteende/Missbruk",
      issueDescription: "Problemets beskrivning: ",
      trackPatients: "Spåra patienter",
      physioProfile: "Fysioterapeutprofil",
      allocation: "Du är tilldelad ",
      patients: " patienter.",
      youHave: "Du har ",
      consultationsMonth: " konsultationer denna månad.",
      slotsAvailable: " platser tillgängliga.",
      patientsTrack: "Patientrapporter",
      change: "Ändra",
      remove: "Ta bort",
      addSlots: "Lägg till platser",
      removeSlots: "Ta bort platser",
      welcomeDr: "Hej Dr. {{name}}!",
      enterSpeciality: "Ange specialitet",
      yearsOfExperience: "Erfarenhetsår: ",
      enterYearsOfExperience: "Ange antal erfarenhetsår...",
      neurologicalDisorder: "Neurologisk störning",
      geriatrics: "Geriatrik",
      cardiovascularPulmonaryPhysiotherapy: "Kardiovaskulär och pulmonal fysioterapi",
      pediatricPhysiotherapy: "Pediatrisk fysioterapi",
      musculoskeletalPhysiotherapy: "Muskuloskeletal fysioterapi",
      sportsPhysiotherapy: "Sportfysioterapi",
      cardiovascularDisease: "Kardiovaskulär sjukdom",
      orthopedics: "Ortopedi",
      vestibularRehabilitation: "Vestibulär rehabilitering",
      homecarePhysiotherapy: "Hemmafysioterapi",
      pediatrics: "Pediatri",
      pelvicFloor: "Bäckenbotten",
      womensHealthPhysiotherapy: "Fysioterapi för kvinnors hälsa",
      acupuncture: "Akupunktur",
      magneticTherapy: "Magnetterapi",
      manualTherapy: "Manuell terapi",
      oncology: "Onkologi",
      postOperativePhysiotherapist: "Postoperativ fysioterapeut",
      rehabilitation: "Rehabilitering",
      chestPhysiotherapy: "Bröstfysioterapi",
      womensHealth: "Kvinnors hälsa",
      pleaseAnswerAllQuestions: "Vänligen besvara alla frågor",
      physioTrackProgress: "Patientrapporter",
      noReportsFound: "Inga rapporter hittades",
      question1: "Veckoförbättring",
      question2: "Videotillfredsställelse",
      specificFeedback: "Öppen feedback",
      submittedAt: "Inskickat",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  sw: { //Swahili
    translation: {
      welcome: "Habari {{name}}!",
      today: "Leo ni {{date}}.",
      trackingCompleted: "Vizuri sana! Umekamilisha mpango wa kufuatilia wa wiki hii.",
      trackingNotCompleted: "Hujakamilisha mpango wa kufuatilia wa wiki hii.",
      faqs: "Maswali Yanayoulizwa Mara kwa Mara",
      home: "Nyumbani",
      trackProgress: "Fuatilia Maendeleo",
      progressTrack: "Ufuatiliaji wa Maendeleo",
      completeTracking: "Je, umekamilisha mpango wa wiki ya kufuatilia?",
      giveFeedback: "Toa maoni?",
      weekFeedback: "Maoni juu ya Mpango wa Mazoezi ya Wiki",
      qOne: "1. Kulingana na kiwango cha 0 hadi 5, umeimarika kiasi gani ukilinganisha na wiki iliyopita?",
      qTwo: "2. Kulingana na kiwango cha 0 hadi 5, video zilizotolewa zilikuwa na ufanisi gani?",
      qThree: "3. Kuna maoni maalum?",
      cancel: "Ghairi",
      submit: "Tuma",
      consultations: "Ushauri",
      speciality: "Utaalamu: ",
      location: "Mahali: ",
      consultationTag: "Panga ushauri wako wa fizioterapia wa ana kwa ana.",
      selectDateTime: "Chagua Tarehe na Muda: ",
      schedule: "Panga",
      scheduleWith: "Panga Ushauri na ",
      videoLibrary: "Maktaba ya Video",
      selectCategory: "Chagua kundi la video:",
      resistance: "Mazoezi ya Upinzani",
      stretching: "Mazoezi ya Urejesho",
      strengthening: "Mazoezi ya Kuimarisha",
      functional: "Mazoezi ya Kazi",
      balanceNeuromuscular: "Mazoezi ya Mizani na Neuromuskula",
      backCategories: "Rudi kwenye Makundi",
      watchVideo: "Angalia Video",
      watched: "Imetazamwa",
      gFeedback: "Toa Maoni",
      rate: "Pigia Alama: ",
      selectRating: "Chagua Alama: ",
      submitRating: "Tuma Alama",
      noVideos: "Hakuna video zilizopo kwa kundi hili.",
      userProfile: "Wasifu wa Mtumiaji",
      editProfile: "Hariri Wasifu",
      profilePicture: "Picha ya Wasifu: ",
      noFileChosen: "Hakuna faili iliyochaguliwa",
      chooseFile: "Chagua faili",
      firstName: "Jina la Kwanza: ",
      lastName: "Jina la Mwisho: ",
      email: "Barua pepe: ",
      sex: "Jinsia: ",
      selectSex: "Chagua Jinsia",
      male: "Mwanaume",
      female: "Mwanamke",
      dob: "Tarehe ya Kuzaliwa: ",
      height: "Urefu (cm): ",
      weight: "Uzito (kg): ",
      firstNameRequired: "Jina la kwanza linahitajika",
      lastNameRequired: "Jina la mwisho linahitajika",
      emailRequired: "Barua pepe inahitajika",
      sexRequired: "Jinsia linahitajika",
      dobRequired: "Tarehe ya kuzaliwa inahitajika",
      dobCorrect: "Tafadhali ingiza tarehe ya kuzaliwa sahihi",
      heightRequired: "Urefu unahitajika",
      heightCorrect: "Tafadhali ingiza urefu sahihi",
      weightRequired: "Uzito unahitajika",
      weightCorrect: "Tafadhali ingiza uzito sahihi",
      saveProfile: "Hifadhi Wasifu",
      profileSaved: "Wasifu umehifadhiwa!",
      noImage: "Hakuna Picha",
      settings: "Mipangilio",
      darkMode: "Hali ya Giza",
      language: "Lugha",
      notificationPreference: "Upendeleo wa arifa",
      lightMode: "Hali ya mwanga",
      emaiL: "Email",
      phone: "Nambari ya simu",
      both: "Vyote viwili",
      login: "Ingia",
      register: "Jisajili",
      firstname: "Jina la kwanza",
      lastname: "Jina la mwisho",
      password: "Nywila: ",
      invalidCredentials: "Email au nywila si sahihi",
      fillAllFields: "Tafadhali jaza sehemu zote",
      dontHaveAccount: "Huna akaunti? ",
      alreadyHaveAccount: "Umefungua akaunti tayari? ",
      registerHere: "Jisajili hapa",
      loginHere: "Ingia hapa",
      messages: "Maongezi",
      directMessages: "Ujumbe wa moja kwa moja",
      typeYourMessage: "Andika ujumbe wako...",
      you: "Wewe",
      send: "Tuma",
      patient: "Mgonjwa",
      physio: "Fisioterapisti",
      selectRole: "Chagua jukumu",
      reportFeedback: "Ripoti",
      name: "Jina: ",
      reportType: "Chagua Aina ya Ripoti: ",
      errorBug: "Hitilafu/Bug",
      misbehaviourAbuse: "Tabia mbaya/Unyanyasaji",
      issueDescription: "Maelezo ya tatizo: ",
      trackPatients: "Fuata wagonjwa",
      physioProfile: "Wasifu wa Fisioterapisti",
      allocation: "Umepewa ",
      patients: " wagonjwa.",
      youHave: "Una ",
      consultationsMonth: " mashauri mwezi huu.",
      slotsAvailable: " nafasi zilizopo",
      patientsTrack: "Ripoti za wagonjwa",
      change: "Badilisha",
      remove: "Ondoa",
      addSlots: "Ongeza Nafasi",
      removeSlots: "Ondoa Nafasi",
      welcomeDr: "Habari Dr. {{name}}!",
      enterSpeciality: "Weka utaalamu",
      yearsOfExperience: "Miaka ya uzoefu: ",
      enterYearsOfExperience: "Weka miaka ya uzoefu...",
      neurologicalDisorder: "Tatizo la neva",
      geriatrics: "Wagonjwa wazee",
      cardiovascularPulmonaryPhysiotherapy: "Tiba ya moyo na mapafu",
      pediatricPhysiotherapy: "Tiba ya watoto",
      musculoskeletalPhysiotherapy: "Tiba ya mifupa na misuli",
      sportsPhysiotherapy: "Tiba ya michezo",
      cardiovascularDisease: "Ugonjwa wa moyo",
      orthopedics: "Ortopedia",
      vestibularRehabilitation: "Urejeshaji wa mfumo wa kusawazisha",
      homecarePhysiotherapy: "Tiba ya nyumbani",
      pediatrics: "Tiba ya watoto",
      pelvicFloor: "Chini ya pelvi",
      womensHealthPhysiotherapy: "Tiba ya afya ya wanawake",
      acupuncture: "Acupuncture",
      magneticTherapy: "Tiba ya sumaku",
      manualTherapy: "Tiba ya mikono",
      oncology: "Onkolojia",
      postOperativePhysiotherapist: "Fisioterapisti baada ya upasuaji",
      rehabilitation: "Rehabilitasi",
      chestPhysiotherapy: "Tiba ya kifua",
      womensHealth: "Afya ya wanawake",
      pleaseAnswerAllQuestions: "Tafadhali jibu maswali yote",
      physioTrackProgress: "Ripoti za wagonjwa",
      noReportsFound: "Hakuna ripoti zilizopatikana",
      question1: "Uboreshaji wa wiki",
      question2: "Kuridhika kwa video",
      specificFeedback: "Maoni wazi",
      submittedAt: "Imewasilishwa",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  th: { //Thai
    translation: {
      welcome: "สวัสดี {{name}}!",
      today: "วันนี้คือ {{date}}.",
      trackingCompleted: "ทำได้ดีมาก! คุณได้ทำแผนติดตามของสัปดาห์นี้เสร็จแล้ว.",
      trackingNotCompleted: "คุณยังไม่ได้ทำแผนติดตามของสัปดาห์นี้ให้เสร็จ.",
      faqs: "คำถามที่พบบ่อย",
      home: "หน้าแรก",
      trackProgress: "ติดตามความคืบหน้า",
      progressTrack: "การติดตามความคืบหน้า",
      completeTracking: "แผนติดตามรายสัปดาห์เสร็จแล้วหรือยัง?",
      giveFeedback: "ให้ข้อเสนอแนะ?",
      weekFeedback: "ข้อเสนอแนะเกี่ยวกับแผนออกกำลังกายรายสัปดาห์",
      qOne: "1. บนระดับ 0 ถึง 5 คุณพัฒนาขึ้นเท่าไหร่เมื่อเทียบกับสัปดาห์ที่แล้ว?",
      qTwo: "2. บนระดับ 0 ถึง 5 วิดีโอที่ให้มีประสิทธิภาพมากน้อยเพียงใด?",
      qThree: "3. มีข้อเสนอแนะเฉพาะหรือไม่?",
      cancel: "ยกเลิก",
      submit: "ส่ง",
      consultations: "ปรึกษา",
      speciality: "ความเชี่ยวชาญ: ",
      location: "สถานที่: ",
      consultationTag: "นัดหมายปรึกษาการกายภาพบำบัดด้วยตนเอง",
      selectDateTime: "เลือกวันที่และเวลา: ",
      schedule: "นัดหมาย",
      scheduleWith: "นัดหมายปรึกษากับ ",
      videoLibrary: "ห้องสมุดวิดีโอ",
      selectCategory: "เลือกหมวดหมู่เพื่อดูวิดีโอ:",
      resistance: "การออกกำลังกายต้านแรง",
      stretching: "การออกกำลังกายยืดเหยียด",
      strengthening: "การออกกำลังกายเสริมความแข็งแรง",
      functional: "การออกกำลังกายที่ใช้งานได้จริง",
      balanceNeuromuscular: "การออกกำลังกายปรับสมดุลและประสานงานประสาท-กล้ามเนื้อ",
      backCategories: "กลับไปที่หมวดหมู่",
      watchVideo: "ดูวิดีโอ",
      watched: "ดูแล้ว",
      gFeedback: "ให้ข้อเสนอแนะ",
      rate: "ให้คะแนน: ",
      selectRating: "เลือกคะแนน: ",
      submitRating: "ส่งคะแนน",
      noVideos: "ไม่มีวิดีโอสำหรับหมวดหมู่นี้",
      userProfile: "โปรไฟล์ผู้ใช้",
      editProfile: "แก้ไขโปรไฟล์",
      profilePicture: "รูปโปรไฟล์: ",
      noFileChosen: "ไม่ได้เลือกไฟล์",
      chooseFile: "เลือกไฟล์",
      firstName: "ชื่อ: ",
      lastName: "นามสกุล: ",
      email: "อีเมล: ",
      sex: "เพศ: ",
      selectSex: "เลือกเพศ",
      male: "ชาย",
      female: "หญิง",
      dob: "วันเกิด: ",
      height: "ส่วนสูง (cm): ",
      weight: "น้ำหนัก (kg): ",
      firstNameRequired: "จำเป็นต้องระบุชื่อ",
      lastNameRequired: "จำเป็นต้องระบุนามสกุล",
      emailRequired: "จำเป็นต้องระบุอีเมล",
      sexRequired: "จำเป็นต้องระบุเพศ",
      dobRequired: "จำเป็นต้องระบุวันเกิด",
      dobCorrect: "กรุณาระบุวันเกิดที่ถูกต้อง",
      heightRequired: "จำเป็นต้องระบุส่วนสูง",
      heightCorrect: "กรุณาระบุส่วนสูงที่ถูกต้อง",
      weightRequired: "จำเป็นต้องระบุน้ำหนัก",
      weightCorrect: "กรุณาระบุน้ำหนักที่ถูกต้อง",
      saveProfile: "บันทึกโปรไฟล์",
      profileSaved: "โปรไฟล์ถูกบันทึกแล้ว!",
      noImage: "ไม่มีรูป",
      settings: "การตั้งค่า",
      darkMode: "โหมดมืด",
      language: "ภาษา",
      notificationPreference: "การตั้งค่าการแจ้งเตือน",
      lightMode: "โหมดสว่าง",
      emaiL: "อีเมล",
      phone: "หมายเลขโทรศัพท์",
      both: "ทั้งคู่",
      login: "เข้าสู่ระบบ",
      register: "ลงทะเบียน",
      firstname: "ชื่อ",
      lastname: "นามสกุล",
      password: "รหัสผ่าน: ",
      invalidCredentials: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
      fillAllFields: "กรุณากรอกข้อมูลในทุกช่อง",
      dontHaveAccount: "ไม่มีบัญชี? ",
      alreadyHaveAccount: "มีบัญชีแล้ว? ",
      registerHere: "ลงทะเบียนที่นี่",
      loginHere: "เข้าสู่ระบบที่นี่",
      messages: "แชท",
      directMessages: "ข้อความตรง",
      typeYourMessage: "พิมพ์ข้อความของคุณ...",
      you: "คุณ",
      send: "ส่ง",
      patient: "ผู้ป่วย",
      physio: "นักกายภาพบำบัด",
      selectRole: "เลือกบทบาท",
      reportFeedback: "รายงาน",
      name: "ชื่อ: ",
      reportType: "เลือกประเภทรายงาน: ",
      errorBug: "ข้อผิดพลาด/บัก",
      misbehaviourAbuse: "พฤติกรรมไม่เหมาะสม/การละเมิด",
      issueDescription: "คำอธิบายปัญหา: ",
      trackPatients: "ติดตามผู้ป่วย",
      physioProfile: "โปรไฟล์นักกายภาพบำบัด",
      allocation: "คุณได้รับมอบหมายให้กับ ",
      patients: " ผู้ป่วย",
      youHave: "คุณมี ",
      consultationsMonth: " การปรึกษาในเดือนนี้",
      slotsAvailable: " ช่องว่างที่มีอยู่",
      patientsTrack: "รายงานผู้ป่วย",
      change: "เปลี่ยน",
      remove: "ลบ",
      addSlots: "เพิ่มช่องว่าง",
      removeSlots: "ลบช่องว่าง",
      welcomeDr: "สวัสดี ดร. {{name}}!",
      enterSpeciality: "กรอกความเชี่ยวชาญ",
      yearsOfExperience: "ปีที่มีประสบการณ์: ",
      enterYearsOfExperience: "กรอกจำนวนปีที่มีประสบการณ์...",
      neurologicalDisorder: "ความผิดปกติทางระบบประสาท",
      geriatrics: "ผู้สูงอายุ",
      cardiovascularPulmonaryPhysiotherapy: "กายภาพบำบัดหัวใจและปอด",
      pediatricPhysiotherapy: "กายภาพบำบัดเด็ก",
      musculoskeletalPhysiotherapy: "กายภาพบำบัดกระดูกและกล้ามเนื้อ",
      sportsPhysiotherapy: "กายภาพบำบัดกีฬา",
      cardiovascularDisease: "โรคหัวใจและหลอดเลือด",
      orthopedics: "ออร์โธปีดิกส์",
      vestibularRehabilitation: "การฟื้นฟูสมรรถภาพการทรงตัว",
      homecarePhysiotherapy: "กายภาพบำบัดที่บ้าน",
      pediatrics: "กุมารเวชศาสตร์",
      pelvicFloor: "พื้นเชิงกราน",
      womensHealthPhysiotherapy: "กายภาพบำบัดสุขภาพผู้หญิง",
      acupuncture: "ฝังเข็ม",
      magneticTherapy: "การบำบัดด้วยแม่เหล็ก",
      manualTherapy: "การบำบัดด้วยมือ",
      oncology: "โรคมะเร็ง",
      postOperativePhysiotherapist: "นักกายภาพบำบัดหลังผ่าตัด",
      rehabilitation: "การฟื้นฟู",
      chestPhysiotherapy: "กายภาพบำบัดหน้าอก",
      womensHealth: "สุขภาพผู้หญิง",
      pleaseAnswerAllQuestions: "กรุณาตอบทุกคำถาม",
      physioTrackProgress: "รายงานผู้ป่วย",
      noReportsFound: "ไม่พบรายงาน",
      question1: "การปรับปรุงรายสัปดาห์",
      question2: "ความพึงพอใจในวิดีโอ",
      specificFeedback: "ความคิดเห็นเปิด",
      submittedAt: "ส่งเมื่อ",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  tl: { //Tagalog
    translation: {
      welcome: "Kumusta {{name}}!",
      today: "Ngayon ay {{date}}.",
      trackingCompleted: "Magaling! Nakumpleto mo na ang tracking plan para sa linggong ito.",
      trackingNotCompleted: "Hindi mo pa nakukumpleto ang tracking plan para sa linggong ito.",
      faqs: "Mga Madalas Itanong",
      home: "Pahina ng Bahay",
      trackProgress: "Subaybayan ang Progreso",
      progressTrack: "Pagsubaybay ng Progreso",
      completeTracking: "Nakumpleto mo na ba ang lingguhang tracking plan?",
      giveFeedback: "Magbigay ng puna?",
      weekFeedback: "Puna para sa Lingguhang Plano ng Ehersisyo",
      qOne: "1. Sa sukat mula 0 hanggang 5, gaano ka na-improve kumpara sa nakaraang linggo?",
      qTwo: "2. Sa sukat mula 0 hanggang 5, gaano kaepektibo ang mga video na ipinakita?",
      qThree: "3. Mayroon bang partikular na puna?",
      cancel: "Kanselahin",
      submit: "Isumite",
      consultations: "Konsultasyon",
      speciality: "Espesyalidad: ",
      location: "Lokasyon: ",
      consultationTag: "I-schedule ang iyong personal na konsultasyon sa pisikal na therapy.",
      selectDateTime: "Pumili ng Petsa at Oras: ",
      schedule: "I-schedule",
      scheduleWith: "I-schedule ang Konsultasyon kasama si ",
      videoLibrary: "Video Library",
      selectCategory: "Pumili ng kategorya para makita ang mga video:",
      resistance: "Mga Resistance Exercises",
      stretching: "Mga Stretching Exercises",
      strengthening: "Mga Strengthening Exercises",
      functional: "Mga Functional Exercises",
      balanceNeuromuscular: "Balance & Neuromuscular Exercises",
      backCategories: "Bumalik sa mga Kategorya",
      watchVideo: "Panoorin ang Video",
      watched: "Napanood",
      gFeedback: "Magbigay ng Puna",
      rate: "I-rate: ",
      selectRating: "Pumili ng Rating: ",
      submitRating: "Isumite ang Rating",
      noVideos: "Walang video na available para sa kategoryang ito.",
      userProfile: "Profile ng User",
      editProfile: "I-edit ang Profile",
      profilePicture: "Larawan ng Profile: ",
      noFileChosen: "Walang napiling file",
      chooseFile: "Pumili ng file",
      firstName: "Unang Pangalan: ",
      lastName: "Apelyido: ",
      email: "Email: ",
      sex: "Kasarian: ",
      selectSex: "Pumili ng Kasarian",
      male: "Lalaki",
      female: "Babae",
      dob: "Petsa ng Kapanganakan: ",
      height: "Taas (cm): ",
      weight: "Timbang (kg): ",
      firstNameRequired: "Kinakailangan ang unang pangalan",
      lastNameRequired: "Kinakailangan ang apelyido",
      emailRequired: "Kinakailangan ang email",
      sexRequired: "Kinakailangan ang kasarian",
      dobRequired: "Kinakailangan ang petsa ng kapanganakan",
      dobCorrect: "Mangyaring maglagay ng tamang petsa ng kapanganakan",
      heightRequired: "Kinakailangan ang taas",
      heightCorrect: "Mangyaring maglagay ng tamang taas",
      weightRequired: "Kinakailangan ang timbang",
      weightCorrect: "Mangyaring maglagay ng tamang timbang",
      saveProfile: "I-save ang Profile",
      profileSaved: "Na-save ang Profile!",
      noImage: "Walang Imahe",
      settings: "Mga Setting",
      darkMode: "Madilim na Mode",
      language: "Wika",
      notificationPreference: "Prayoridad ng Abiso",
      lightMode: "Light Mode",
      emaiL: "Email",
      phone: "Numero ng Telepono",
      both: "Pareho",
      login: "Mag-login",
      register: "Magrehistro",
      firstname: "Unang Pangalan",
      lastname: "Apelyido",
      password: "Password: ",
      invalidCredentials: "Di-wastong email o password",
      fillAllFields: "Pakitapos ang lahat ng patlang",
      dontHaveAccount: "Wala kang account? ",
      alreadyHaveAccount: "Mayroon ka nang account? ",
      registerHere: "Magrehistro dito",
      loginHere: "Mag-login dito",
      messages: "Chat",
      directMessages: "Direktang Mensahe",
      typeYourMessage: "I-type ang iyong mensahe...",
      you: "Ikaw",
      send: "Ipadala",
      patient: "Pasyente",
      physio: "Fisioterapista",
      selectRole: "Pumili ng Papel",
      reportFeedback: "Iulat",
      name: "Pangalan: ",
      reportType: "Pumili ng Uri ng Ulat: ",
      errorBug: "Bug/Error",
      misbehaviourAbuse: "Maling Asal/Pang-aabuso",
      issueDescription: "Paglalarawan ng Problema: ",
      trackPatients: "Subaybayan ang mga Pasyente",
      physioProfile: "Profile ng Fisioterapista",
      allocation: "Ikaw ay na-allocate sa ",
      patients: " pasyente",
      youHave: "Mayroon kang ",
      consultationsMonth: " konsultasyon ngayong buwan",
      slotsAvailable: " slot pa available",
      patientsTrack: "Ulat ng Pasyente",
      change: "Baguhin",
      remove: "Alisin",
      addSlots: "Magdagdag ng Slot",
      removeSlots: "Alisin ang Slot",
      welcomeDr: "Kamusta Dr. {{name}}!",
      enterSpeciality: "Ilagay ang Espesyalidad",
      yearsOfExperience: "Mga Taon ng Karanasan: ",
      enterYearsOfExperience: "Ilagay ang Taon ng Karanasan...",
      neurologicalDisorder: "Neurological Disorder",
      geriatrics: "Geriatrics",
      cardiovascularPulmonaryPhysiotherapy: "Cardiovascular at Pulmonary Physiotherapy",
      pediatricPhysiotherapy: "Pediatric Physiotherapy",
      musculoskeletalPhysiotherapy: "Musculoskeletal Physiotherapy",
      sportsPhysiotherapy: "Sports Physiotherapy",
      cardiovascularDisease: "Cardiovascular Disease",
      orthopedics: "Orthopedics",
      vestibularRehabilitation: "Vestibular Rehabilitation",
      homecarePhysiotherapy: "Homecare Physiotherapy",
      pediatrics: "Pediatrics",
      pelvicFloor: "Pelvic Floor",
      womensHealthPhysiotherapy: "Women's Health Physiotherapy",
      acupuncture: "Acupuncture",
      magneticTherapy: "Magnetic Therapy",
      manualTherapy: "Manual Therapy",
      oncology: "Oncology",
      postOperativePhysiotherapist: "Post Operative Physiotherapy",
      rehabilitation: "Rehabilitation",
      chestPhysiotherapy: "Chest Physiotherapy",
      womensHealth: "Women's Health",
      pleaseAnswerAllQuestions: "Pakiusap, sagutin ang lahat ng tanong",
      physioTrackProgress: "Ulat ng Pasyente",
      noReportsFound: "Walang Ulat Natagpuan",
      question1: "Pagbuti lingguhan",
      question2: "Kasiyahan sa Video",
      specificFeedback: "Bukas na Feedback",
      submittedAt: "Isinumite noong",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  tr: { //Turkish
    translation: {
      welcome: "Merhaba {{name}}!",
      today: "Bugün {{date}}.",
      trackingCompleted: "Aferin! Bu haftanın takip planını tamamladınız.",
      trackingNotCompleted: "Bu haftanın takip planını tamamlamadınız.",
      faqs: "Sık Sorulan Sorular",
      home: "Ana Sayfa",
      trackProgress: "Takip Et",
      progressTrack: "İlerleme Takibi",
      completeTracking: "Haftalık takip planı tamamlandı mı?",
      giveFeedback: "Geri Bildirim Ver?",
      weekFeedback: "Haftalık Egzersiz Planı Geri Bildirimi",
      qOne: "1. 0'dan 5'e kadar olan ölçekte, geçen haftaya kıyasla ne kadar gelişim gösterdiniz?",
      qTwo: "2. 0'dan 5'e kadar olan ölçekte, verilen videolar ne kadar etkiliydi?",
      qThree: "3. Herhangi özel bir geri bildiriminiz var mı?",
      cancel: "İptal",
      submit: "Gönder",
      consultations: "Danışmanlık",
      speciality: "Uzmanlık: ",
      location: "Konum: ",
      consultationTag: "Yüz yüze fizyoterapi danışmanlığınızı planlayın.",
      selectDateTime: "Tarih ve Saat Seçin: ",
      schedule: "Planla",
      scheduleWith: "İle Danışmanlık Planla: ",
      videoLibrary: "Video Kütüphanesi",
      selectCategory: "Videoları görüntülemek için bir kategori seçin:",
      resistance: "Direnç Egzersizleri",
      stretching: "Esneme Egzersizleri",
      strengthening: "Güçlendirme Egzersizleri",
      functional: "Fonksiyonel Egzersizler",
      balanceNeuromuscular: "Denge ve Nöromüsküler Egzersizler",
      backCategories: "Kategorilere Geri Dön",
      watchVideo: "Videoyu İzle",
      watched: "İzledi",
      gFeedback: "Geri Bildirim Ver",
      rate: "Değerlendir: ",
      selectRating: "Değerlendirme Seçin: ",
      submitRating: "Değerlendirmeyi Gönder",
      noVideos: "Bu kategori için video yok.",
      userProfile: "Kullanıcı Profili",
      editProfile: "Profili Düzenle",
      profilePicture: "Profil Resmi: ",
      noFileChosen: "Dosya seçilmedi",
      chooseFile: "Dosya Seç",
      firstName: "Ad: ",
      lastName: "Soyad: ",
      email: "E-posta: ",
      sex: "Cinsiyet: ",
      selectSex: "Cinsiyet Seçin",
      male: "Erkek",
      female: "Kadın",
      dob: "Doğum Tarihi: ",
      height: "Boy (cm): ",
      weight: "Kilo (kg): ",
      firstNameRequired: "Ad gereklidir",
      lastNameRequired: "Soyad gereklidir",
      emailRequired: "E-posta gereklidir",
      sexRequired: "Cinsiyet gereklidir",
      dobRequired: "Doğum tarihi gereklidir",
      dobCorrect: "Lütfen doğru bir doğum tarihi girin",
      heightRequired: "Boy gereklidir",
      heightCorrect: "Lütfen doğru bir boy girin",
      weightRequired: "Kilo gereklidir",
      weightCorrect: "Lütfen doğru bir kilo girin",
      saveProfile: "Profili Kaydet",
      profileSaved: "Profil kaydedildi!",
      noImage: "Resim yok",
      settings: "Ayarlar",
      darkMode: "Karanlık Mod",
      language: "Dil",
      notificationPreference: "Bildirim Tercihi",
      lightMode: "Açık Mod",
      emaiL: "E-posta",
      phone: "Telefon Numarası",
      both: "Her ikisi de",
      login: "Giriş Yap",
      register: "Kayıt Ol",
      firstname: "Ad",
      lastname: "Soyad",
      password: "Şifre: ",
      invalidCredentials: "Geçersiz e-posta veya şifre",
      fillAllFields: "Lütfen tüm alanları doldurun",
      dontHaveAccount: "Hesabınız yok mu? ",
      alreadyHaveAccount: "Zaten hesabınız var mı? ",
      registerHere: "Buradan kayıt olun",
      loginHere: "Buradan giriş yapın",
      messages: "Sohbet",
      directMessages: "Doğrudan Mesajlar",
      typeYourMessage: "Mesajınızı yazın...",
      you: "Siz",
      send: "Gönder",
      patient: "Hasta",
      physio: "Fizyoterapist",
      selectRole: "Rol Seçin",
      reportFeedback: "Rapor Et",
      name: "İsim: ",
      reportType: "Rapor Türünü Seçin: ",
      errorBug: "Hata/Bug",
      misbehaviourAbuse: "Kötü Davranış/Suistimal",
      issueDescription: "Sorun Açıklaması: ",
      trackPatients: "Hastaları Takip Et",
      physioProfile: "Fizyoterapist Profili",
      allocation: "Size atandı: ",
      patients: " hasta",
      youHave: "Sahipsiniz: ",
      consultationsMonth: " bu ayki danışma",
      slotsAvailable: " uygun kontenjan",
      patientsTrack: "Hasta Raporları",
      change: "Değiştir",
      remove: "Kaldır",
      addSlots: "Kontenjan Ekle",
      removeSlots: "Kontenjan Kaldır",
      welcomeDr: "Merhaba Dr. {{name}}!",
      enterSpeciality: "Uzmanlık alanını girin",
      yearsOfExperience: "Deneyim Yılı: ",
      enterYearsOfExperience: "Deneyim yılını girin...",
      neurologicalDisorder: "Nörolojik Bozukluk",
      geriatrics: "Geriatrik",
      cardiovascularPulmonaryPhysiotherapy: "Kardiyovasküler ve Pulmoner Fizyoterapi",
      pediatricPhysiotherapy: "Pediatrik Fizyoterapi",
      musculoskeletalPhysiotherapy: "Kas-iskelet Fizyoterapisi",
      sportsPhysiotherapy: "Spor Fizyoterapisi",
      cardiovascularDisease: "Kardiyovasküler Hastalık",
      orthopedics: "Ortopedi",
      vestibularRehabilitation: "Vestibüler Rehabilitasyon",
      homecarePhysiotherapy: "Evde Fizyoterapi",
      pediatrics: "Pediatri",
      pelvicFloor: "Pelvik Taban",
      womensHealthPhysiotherapy: "Kadın Sağlığı Fizyoterapisi",
      acupuncture: "Akupunktur",
      magneticTherapy: "Manyetik Terapi",
      manualTherapy: "Manuel Terapi",
      oncology: "Onkoloji",
      postOperativePhysiotherapist: "Ameliyat Sonrası Fizyoterapist",
      rehabilitation: "Rehabilitasyon",
      chestPhysiotherapy: "Göğüs Fizyoterapisi",
      womensHealth: "Kadın Sağlığı",
      pleaseAnswerAllQuestions: "Lütfen tüm soruları yanıtlayın",
      physioTrackProgress: "Hasta Raporları",
      noReportsFound: "Rapor bulunamadı",
      question1: "Haftalık İyileşme",
      question2: "Video Memnuniyeti",
      specificFeedback: "Açık Geri Bildirim",
      submittedAt: "Gönderildi",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  uk: { //Ukrainian
    translation: {
      welcome: "Привіт, {{name}}!",
      today: "Сьогодні {{date}}.",
      trackingCompleted: "Молодець! Ви завершили план відстеження цього тижня.",
      trackingNotCompleted: "Ви не завершили план відстеження цього тижня.",
      faqs: "Часто задавані питання",
      home: "Головна",
      trackProgress: "Відстежуйте прогрес",
      progressTrack: "Відстеження прогресу",
      completeTracking: "Чи завершено тижневий план відстеження?",
      giveFeedback: "Залишити відгук?",
      weekFeedback: "Відгук на тижневий план вправ",
      qOne: "1. За шкалою від 0 до 5, наскільки ви покращилися порівняно з минулим тижнем?",
      qTwo: "2. За шкалою від 0 до 5, наскільки ефективними були надані відео?",
      qThree: "3. Чи є якісь конкретні відгуки?",
      cancel: "Скасувати",
      submit: "Відправити",
      consultations: "Консультації",
      speciality: "Спеціальність: ",
      location: "Локація: ",
      consultationTag: "Заплануйте особисту консультацію з фізіотерапії.",
      selectDateTime: "Виберіть дату та час: ",
      schedule: "Запланувати",
      scheduleWith: "Заплануйте консультацію з ",
      videoLibrary: "Відеотека",
      selectCategory: "Виберіть категорію для перегляду відео:",
      resistance: "Вправи з опором",
      stretching: "Вправи на розтягування",
      strengthening: "Вправи на укріплення",
      functional: "Функціональні вправи",
      balanceNeuromuscular: "Вправи на баланс та нейром'язову координацію",
      backCategories: "Повернутися до категорій",
      watchVideo: "Переглянути відео",
      watched: "Переглянуто",
      gFeedback: "Залишити відгук",
      rate: "Оцініть: ",
      selectRating: "Виберіть оцінку: ",
      submitRating: "Надіслати оцінку",
      noVideos: "Відео для цієї категорії недоступні.",
      userProfile: "Профіль користувача",
      editProfile: "Редагувати профіль",
      profilePicture: "Фото профілю: ",
      noFileChosen: "Файл не вибрано",
      chooseFile: "Виберіть файл",
      firstName: "Ім'я: ",
      lastName: "Прізвище: ",
      email: "Електронна пошта: ",
      sex: "Стать: ",
      selectSex: "Виберіть стать",
      male: "Чоловіча",
      female: "Жіноча",
      dob: "Дата народження: ",
      height: "Зріст (cm): ",
      weight: "Вага (kg): ",
      firstNameRequired: "Ім'я є обов'язковим",
      lastNameRequired: "Прізвище є обов'язковим",
      emailRequired: "Електронна пошта є обов'язковою",
      sexRequired: "Стать є обов'язковою",
      dobRequired: "Дата народження є обов'язковою",
      dobCorrect: "Будь ласка, введіть правильну дату народження",
      heightRequired: "Зріст є обов'язковим",
      heightCorrect: "Будь ласка, введіть правильний зріст",
      weightRequired: "Вага є обов'язковою",
      weightCorrect: "Будь ласка, введіть правильну вагу",
      saveProfile: "Зберегти профіль",
      profileSaved: "Профіль збережено!",
      noImage: "Немає зображення",
      settings: "Налаштування",
      darkMode: "Темний режим",
      language: "Мова",
      notificationPreference: "Налаштування сповіщень",
      lightMode: "Світлий режим",
      emaiL: "Електронна пошта",
      phone: "Номер телефону",
      both: "Обидва",
      login: "Увійти",
      register: "Реєстрація",
      firstname: "Ім'я",
      lastname: "Прізвище",
      password: "Пароль: ",
      invalidCredentials: "Невірний email або пароль",
      fillAllFields: "Будь ласка, заповніть усі поля",
      dontHaveAccount: "Немає акаунту? ",
      alreadyHaveAccount: "Вже є акаунт? ",
      registerHere: "Зареєструйтеся тут",
      loginHere: "Увійдіть тут",
      messages: "Чат",
      directMessages: "Прямі повідомлення",
      typeYourMessage: "Введіть ваше повідомлення...",
      you: "Ви",
      send: "Надіслати",
      patient: "Пацієнт",
      physio: "Фізіотерапевт",
      selectRole: "Виберіть роль",
      reportFeedback: "Повідомити",
      name: "Ім'я: ",
      reportType: "Виберіть тип звіту: ",
      errorBug: "Помилка/Баг",
      misbehaviourAbuse: "Неприйнятна поведінка/Зловживання",
      issueDescription: "Опис проблеми: ",
      trackPatients: "Відстежувати пацієнтів",
      physioProfile: "Профіль фізіотерапевта",
      allocation: "Вам призначено ",
      patients: " пацієнтів.",
      youHave: "У вас є ",
      consultationsMonth: " консультації цього місяця.",
      slotsAvailable: " доступних місць.",
      patientsTrack: "Звіти пацієнтів",
      change: "Змінити",
      remove: "Видалити",
      addSlots: "Додати місця",
      removeSlots: "Видалити місця",
      welcomeDr: "Привіт, д-р {{name}}!",
      enterSpeciality: "Введіть спеціальність",
      yearsOfExperience: "Роки досвіду: ",
      enterYearsOfExperience: "Введіть роки досвіду...",
      neurologicalDisorder: "Неврологічний розлад",
      geriatrics: "Геріатрія",
      cardiovascularPulmonaryPhysiotherapy: "Кардіоваскулярна та легенева фізіотерапія",
      pediatricPhysiotherapy: "Педіатрична фізіотерапія",
      musculoskeletalPhysiotherapy: "М'язово-скелетна фізіотерапія",
      sportsPhysiotherapy: "Спортивна фізіотерапія",
      cardiovascularDisease: "Серцево-судинне захворювання",
      orthopedics: "Ортопедія",
      vestibularRehabilitation: "Вестибулярна реабілітація",
      homecarePhysiotherapy: "Домашня фізіотерапія",
      pediatrics: "Педіатрія",
      pelvicFloor: "М'язи тазу",
      womensHealthPhysiotherapy: "Фізіотерапія жіночого здоров’я",
      acupuncture: "Акупунктура",
      magneticTherapy: "Магнітотерапія",
      manualTherapy: "Мануальна терапія",
      oncology: "Онкологія",
      postOperativePhysiotherapist: "Фізіотерапевт після операції",
      rehabilitation: "Реабілітація",
      chestPhysiotherapy: "Фізіотерапія грудей",
      womensHealth: "Жіноче здоров’я",
      pleaseAnswerAllQuestions: "Будь ласка, відповідайте на всі запитання",
      physioTrackProgress: "Звіти пацієнтів",
      noReportsFound: "Звітів не знайдено",
      question1: "Тижневе покращення",
      question2: "Задоволеність відео",
      specificFeedback: "Відкритий відгук",
      submittedAt: "Надіслано",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  ur: { //Urdu
    translation: {
      welcome: "ہیلو {{name}}",
      today: "آج {{date}} ہے۔",
      trackingCompleted: "شاباش! آپ نے اس ہفتے کا ٹریکنگ پلان مکمل کر لیا ہے۔",
      trackingNotCompleted: "آپ نے اس ہفتے کا ٹریکنگ پلان مکمل نہیں کیا۔",
      faqs: "عمومی سوالات",
      home: "ہوم",
      trackProgress: "پروگریس ٹریک کریں",
      progressTrack: "پروگریس ٹریکنگ",
      completeTracking: "کیا آپ نے ہفتہ وار ٹریکنگ پلان مکمل کر لیا ہے؟",
      giveFeedback: "کیا آپ رائے دینا چاہیں گے؟",
      weekFeedback: "ہفتہ وار ایکسرسائز پلان کا فیڈ بیک",
      qOne: "0 سے 5 کے پیمانے پر، پچھلے ہفتے کے مقابلے میں آپ نے کتنا بہتری دکھائی؟",
      qTwo: "0 سے 5 کے پیمانے پر، فراہم کردہ ویڈیوز کتنی مؤثر تھیں؟",
      qThree: "کوئی خاص رائے؟",
      cancel: "منسوخ کریں",
      submit: "جمع کرائیں",
      consultations: "مشاورت",
      speciality: "تخصص",
      location: "مقام",
      consultationTag: "اپنی ذاتی فزیوتھراپی مشاورت کا شیڈول بنائیں۔",
      selectDateTime: "تاریخ اور وقت منتخب کریں",
      schedule: "شیڈول کریں",
      scheduleWith: "کے ساتھ مشاورت کا شیڈول بنائیں",
      videoLibrary: "ویڈیو لائبریری",
      selectCategory: "ویڈیوز دیکھنے کے لیے ایک زمرہ منتخب کریں",
      resistance: "مزاحمتی ورزشیں",
      stretching: "اسٹریچنگ ورزشیں",
      strengthening: "طاقت بڑھانے والی ورزشیں",
      functional: "فعال ورزشیں",
      balanceNeuromuscular: "توازن اور نیورومسکولر ورزشیں",
      backCategories: "اقسام پر واپس جائیں",
      watchVideo: "ویڈیو دیکھیں",
      watched: "دیکھ لیا گیا",
      gFeedback: "رائے دیں",
      rate: "ریٹ: ",
      selectRating: "ریٹنگ منتخب کریں",
      submitRating: "ریٹنگ جمع کرائیں",
      noVideos: "اس زمرے کے لیے کوئی ویڈیو دستیاب نہیں۔",
      userProfile: "یوزر پروفائل",
      editProfile: "پروفائل ترمیم کریں",
      profilePicture: "پروفائل تصویر",
      noFileChosen: "کوئی فائل منتخب نہیں ہوئی",
      chooseFile: "فائل منتخب کریں",
      firstName: "پہلا نام",
      lastName: "آخری نام",
      email: "ای میل",
      sex: "جنس",
      selectSex: "جنس منتخب کریں",
      male: "مرد",
      female: "عورت",
      dob: "تاریخ پیدائش",
      height: "قد (سنٹی میٹر)",
      weight: "وزن (کلو)",
      firstNameRequired: "پہلا نام درکار ہے",
      lastNameRequired: "آخری نام درکار ہے",
      emailRequired: "ای میل درکار ہے",
      sexRequired: "جنس درکار ہے",
      dobRequired: "تاریخ پیدائش درکار ہے",
      dobCorrect: "براہ کرم درست تاریخ پیدائش درج کریں",
      heightRequired: "قد درکار ہے",
      heightCorrect: "براہ کرم درست قد درج کریں",
      weightRequired: "وزن درکار ہے",
      weightCorrect: "براہ کرم درست وزن درج کریں",
      saveProfile: "پروفائل محفوظ کریں",
      profileSaved: "پروفائل محفوظ ہوگیا!",
      noImage: "کوئی تصویر نہیں",
      settings: "سیٹنگز",
      darkMode: "ڈارک موڈ",
      language: "زبان",
      notificationPreference: "اطلاع کی ترجیح",
      lightMode: "ہلکا موڈ",
      emaiL: "ای میل",
      phone: "فون نمبر",
      both: "دونوں",
      login: "لاگ ان",
      register: "رجسٹر کریں",
      firstname: "پہلا نام",
      lastname: "آخری نام",
      password: "پاس ورڈ: ",
      invalidCredentials: "غلط ای میل یا پاس ورڈ",
      fillAllFields: "براہ مہربانی تمام فیلڈز پُر کریں",
      dontHaveAccount: "آپ کا اکاؤنٹ نہیں ہے؟ ",
      alreadyHaveAccount: "آپ کا اکاؤنٹ پہلے سے موجود ہے؟ ",
      registerHere: "یہاں رجسٹر کریں",
      loginHere: "یہاں لاگ ان کریں",
      messages: "چیٹ",
      directMessages: "براہ راست پیغامات",
      typeYourMessage: "اپنا پیغام ٹائپ کریں...",
      you: "آپ",
      send: "بھیجیں",
      patient: "مریض",
      physio: "فزیوتھراپسٹ",
      selectRole: "کردار منتخب کریں",
      reportFeedback: "رپورٹ کریں",
      name: "نام: ",
      reportType: "رپورٹ کی قسم منتخب کریں: ",
      errorBug: "بگ/غلطی",
      misbehaviourAbuse: "غلط رویہ/استحصال",
      issueDescription: "مسئلہ کی تفصیل: ",
      trackPatients: "مریضوں کا ٹریک رکھیں",
      physioProfile: "فزیوتھراپسٹ پروفائل",
      allocation: "آپ کو تفویض کیا گیا ہے ",
      patients: " مریض",
      youHave: "آپ کے پاس ہیں ",
      consultationsMonth: " اس ماہ کی مشاورتیں",
      slotsAvailable: " دستیاب سلاٹس",
      patientsTrack: "مریض رپورٹس",
      change: "تبدیل کریں",
      remove: "ہٹائیں",
      addSlots: "سلاٹس شامل کریں",
      removeSlots: "سلاٹس ہٹائیں",
      welcomeDr: "ہیلو ڈاکٹر {{name}}!",
      enterSpeciality: "خصوصیت درج کریں",
      yearsOfExperience: "تجربے کے سال: ",
      enterYearsOfExperience: "تجربے کے سال درج کریں...",
      neurologicalDisorder: "اعصابی خرابی",
      geriatrics: "جرائٹرکس",
      cardiovascularPulmonaryPhysiotherapy: "دل اور پھیپھڑوں کی فزیوتھراپی",
      pediatricPhysiotherapy: "بچوں کی فزیوتھراپی",
      musculoskeletalPhysiotherapy: "عضلاتی اور ہڈیوں کی فزیوتھراپی",
      sportsPhysiotherapy: "کھیلوں کی فزیوتھراپی",
      cardiovascularDisease: "دل کی بیماری",
      orthopedics: "آرتھوپیڈکس",
      vestibularRehabilitation: "وزٹیبیولر بحالی",
      homecarePhysiotherapy: "گھر پر فزیوتھراپی",
      pediatrics: "بچوں کی دوا",
      pelvicFloor: "پیلوک فلور",
      womensHealthPhysiotherapy: "خواتین کی صحت کی فزیوتھراپی",
      acupuncture: "اکیوپنکچر",
      magneticTherapy: "مقناطیسی تھراپی",
      manualTherapy: "دستی تھراپی",
      oncology: "آنکولوجی",
      postOperativePhysiotherapist: "آپریشن کے بعد فزیوتھراپسٹ",
      rehabilitation: "بحالی",
      chestPhysiotherapy: "چھاتی کی فزیوتھراپی",
      womensHealth: "خواتین کی صحت",
      pleaseAnswerAllQuestions: "براہ مہربانی تمام سوالات کے جوابات دیں",
      physioTrackProgress: "مریض رپورٹس",
      noReportsFound: "کوئی رپورٹ نہیں ملی",
      question1: "ہفتہ وار بہتری",
      question2: "ویڈیو تسلی",
      specificFeedback: "کھلا فیڈ بیک",
      submittedAt: "جمع کرایا گیا",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  vi: { //Vietnamese
    translation: {
      welcome: "Chào {{name}}!",
      today: "Hôm nay là {{date}}.",
      trackingCompleted: "Tuyệt vời! Bạn đã hoàn thành kế hoạch theo dõi của tuần này.",
      trackingNotCompleted: "Bạn chưa hoàn thành kế hoạch theo dõi của tuần này.",
      faqs: "Các câu hỏi thường gặp",
      home: "Trang chủ",
      trackProgress: "Theo dõi Tiến độ",
      progressTrack: "Theo dõi Tiến độ",
      completeTracking: "Kế hoạch theo dõi hàng tuần đã hoàn thành?",
      giveFeedback: "Có muốn đưa ra phản hồi không?",
      weekFeedback: "Phản hồi về Kế hoạch Tập luyện hàng tuần",
      qOne: "1. Trên thang điểm từ 0 đến 5, bạn đã cải thiện được bao nhiêu so với tuần trước?",
      qTwo: "2. Trên thang điểm từ 0 đến 5, video được cung cấp có hiệu quả như thế nào?",
      qThree: "3. Có phản hồi cụ thể nào không?",
      cancel: "Hủy",
      submit: "Gửi",
      consultations: "Tư vấn",
      speciality: "Chuyên môn: ",
      location: "Địa điểm: ",
      consultationTag: "Hãy đặt lịch tư vấn vật lý trị liệu trực tiếp của bạn.",
      selectDateTime: "Chọn Ngày và Giờ: ",
      schedule: "Đặt Lịch",
      scheduleWith: "Đặt lịch tư vấn với ",
      videoLibrary: "Thư viện Video",
      selectCategory: "Chọn một danh mục để xem video:",
      resistance: "Bài tập Kháng Lực",
      stretching: "Bài tập Duỗi",
      strengthening: "Bài tập Tăng Cường",
      functional: "Bài tập Chức Năng",
      balanceNeuromuscular: "Bài tập Cân Bằng & Neuromuscular",
      backCategories: "Quay lại Danh mục",
      watchVideo: "Xem Video",
      watched: "Đã xem",
      gFeedback: "Đưa ra Phản hồi",
      rate: "Đánh giá: ",
      selectRating: "Chọn Đánh giá: ",
      submitRating: "Gửi Đánh giá",
      noVideos: "Không có video nào cho danh mục này.",
      userProfile: "Hồ sơ Người dùng",
      editProfile: "Chỉnh sửa Hồ sơ",
      profilePicture: "Ảnh Hồ sơ: ",
      noFileChosen: "Không có tệp nào được chọn",
      chooseFile: "Chọn tệp",
      firstName: "Tên: ",
      lastName: "Họ: ",
      email: "Email: ",
      sex: "Giới tính: ",
      selectSex: "Chọn Giới tính",
      male: "Nam",
      female: "Nữ",
      dob: "Ngày sinh: ",
      height: "Chiều cao (cm): ",
      weight: "Cân nặng (kg): ",
      firstNameRequired: "Bắt buộc phải có tên",
      lastNameRequired: "Bắt buộc phải có họ",
      emailRequired: "Bắt buộc phải có email",
      sexRequired: "Bắt buộc phải chọn giới tính",
      dobRequired: "Bắt buộc phải có ngày sinh",
      dobCorrect: "Vui lòng nhập ngày sinh chính xác",
      heightRequired: "Bắt buộc phải có chiều cao",
      heightCorrect: "Vui lòng nhập chiều cao chính xác",
      weightRequired: "Bắt buộc phải có cân nặng",
      weightCorrect: "Vui lòng nhập cân nặng chính xác",
      saveProfile: "Lưu Hồ sơ",
      profileSaved: "Hồ sơ đã được lưu!",
      noImage: "Không có hình ảnh",
      settings: "Cài đặt",
      darkMode: "Chế độ Tối",
      language: "Ngôn ngữ",
      notificationPreference: "Ưu tiên thông báo",
      lightMode: "Chế độ sáng",
      emaiL: "Email",
      phone: "Số điện thoại",
      both: "Cả hai",
      login: "Đăng nhập",
      register: "Đăng ký",
      firstname: "Tên",
      lastname: "Họ",
      password: "Mật khẩu: ",
      invalidCredentials: "Email hoặc mật khẩu không hợp lệ",
      fillAllFields: "Vui lòng điền đầy đủ các trường",
      dontHaveAccount: "Không có tài khoản? ",
      alreadyHaveAccount: "Đã có tài khoản? ",
      registerHere: "Đăng ký ở đây",
      loginHere: "Đăng nhập ở đây",
      messages: "Trò chuyện",
      directMessages: "Tin nhắn trực tiếp",
      typeYourMessage: "Nhập tin nhắn của bạn...",
      you: "Bạn",
      send: "Gửi",
      patient: "Bệnh nhân",
      physio: "Nhà vật lý trị liệu",
      selectRole: "Chọn vai trò",
      reportFeedback: "Báo cáo",
      name: "Tên: ",
      reportType: "Chọn loại báo cáo: ",
      errorBug: "Lỗi/Bug",
      misbehaviourAbuse: "Hành vi sai trái/Lạm dụng",
      issueDescription: "Mô tả vấn đề: ",
      trackPatients: "Theo dõi bệnh nhân",
      physioProfile: "Hồ sơ vật lý trị liệu",
      allocation: "Bạn được phân công cho ",
      patients: " bệnh nhân.",
      youHave: "Bạn có ",
      consultationsMonth: " cuộc tư vấn trong tháng này.",
      slotsAvailable: " vị trí còn trống.",
      patientsTrack: "Báo cáo bệnh nhân",
      change: "Thay đổi",
      remove: "Xóa",
      addSlots: "Thêm vị trí",
      removeSlots: "Xóa vị trí",
      welcomeDr: "Xin chào Dr. {{name}}!",
      enterSpeciality: "Nhập chuyên ngành",
      yearsOfExperience: "Số năm kinh nghiệm: ",
      enterYearsOfExperience: "Nhập số năm kinh nghiệm...",
      neurologicalDisorder: "Rối loạn thần kinh",
      geriatrics: "Lão khoa",
      cardiovascularPulmonaryPhysiotherapy: "Vật lý trị liệu tim mạch và phổi",
      pediatricPhysiotherapy: "Vật lý trị liệu nhi",
      musculoskeletalPhysiotherapy: "Vật lý trị liệu cơ xương khớp",
      sportsPhysiotherapy: "Vật lý trị liệu thể thao",
      cardiovascularDisease: "Bệnh tim mạch",
      orthopedics: "Chỉnh hình",
      vestibularRehabilitation: "Phục hồi chức năng tiền đình",
      homecarePhysiotherapy: "Vật lý trị liệu tại nhà",
      pediatrics: "Nhi khoa",
      pelvicFloor: "Sàn chậu",
      womensHealthPhysiotherapy: "Vật lý trị liệu sức khỏe phụ nữ",
      acupuncture: "Châm cứu",
      magneticTherapy: "Liệu pháp từ",
      manualTherapy: "Liệu pháp thủ công",
      oncology: "Ung thư học",
      postOperativePhysiotherapist: "Vật lý trị liệu sau mổ",
      rehabilitation: "Phục hồi chức năng",
      chestPhysiotherapy: "Vật lý trị liệu ngực",
      womensHealth: "Sức khỏe phụ nữ",
      pleaseAnswerAllQuestions: "Vui lòng trả lời tất cả các câu hỏi",
      physioTrackProgress: "Báo cáo bệnh nhân",
      noReportsFound: "Không tìm thấy báo cáo",
      question1: "Cải thiện hàng tuần",
      question2: "Sự hài lòng với video",
      specificFeedback: "Phản hồi mở",
      submittedAt: "Đã gửi vào",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  },
  zh: { //Mandarin Standard Chinese
    translation: {
      welcome: "你好，{{name}}！",
      today: "今天是{{date}}。",
      trackingCompleted: "做得好！你已完成本周的跟踪计划。",
      trackingNotCompleted: "你还没有完成本周的跟踪计划。",
      faqs: "常见问题",
      home: "主页",
      trackProgress: "跟踪进度",
      progressTrack: "进度跟踪",
      completeTracking: "你完成了每周的跟踪计划吗？",
      giveFeedback: "要提供反馈吗？",
      weekFeedback: "每周锻炼计划反馈",
      qOne: "1. 在0到5的范围内，与上周相比，你提高了多少？",
      qTwo: "2. 在0到5的范围内，所提供的视频有多有效？",
      qThree: "3. 有什么具体反馈吗？",
      cancel: "取消",
      submit: "提交",
      consultations: "咨询",
      speciality: "专业：",
      location: "地点：",
      consultationTag: "预约您的面对面物理治疗咨询。",
      selectDateTime: "选择日期和时间：",
      schedule: "安排",
      scheduleWith: "预约与...的咨询：",
      videoLibrary: "视频库",
      selectCategory: "选择一个类别以查看视频：",
      resistance: "阻力训练",
      stretching: "拉伸运动",
      strengthening: "力量训练",
      functional: "功能性训练",
      balanceNeuromuscular: "平衡与神经肌肉训练",
      backCategories: "返回类别",
      watchVideo: "观看视频",
      watched: "已观看",
      gFeedback: "提供反馈",
      rate: "评分：",
      selectRating: "选择评分：",
      submitRating: "提交评分",
      noVideos: "此类别暂无视频。",
      userProfile: "用户资料",
      editProfile: "编辑资料",
      profilePicture: "头像: ",
      noFileChosen: "未选择文件",
      chooseFile: "选择文件",
      firstName: "名字: ",
      lastName: "姓氏: ",
      email: "电子邮件: ",
      sex: "性别：",
      selectSex: "选择性别",
      male: "男",
      female: "女",
      dob: "出生日期：",
      height: "身高（厘米): ",
      weight: "体重（公斤)：",
      firstNameRequired: "名字为必填项",
      lastNameRequired: "姓氏为必填项",
      emailRequired: "电子邮件为必填项",
      sexRequired: "性别为必填项",
      dobRequired: "出生日期为必填项",
      dobCorrect: "请输入正确的出生日期",
      heightRequired: "身高为必填项",
      heightCorrect: "请输入正确的身高",
      weightRequired: "体重为必填项",
      weightCorrect: "请输入正确的体重",
      saveProfile: "保存资料",
      profileSaved: "资料已保存！",
      noImage: "无图片",
      settings: "设置",
      darkMode: "深色模式",
      language: "语言",
      notificationPreference: "通知偏好",
      lightMode: "浅色模式",
      emaiL: "电子邮件",
      phone: "电话号码",
      both: "两者",
      login: "登录",
      register: "注册",
      firstname: "名字",
      lastname: "姓氏",
      password: "密码: ",
      invalidCredentials: "电子邮件或密码无效",
      fillAllFields: "请填写所有字段",
      dontHaveAccount: "没有账号？ ",
      alreadyHaveAccount: "已有账号？ ",
      registerHere: "在此注册",
      loginHere: "在此登录",
      messages: "聊天",
      directMessages: "直接消息",
      typeYourMessage: "请输入您的消息...",
      you: "您",
      send: "发送",
      patient: "病人",
      physio: "物理治疗师",
      selectRole: "选择角色",
      reportFeedback: "报告",
      name: "姓名: ",
      reportType: "选择报告类型: ",
      errorBug: "错误/故障",
      misbehaviourAbuse: "不当行为/滥用",
      issueDescription: "问题描述: ",
      trackPatients: "跟踪病人",
      physioProfile: "物理治疗师档案",
      allocation: "您被分配到 ",
      patients: " 位病人",
      youHave: "您有 ",
      consultationsMonth: " 本月咨询",
      slotsAvailable: " 个空位",
      patientsTrack: "病人报告",
      change: "更改",
      remove: "移除",
      addSlots: "添加空位",
      removeSlots: "移除空位",
      welcomeDr: "您好，Dr. {{name}}!",
      enterSpeciality: "输入专业",
      yearsOfExperience: "经验年数: ",
      enterYearsOfExperience: "请输入经验年数...",
      neurologicalDisorder: "神经障碍",
      geriatrics: "老年医学",
      cardiovascularPulmonaryPhysiotherapy: "心血管及肺部物理治疗",
      pediatricPhysiotherapy: "儿童物理治疗",
      musculoskeletalPhysiotherapy: "肌骨物理治疗",
      sportsPhysiotherapy: "运动物理治疗",
      cardiovascularDisease: "心血管疾病",
      orthopedics: "整形外科",
      vestibularRehabilitation: "前庭康复",
      homecarePhysiotherapy: "家庭物理治疗",
      pediatrics: "儿科",
      pelvicFloor: "盆底",
      womensHealthPhysiotherapy: "女性健康物理治疗",
      acupuncture: "针灸",
      magneticTherapy: "磁疗",
      manualTherapy: "手动治疗",
      oncology: "肿瘤学",
      postOperativePhysiotherapist: "术后物理治疗师",
      rehabilitation: "康复",
      chestPhysiotherapy: "胸部物理治疗",
      womensHealth: "女性健康",
      pleaseAnswerAllQuestions: "请回答所有问题",
      physioTrackProgress: "病人报告",
      noReportsFound: "未找到报告",
      question1: "每周改善",
      question2: "视频满意度",
      specificFeedback: "开放反馈",
      submittedAt: "提交于",
      logout: "Log Out",
      phoneNumber: "Phone Number: ",
    }
  }
};

i18n
  .use(initReactI18next) //Passes i18n instance to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', //Use language from local storage or default to English
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false //React already escapes values
    }
  });

export default i18n;